import { useState, useEffect, useContext, useRef, useCallback } from "react";
import {
  APIs,
  API_BASE_URL,
  REPORT_TITLE,
  TOAST_TYPE,
  REPORTDONESTATUS,
  VDCLIMS,
  MODAL_TYPE,
  REPORT_SUBMIT_SOURCE,
  SHARED_SERVICEURL,
  DICOM_ACCEPTOR_BASE_URL,
  NonAuthRoutes,
  TAB_NAME,
} from "../../constants/Constants";
import { StringLiterals } from "../../constants/StringLiterals";
import { useTranslation } from "react-i18next";
import { USERTYPES } from "../../constants/Constants";
import { useParams, useSearchParams } from "react-router-dom";
import Moment from "moment";
import {
  assignStudy,
  downloadAIReportAPI,
  downloadFistolugramImage,
  downloadPdfReport,
  generateCTBrainReportCall,
  generateMRISpineReportCall,
  generateRSNADynamicReport,
  getPatientReportData,
  getQCProvidersList,
  getReportTemplatesData,
  getS10ReportData,
  getStorageKeyFistolugram,
  getStudyReportData,
  getWordSession,
  loadStudyReportPdf,
  markAsSuspect,
  previewPdfReport,
  previewPdfReportVersion,
  previewPdfWithKeyImageReport,
  regenerateLLMReport,
  saveReportTemplatesData,
  submitQC,
  submitReportTemplatesData,
  toggleStudyReportPdfAttachment,
  uploadFistolugramService,
  deleteFistolugramService,
  getStorageKeyFibroid,
  uploadFibroidService,
  deleteFibroidService,
  autosaveReportData,
  getReportSnapshotCheck,
  discardReportSnapshot,
  loadExternalFirmSubmittedReportPdf,
} from "../../service/StudyReportService";
import { userPreference } from "../../service/UserService";
import StudyReportContext from "../studyreport/StudyReportContext";
import studyviewerContext from "../studyviewer/StudyviewerContext";
import ViewportContext from "../studyviewer/ViewportContext";
import userContext from "../users/UserContext";
// ViewportContext and studyviewerContext dependencies removed —
// maskImages, studyClinicalNotesData, isNormalStudy are now internal state.
// The viewer syncs data into StudyReportState via exposed setters.
import { generateRSNAReport } from "../../pages/Report/helper/RSNAUtilities";
import {
  annotation_state,
  init_pathology_state,
} from "../../pages/Annotations/helper/initialData";
import { ReleaseStudyApi, ReleasePreliminaryStudyApi, ReturnStudyApi, getScDicomLibrary, updateAdvKeyImagesAPI, getStudyCapturedPages, getStudyCapturedPagesByReport, getStudyKeyImageTitleFlag, updateStudyCapturedPages } from "../../service/StudyViewerService";
import { savingBoundingBoxJsonData } from "../../pages/StudyViewer/helpers/BoundingBoxUtilities";
import { getViewport } from "../../pages/StudyViewer/helpers/CornerstoneViewportService";
import { logAmplitudeEventWithUsernameAndRole } from "../../helpers/Amplitude";
import loaderContext from "../loader/LoaderContext";
import toastContext from "../toast/ToastContext";
import { isMobile } from "react-device-detect";
import { keyImagesPresent } from "../../pages/StudyViewer/helpers/KeyImageUtility";
import { assignMeSupervisor } from "../../service/StudyListService";
import themeContext from "../theme/ThemeContext";
import ModalHeader from "../../components/Modal/ModalHeader";
import ModalFooter from "../../components/Modal/ModalFooter";
import studylistContext from "../studylist/StudylistContext";
import { generateRandomString, slateJsonToPlainText, getRadiologistDisplayName } from "../../helpers/CommonUtility";
import { loadAndCacheImage } from "@cornerstonejs/core/loaders/imageLoader";
import { isLLMAgentPresent, loadDicomAndDrawRectangle, removeMaskImageAnnotation } from "../../service/MaskImageService";
import { getLLMAgentList, getStylesList } from "../../service/MasterService";
import PlatformHelper from "../../helpers/PlatformHelper";
import ConfirmAlertModal from "../../components/ConfirmAlertModal/ConfirmAlertModal";
import ConfirmModal from "../../components/Modal/ConfirmModal";
import { use } from "react";
import moment from "moment-timezone";
import DOMPurify from "dompurify";
import { getEnv } from '../../helpers/EnvHelper';

const StudyReportState = (props) => {
  const {
    roles,
    username,
    userId,
    qcReviewer,
    enableLlmReport,
    privilegedFirmDoctor,
    disableSubmitforResident,
    typistAllowSubmit
  } = useContext(userContext);

  const { themeName } = useContext(themeContext);

  const ENTITY_TO_TEXT = {
  // frequently used named entities (radiology-focused)
  amp: " and ",           // &amp;
  // nbsp: "",              // &nbsp;
  ndash: "-",             // &ndash;
  mdash: "-",           // &mdash;
  lsquo: "'", rsquo: "'", // &lsquo; &rsquo;
  quot: '"',              // &quot;
  ldquo: '"', rdquo: '"',
  hellip: "...",          // &hellip;
  plusmn: "+/-",          // &plusmn;
  times: "x",             // &times;
  divide: "/",            // &divide;
  deg: " deg",            // &deg; -> " deg"
  mu: "µ",                // &mu; -> "u" (ug/mL)
  le: " less than equal to ", ge: " greater than equal to ",     // &le;, &ge;
  minus: "-",             // &minus;
  bull: "-",              // &bull;
  frac12: "1/2", frac14: "1/4", frac34: "3/4",
  sup2: "^2", sup3: "^3", // superscripts
  prime: "'", primes: '"',// &prime; &Prime;
  rarr: "->", larr: "<-", // &rarr; &larr;
  trade: "(TM)", reg: "(R)", copy: "(C)", // &trade;, &reg;, &copy;
  // Some additional names encountered in HTML:
  ensp: " ", emsp: " ",
  shy: "",                // soft hyphen - remove
  zwj: "", zwnj: "",      // zero-width joiner/non-joiner
  lt: " less than ",    // less than
  gt: " greater than ", // greater than
  ne: " not equal to ", // not equal to
  // Add more named entities as you find them...
};

/**
 * Also map direct Unicode characters (actual chars) to replacements.
 * These are applied both for decoded numeric entities and for raw characters in the text.
 */
const CHAR_TO_TEXT = {
  // "\u00A0": " ",          // non-breaking space
  "\u2013": "-",          // en dash
  "\u2014": " - ",        // em dash
  "\u2018": "'", "\u2019": "'", // single quotes
  "\u201C": '"', "\u201D": '"', // double quotes
  "\u2026": "...",        // ellipsis
  "\u00B1": "+/-",        // plus/minus
  "\u00D7": "x",          // multiplication sign
  "\u00F7": "/",          // division sign
  "\u00B0": " deg",       // degree
  "\u00B5": "u",          // µ (micro sign)
  "\u03BC": "u",         // μ (Greek mu)
  "\u2264": " less than equal to ", "\u2265": " greater than equal to ", // ≤ ≥
  "\u2212": "-",          // minus sign
  "\u2022": "-",          // bullet
  "\u00BD": "1/2", "\u00BC": "1/4", "\u00BE": "3/4",
  "\u00B2": "^2", "\u00B3": "^3",
  "\u2032": "'", "\u2033": '"', // prime marks
  "\u2192": "->", "\u2190": "<-",
  "\u00AE": "(R)", "\u2122": "(TM)", "\u00A9": "(C)",
  "\u200B": "",           // zero width space
  // control characters will be stripped later
};

/**
 * Build convenience maps
 */
const namedMap = new Map(Object.entries(ENTITY_TO_TEXT));
const charMap = new Map(Object.entries(CHAR_TO_TEXT));

/**
 * Regex for finding entities in text:
 * - named entities: &name;
 * - numeric decimal: &#1234;
 * - numeric hex: &#x1F4A9;
 */
const ENTITY_REGEX = /&(#x?[0-9A-Fa-f]+|[A-Za-z]+);/g;



  // Self-contained report state — no dependency on studyviewerContext.
  // When inside the viewer, use the exposed setters to sync viewer data.
  const [maskImages, setMaskImages] = useState({});
  const [studyClinicalNotesData, setStudyClinicalNotesData] = useState("");
  const [isNormalStudy, setIsNormalStudy] = useState(false);
  // Get studyClinicalNotesData from studyviewerContext if available
  const showSavedReport = useContext(studyviewerContext);
  const studyViewerData = useContext(studyviewerContext);
  
  
  const viewerContextData = useContext(ViewportContext);
  const disableMasking = viewerContextData?.disableMasking ?? (()=>{});
  // Values previously destructured from studyviewerContext; derive from the full context value.
  const reportMenu = studyViewerData?.reportMenu;
  
  useEffect(() => {
    if (studyViewerData && studyViewerData.studyClinicalNotesData) {
      setStudyClinicalNotesData(studyViewerData.studyClinicalNotesData);
    }
  }, [studyViewerData?.studyClinicalNotesData]);
  //const {
  // assignmentData,
  // keyImages,
  // studyParentId,
  //setAlertSuccessModal,
  //alertSuccessModal,
  //confirmAlertModal, setConfirmAlertModal,
  //qcData,
  //showToast, setShowToast,
  //} = useContext(studyviewerContext);

  const agenticInterfaceRef = useRef(null);
  const { ref, setLoaderRunning, setShowModal, showModal } =
    useContext(loaderContext);
  const { showToastv2 } = useContext(toastContext);


  const [studyId, setStudyId] = useState(null);
  const [t] = useTranslation();
  // const [patientId, setPatientId] = useState(440);
  const { patientID } = useParams();
  const [studyData, setStudyData] = useState();
  const [studyPatientSex, setStudyPatientSex] = useState(null);
  const [model, setModel] = useState("");

  const [addendumModel, setAddendumModel] = useState("");
  const [patientReports, setPatientReports] = useState([]);
  const [oldPatientReports, setOldPatientReports] = useState([]);
  const [hasAgenticReport, setHasAgenticReport] = useState(false);

  const [childModel, setChildModel] = useState("");
  const [childPatientReports, setChildPatientReports] = useState([]);
  const [childCurrentActiveTab, setChildCurrentActiveTab] = useState("");
  const [sanitizeReportContentForHL7, setSanitizeReportContentForHL7] = useState(false);
  const [useOldReportTemplate, setUseOldReportTemplate] = useState(false);

  // const [showToast, setShowToast] = useState({
  //   show: false,
  //   message: "",
  //   loading: false,
  //   state: "success",
  // });
  const [currentActiveTab, setCurrentActiveTab] = useState("");
  const [userRole, setUserRole] = useState(null);
  const [modality, setModality] = useState("");
  const [studyDescription, setStudyDescription] = useState("");
  const [showAlert, setShowAlert] = useState(true);
  const [hideDialog, setToggleHideDialog] = useState(true);
  const [stopEffect, setStopEffect] = useState(false);
  const [isDraggable, setToggleIsDraggable] = useState(false);
  const [enableReportRegenerate, setEnableReportRegenerate] = useState(false);
  const [selectedCategoryTemplate, setSelectedCategoryTemplate] = useState(
    "deeptekReportTemplage"
  );
  const [suggestedListReport, setSuggestedListReport] = useState([]);
  const [firstReportAdded, setFirstReportAdded] = useState(false);
  const [allReportTemplates, setAllReportTemplates] = useState({});
  const [clientFirmList, setClientFirmList] = useState([]);
  const [allReportTemplatesLoading, setAllReportTemplateLoading] = useState(false);
  const [raiseAlertList, setRaiseAlertList] = useState([]);
  const [raiseAlertValue, setRaiseAlertValue] = useState();
  const [dropdownSelectedTemplates, setDropdownSelectedTemplates] = useState(
    []
  );
  const [dropdownSelectedTemplatesStore, setDropdownSelectedTemplatesStore] =
    useState([]);
  const [annotationsJson, setAnnotationsJson] = useState("");
  const [studyOptionJson, setStudyOptionJson] = useState("");
  const [reset, setReset] = useState(false);
  const [userActionLoading, setUserActionLoading] = useState(true);
  const [downloadedStudyIds, setDownloadedStudyIds] = useState([]);
  const [capturedPages, setCapturedPages] = useState([]);
  const [selectedCapturedPageId, setSelectedCapturedPageId] = useState(null);
  // When true, captured-image (key image) titles are shown in the Images modal preview and
  // rendered into the downloaded report. Persisted per-study; defaults to true.
  const [showKeyImageTitle, setShowKeyImageTitle] = useState(true);
  // When true (default), captured images are appended once at the very end of the report and the
  // Images modal shows a single end-of-report bucket. When false, captured pages are distributed
  // across the individual reports (interleaved after each report's body). Persisted per-study.
  const [appendCapturedImagesAtEnd, setAppendCapturedImagesAtEnd] = useState(true);
  const [scDicomLibrary, setScDicomLibrary] = useState([]);
  const [scDicomLibraryLoading, setScDicomLibraryLoading] = useState(false);

  const refreshScDicomLibrary = useCallback(async () => {
    if (!studyId) {
      setScDicomLibrary([]);
      return;
    }
    setScDicomLibraryLoading(true);
    try {
      // The /sc-dicom/library response already merges Advanced Viewer key images
      // server-side and carries each entry's title/imageId/enabled, so no separate
      // /advviewer/keyimages fetch + client-side merge is needed here.
      const libRes = await getScDicomLibrary(studyId);
      const items = libRes?.data ?? libRes ?? [];
      const list = Array.isArray(items) ? items : [];
      setScDicomLibrary(list);
      return list;
    } finally {
      setScDicomLibraryLoading(false);
    }
  }, [studyId]);

  useEffect(() => {
    refreshScDicomLibrary();
  }, [refreshScDicomLibrary]);

  // Captured-page persistence does not store previewUrl, so after the library
  // refreshes we backfill each placed image's previewUrl/scImageId from the
  // library entry keyed by sopInstanceUid. Without this, reloaded reports show
  // empty placeholders for previously captured images.
  useEffect(() => {
    if (!scDicomLibrary || scDicomLibrary.length === 0) return;
    const byUid = new Map(scDicomLibrary.map((it) => [it.sopInstanceUid, it]));
    let patchedAny = false;
    // The library is authoritative for each SC's preview endpoint (newly-captured PNGs and
    // pre-existing secondary captures resolve differently), so adopt its previewUrl even when
    // a (possibly stale/wrong) one is already present — e.g. after server hydration.
    const patchImage = (img) => {
      if (!img) return img;
      const lib = byUid.get(img.sopInstanceUid);
      if (!lib) return img;
      const nextPreview = lib.previewUrl || img.previewUrl;
      const nextScImageId = img.scImageId || lib.scImageId;
      if (nextPreview === img.previewUrl && nextScImageId === img.scImageId) return img;
      patchedAny = true;
      return { ...img, previewUrl: nextPreview, scImageId: nextScImageId };
    };
    Object.keys(capturedPagesMapRef.current || {}).forEach((tplKey) => {
      const pages = capturedPagesMapRef.current[tplKey] || [];
      capturedPagesMapRef.current[tplKey] = pages.map((p) => ({
        ...p,
        images: (p.images || []).map(patchImage),
      }));
    });
    if (patchedAny) {
      setCapturedPages((prev) =>
        prev.map((p) => ({ ...p, images: (p.images || []).map(patchImage) })),
      );
    }
    // Auto-arranging captured images onto the page is driven by the captured-images
    // popup on open (see CapturedImagesTab), not here — so it runs against the freshly
    // server-loaded layout and respects an already-saved arrangement.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scDicomLibrary]);

  const capturedPagesMapRef = useRef({});
  // Per-report "the user explicitly arranged captured images" flag, keyed by report id. Loaded from
  // getData, flipped true when the Images popup persists a layout, and round-tripped on report save
  // so the backend keeps rendering the user's arrangement instead of the derived default layout.
  const capturedPagesCustomizedMapRef = useRef({});
  const capturedPageSelectedIdMapRef = useRef({});
  // Tracks which tab key the current `capturedPages` state belongs to.
  // Updated synchronously in handleChangeTemplate before setCapturedPages, so the
  // persistence effect never writes one tab's pages into another tab's map slot.
  const capturedPagesOwnerKeyRef = useRef("");

  const [disablePreview, setDisablePreview] = useState(true);
  const [disableQCPass, setDisableQCPass] = useState(true);
  const [disableQCReturn, setDisableQCReturn] = useState(true);
  const [disableQCReason, setDisableQcReason] = useState(true);
  const [disableSave, setDisableSave] = useState(true);

  const [disableSubmit, setDisableSubmit] = useState(true);
  const [disablePositiveNegative, setDisablePositiveNegative] = useState(true);
  // flog to show word
  const [showMsWord, setShowMsWord] = useState(false);
  const [isWordFilePath, setIsWordFilePath] = useState(false);
  const [showQCReasonBadge, setShowQCReasonBadge] = useState(false);
  const [disableSubmitUntilQCReasonClick, setDisableSubmitUntilQCReasonClick] =
    useState(false);
  const [disableDownload, setDisableDownload] = useState(true);
  const [disableRaiseAlert, setDisableRaiseAlert] = useState(true);
  const [disablePenEye, setDisablePenEye] = useState(true);
  const [showLockWarning, setShowLockWarning] = useState(false);
  const [hideLockWarningMessage, setHideLockWarningMessage] = useState(false);
  const [alreadyLocked, setAlreadyLocked] = useState(false);
  const [lockedByOther, setLockedByOther] = useState(false)
  const [showLockButton, setShowLockButton] = useState(true);
  const [openRSNAModal, setOpenRSNAModal] = useState(false);
  const [RSNAModalContent, setRSNAModalContent] = useState();
  const [reportModalState, setReportModalState] = useState({
    hrctChestILD: false,
    hrctChestCovid: false,
    ctBrain: false,
    mriSpine: false,
    content: {},
    id: null,
  });
  const [hasNewCapturedImage, setHasNewCapturedImage] = useState(false);
  // Count of images captured since the captured-images popup was last opened.
  // Shown as a number badge on the popup-trigger button instead of auto-opening the popup.
  const [newCapturedImageCount, setNewCapturedImageCount] = useState(0);
  // Open/close flag for the captured-images popup. The modal itself is rendered in CustomEditor,
  // but the trigger lives in more than one toolbar (the standard editor header and the agentic
  // LLMTopBar), so the flag is shared here rather than held as local state.
  const [showCapturedImagesModal, setShowCapturedImagesModal] = useState(false);
  // SOP instance UIDs of images captured this session that may not yet be ingested into
  // object storage (the acceptor pipeline is async). The popup shows a loader tile for each,
  // polls the library until it appears, then auto-places it. Persists across popup open/close.
  const [pendingCaptureSops, setPendingCaptureSops] = useState([]);
  const [reportingDoctorName, setReportingDoctorName] = useState(null);
  const [isExternal, setIsExternal] = useState(false);
  const [isWidget, setIsWidget] = useState(false);
  const [allStoreAnnotations, setAllStoreAnnotation] = useState([]);
  const [reportAnnotationState, setReportAnnotationState] =
    useState(annotation_state);
  const [addStoreAnnotationState, setAddStoreAnnotationState] = useState(
    JSON.parse(JSON.stringify(init_pathology_state))
  );
  const [openQCPassConfirmModal, setOpenQCPassConfirmModal] = useState(false);
  const [isKeyImagesPresent, setIsKeyImagesPresent] = useState(false);
  const [isTextAnnotationPresent, setIsTextAnnotationPresent] = useState(false);
  const [openQcModal, setOpenQcModal] = useState(false);
  const [openQcReasonModal, setOpenQcReasonModal] = useState(false);
  const [openFistolugramUploadModal, setFistolugramUploadModal] =
    useState(false);
  //  (Fistulogram Modal): controls the new unified fistulogram annotation modal
  const [openFistolugramModal, setOpenFistolugramModal] = useState(false);
  //  (Fibroid Modal): opens the fibroid annotation modal.
  const [openFibroidModal,     setOpenFibroidModal]     = useState(false);
  const [qcFailReason, setQcFailReason] = useState("");
  const [qcProviderList, setQcProviderList] = useState([]);
  const [qcFixerId, setQCFixerId] = useState("");
  const [showKeyImagesAndTextAnnotation, setShowKeyImagesAndTextAnnotation] =
    useState(false);
  const [showReturnedStudyReasonModal, setShowReturnedStudyReasonModal] =
    useState(false);
  const [cancelClicked, setCancelClicked] = useState(true);
  // TODO
  const [activeTab, setActiveTab] = useState(1);
  const [disableAddendumTab, setDisableAddendumTab] = useState(true);
  const [showReturnStudyModal, setShowReturnStudyModal] = useState(false);
  const [reportDoneStatusState, setReportDoneStatusState] = useState(null);
  const [showCommunicationModal, setShowCommunicationModal] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [updateRowSubmitDone, setUpdateDoneSubmitDone] = useState({
    id: null,
    show: false,
  });
  const [studyPatientDetails, setStudyPatientDetails] = useState({
    patientName: null,
    patientId: null,
  });
  //  str.substring(str.lastIndexOf('/') + 1);
  const [searchParams] = useSearchParams();
  const [studyParentId, setStudyParentId] = useState(
    window.location.pathname.includes("studylist")
      ? null
      : window.location.pathname.includes(NonAuthRoutes.CONTEXTSWITCHSTUDYVIEWER) ? searchParams.get("studyId") : window.location.pathname.substring(
        window.location.pathname.lastIndexOf("/") + 1
      )
  );
  const [firmId, setFirmId] = useState(searchParams.get("firmId"));
  const isStudyList = true;

  const [openReportModal, setOpenReportModal] = useState(false);
  const [keyImagePresentStudyList, setKeyImagePresentStudyList] =
    useState(false);
  const [modalityReport, setModalityReport] = useState("");
  const [isClientReportExist, setIsClientReportExist] = useState(false);
  const [
    isClientReportExistExternalModal,
    setIsClientReportExistExternalModal,
  ] = useState(null);
  const [isDSRExists, setIsDSRExists] = useState(false);
  const [showFistolugram, setShowFistolugram] = useState(false);
  const [fistolugramFilePath, setFistolugramFilePath] = useState(null);
  // NEW (Fibroid Modal): parallel visibility + storage-key state for the Fibroid button + modal.
  // Same shape and lifecycle as the fistolugram* state above.
  const [showFibroid,     setShowFibroid]     = useState(false);
  const [fibroidFilePath, setFibroidFilePath] = useState(null);
  const [conflictSave, setConflictSave] = useState("0");
  const [passConflict, setPassConflict] = useState(null);
  const [addendumDisclaimerEnabled, setAddendumDisclaimerEnabled] =
    useState(false);
  const [addendumDisclaimerAddedByRad, setAddendumDisclaimerAddedByRad] =
    useState(false);
  const [showAddendumDisclaimerModal, setShowAddendumDisclaimerModal] =
    useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showAddendumDisclaimerPopup, setShowAddendumDisclaimerPopup] =
    useState(true);
  const [showSubmitTick, setShowSubmitTick] = useState(false);
  const [showSuspectIcon, setShowSuspectIcon] = useState(false);
  const [disableMarkAsSuspect, setDisableMarkAsSuspect] = useState(true);
  const [reportSavedSuccess, setReportSaveSuccess] = useState(null);
  const [allowDownloadReport, setAllowDownloadReport] = useState(true);
  const [isAdvanceViewer, setIsAdvanceViewer] = useState(false);
  const [alertSuccessModal, setAlertSuccessModal] = useState({
    show: false,
    isError: false,
    isWarning: false,
    isSuccess: false,
    heading: "",
    description: "",
  });
  const [confirmAlertModal, setConfirmAlertModal] = useState({
    isConflictPopup: false,
    show: false,
    isError: false,
    isWarning: false,
    isSuccess: false,
    confirmClicked: false,
    heading: "",
    description: "",
    type: "save",
    qcData: {},
    allTextToolData: "",
    checkKeyImagesAndTextAnnotation: false
  });
  const externalReportingModalRef = useRef(null);
  const [positive,setPositive] = useState(null);
  const [externalReportingLoading, setExternalReportingLoading] =
    useState(true);
  const [isChildStudyReportState, setIsChildStudyReportState] = useState(false);
  const [allowCopyPaste, setAllowCopyPaste] = useState(false);
  const [isRestrictionsEnabled, setIsRestrictionsEnabled] = useState(false);
  const [forceReinferenceInProgress, setForReinferenceInProgress] = useState(false);
  const [showForceReinferenceModal, setShowForceReinferenceModal] = useState(false);
  const [observationState, setObservationState] = useState({
    clinicalHistory: "",
    comparison: "",
    technique: "",
    findings: "",
    impressions: ""
  })
  const [activeField, setActiveField] = useState(null);
  const [findingSentence, setFindingSentence] = useState("");
  const [disableObservations, setDisableObservations] = useState(false);
  const [llmReportTitle, setLlmReportTitle] = useState("");
  const [defaultAgenticTemplate, setDefaultAgenticTemplate] = useState("");
  const [reportSavedBy, setReportSavedBy] = useState(0);
  const [showFindingsErrorMessage, setShowFindingsErrorMessage] = useState(false);

  const [showTemplateList, setShowTemplateList] = useState({
    showTemplate: true,
    selectedList: "deeptekReportTemplage"
  });
  const [rsnaFlag, setRSNAFlag] = useState(false);
  const [s10User, setS10User] = useState(false);
  const [s10Url, setS10Url] = useState(null);
  const [confirmMultipleTemplateOpen, setConfirmMultipleTemplateOpen] = useState(false);
  const [confirmMultipleTemplateModalContent, setConfirmMultipleTemplateModalContent] = useState(null);
  const editorRef = useRef(null);
  // const [inputValue, setInputValue] = useState('');
  const [formatterAgentEnabled, setFormatterAgentEnabled] = useState(false);
  const [showFormatterPopup, setShowFormatterPopup] = useState(false);
  const [showPreliminaryActionPopup, setShowPreliminaryActionPopup] = useState(false);
  
  const [formattedReportAction, setFormattedReportAction] = useState("");
  const [pendingSubmission, setPendingSubmission] = useState(null);
  const [submissionParams, setSubmissionParams] = useState(null);
  const [pendingQCPass, setPendingQCPass] = useState(null);
  const [qcPassParams, setQCPassParams] = useState(null);
  const [formattedReportUsed, setFormattedReportUsed] = useState(false);
  const [templateHeight, setTemplateHeight] = useState(0);
  const [reviewerId, setReviewerId] = useState(null);
  const [reviewStatus, setReviewStatus] = useState(null);
  const [pageOpenTime, setPageOpenTime] = useState(null);

  useEffect(() => {
    setPageOpenTime(new Date());
  }, []);

  const [reportTitle, setReportTitle] = useState(""); 
  const [selectedClient, setSelectedClient] = useState("");
  const [llmSessionId, setLlmSessionId] = useState("");
  const [resetLLMReportClicked, setResetLLMReportClicked] = useState(false);
  const chatInputRef = useRef(null);
  const [disableEditReport,setDisableEditReport] = useState(false);

  const [showUnparsableDialog, setShowUnparsableDialog] = useState(false);
  const [unparsableDialogMessage, setUnparsableDialogMessage] = useState("");
  const [autoSaveReportPreference, setAutoSaveReportPreference] = useState(false);
  const [showPathologySentences, setShowPathologySentences] = useState(true);
  const [autoPopulateManualPathology, setAutoPopulateManualPathology] = useState(false);
  const [reportAutosaveIntervalSec, setReportAutosaveIntervalSec] = useState(null);
  /** off | on | saving | saved */
  const [reportAutosaveStatus, setReportAutosaveStatus] = useState("off");
  const [reportAutosaveLastSavedAt, setReportAutosaveLastSavedAt] = useState(null);
  const [reportAutosaveOffReason, setReportAutosaveOffReason] = useState("");
  const [reportAutosaveDirty, setReportAutosaveDirty] = useState(false);
  const [reportAutosaveBlocked, setReportAutosaveBlocked] = useState(false);
  const [snapshotRecoveryModalOpen, setSnapshotRecoveryModalOpen] = useState(false);
  const [snapshotDraftPatientReports, setSnapshotDraftPatientReports] = useState([]);
  const [snapshotOfficialPatientReports, setSnapshotOfficialPatientReports] = useState([]);
  const [snapshotRecoveryReopenVisible, setSnapshotRecoveryReopenVisible] =
    useState(false);
  const [autosaveScheduleVersion, setAutosaveScheduleVersion] = useState(0);

  const autosaveDepsRef = useRef({
    keyImages: [],
    annotationData: {},
    annotationDataAI: {},
    allTextToolAnnotation: [],
    activeViewportIndex: 0,
  });
  const autosaveDirtyRef = useRef(false);
  const skipNextExternalAutosaveDirtyRef = useRef(false);

  const setReportAutosaveDeps = useCallback((partial) => {
    autosaveDepsRef.current = {
      ...autosaveDepsRef.current,
      ...partial,
    };
  }, []);

  const markReportAutosaveDirty = useCallback(() => {
    autosaveDirtyRef.current = true;
    setReportAutosaveDirty(true);
    setAutosaveScheduleVersion((v) => v + 1);
  }, []);

  const mapSnapshotStudyReportListToPatientReports = useCallback((list) => {
    if (!list || !Array.isArray(list)) return [];
    return list.map((item, idx) => ({
      key: item.reportTemplateId ?? `snap-${idx}`,
      text:
        item.reportTemplateTitle ??
        item.title ??
        item.reportDetails?.reportTemplateTitle ??
        `Report ${idx + 1}`,
      isSuperSpecialReport: item.isSuperSpecialReport ?? 0,
      reportDetails: {
        reportTemplateId:
          item.reportTemplateId ?? item.reportDetails?.reportTemplateId ?? item.id,
        reportTemplateTitle:
          item.reportTemplateTitle ?? item.reportDetails?.reportTemplateTitle,
        title:
          item.reportTemplateTitle ??
          item.title ??
          item.reportDetails?.title,
        report:
          item.finalReport ??
          item.report ??
          item.reportDetails?.report ??
          item.reportDetails?.finalReport,
        finalReport:
          item.finalReport ??
          item.reportDetails?.finalReport ??
          item.reportDetails?.report,
        addendum: item.addendum ?? item.reportDetails?.addendum ?? "",
        isSuperSpecialReport:
          item.isSuperSpecialReport ?? item.reportDetails?.isSuperSpecialReport ?? 0,
      },
    }));
  }, []);

  const [studyReportPdf, setStudyReportPdf] = useState(null);
  const [studyReportPdfSelected , setStudyReportPdfSelected] = useState(false);
  const [studyReportPdfUrl, setStudyReportPdfUrl] = useState(null);
  const [isexternalStudyReport,setIsExternalStudyReport] =useState(false);
  const [externalReportLoadKey, setExternalReportLoadKey] = useState(0);
  const [activeTabKey, setActiveTabKey] = useState("");

  useEffect(() => {
    const ownerKey = capturedPagesOwnerKeyRef.current;
    if (ownerKey) {
      capturedPagesMapRef.current[ownerKey] = capturedPages;
    }
  }, [capturedPages]);

  useEffect(() => {
    const ownerKey = capturedPagesOwnerKeyRef.current;
    if (ownerKey) {
      capturedPageSelectedIdMapRef.current[ownerKey] = selectedCapturedPageId;
    }
  }, [selectedCapturedPageId]);

  let isBvpPlatform = (getEnv("REACT_APP_BVP_PLATFORM") == "true" || getEnv("REACT_APP_BVP_PLATFORM") == true) ? true : false;
  let isVdcPlatform = (getEnv("REACT_APP_VDC_PLATFORM")=="true"||getEnv("REACT_APP_VDC_PLATFORM")==true)?true:false;

  useEffect(() => {
    // Check if any report title contains "agentic report"
    const hasAgentic = patientReports.some(
      (report) => report.text && report.text.toLowerCase().includes("agentic report")
    );
    setHasAgenticReport(hasAgentic);
  }, [patientReports]);

  const handleUpdateStudyId = (id) => {
  
  };

  useEffect(() => {
    setModel("");
    setCapturedPages([]);
  }, [openReportModal]);

  useEffect(() => {
    if (
      firmId != null &&
      firmId != undefined &&
      studyParentId != null &&
      (isExternal || isWidget) &&
      isClientReportExistExternalModal != null && !isMobile
    ) {
      if (isExternal) setExternalReportingLoading(true);
      // setLoaderMessage("Loading external report data...");
      setLoaderRunning(true);
      ref.current.continuousStart();

      setTimeout(() => {
        setDisablePreview(true);
        setDisableQCPass(true);
        setDisableQCReturn(true);
        setDisableQcReason(true);
        setDisableSave(true);
        setDisableSubmit(true);
        setShowQCReasonBadge(false);
        setDisableSubmitUntilQCReasonClick(false);
        setDisableDownload(true);
        setDisableRaiseAlert(true);
        setShowLockWarning(false);
        setHideLockWarningMessage(false);
        setAlreadyLocked(false);
        setLockedByOther(false);
        setReportDoneStatusState(null);
        setOpenReportModal(true);
        setReportingDoctorName(null);
        setShowMsWord(false);
        setIsWordFilePath(false);
        setAllowCopyPaste(false);
        setRaiseAlertValue();
        setRaiseAlertList([]);
        setStudyReportPdf(null);
        setStudyReportPdfSelected(false);
        setStudyReportPdfUrl(null);
        setReportAutosaveIntervalSec(null);
        setReportAutosaveStatus("off");
        setReportAutosaveLastSavedAt(null);
        setReportAutosaveOffReason("");
        setExternalReportLoadKey((k) => k + 1);
      }, 100);

      setTimeout(() => {
        let res = getData(false);
        if (res) {
          setExternalReportingLoading(false);
        }
      }, 200);
    }
  }, [
    studyParentId,
    firmId,
    isExternal,
    isWidget,
    isClientReportExistExternalModal,
    keyImagePresentStudyList,
  ]);

  useEffect(() => {    
    if(studyReportPdf){
      loadStudyReportPdf(studyId).then(setStudyReportPdfUrl);
    }
  }, [studyReportPdf]);

  useEffect(() => {
    if (!isexternalStudyReport || !studyId) return;

    const load = async () => {
      const url = await loadExternalFirmSubmittedReportPdf(studyId);
      setStudyReportPdfUrl(url);

      const ulItem = document.getElementById("horizontal-list");
      if (!ulItem) return;
      const allTabs = ulItem.children;

      // STEP 1: Always clear active class from ALL tabs
      for (let i = 0; i < allTabs.length; i++) {
        if (isStudyList) {
          allTabs[i].classList.remove(themeName + "-active-li");
        } else {
          allTabs[i].classList.remove("active-li");
        }
      }
      setStudyReportPdfSelected(true);
    };

    load();
  }, [isexternalStudyReport, studyId,externalReportLoadKey]);

  useEffect(() => {
    if (!reportMenu) return;
    if (showFistolugram && studyParentId) {
      getFistulogramStorageKey(studyParentId);
    }
    if (showFibroid && studyParentId) {
      getFibroidStorageKey(studyParentId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportMenu, showFistolugram, showFibroid, studyParentId]);

  const handleAttachToggle = async (flag) => {
    setLoaderRunning(true);
    ref.current.continuousStart();
    try {
      const res = await toggleStudyReportPdfAttachment(studyId, flag);
      if(res.status === 200){
        setStudyReportPdf(res.data.data);
        setStudyReportPdfSelected(false); 
      } 
      setLoaderRunning(false);
      ref.current.complete();    
    } catch (error) {
      setLoaderRunning(false);
      ref.current.complete();
    }
    
  };

  const getData = async (refresh, isReportSubmitted = true, changeReport = true, closeSeriesMenuOnRefresh = true) => {
    if (refresh) {
     //setLlmReportTitle("");
      setShowFindingsErrorMessage(false);
    }
    if (firmId == null) {
      return;
    }
    // if (!isExternal && studyId == null) {
    //   getAllReport(studyParentId);
    // }
    if (isWidget) {
      getAllReport(studyParentId);
    } else if (!isExternal && studyId == null) {
      getAllReport(studyParentId);
    }
    setSelectedCategoryTemplate("deeptekReportTemplage");
    // Clear all captured-page state before fetching so the UI reflects exactly
    // what the backend returns — no leftovers from a previous load.
    capturedPagesMapRef.current = {};
    capturedPageSelectedIdMapRef.current = {};
    capturedPagesOwnerKeyRef.current = "";
    setCapturedPages([]);
    setSelectedCapturedPageId(null);
    try {
      const response = await getStudyReportData(studyParentId, firmId);
      if (response.status === 200) {
        let data = response.data.data.studyReportList;     
        setModality(response.data.data.modality);
        setStudyDescription(response.data.data.studyDescription)
        setQcFailReason(response.data.data.qcfailReason);
        setAddendumDisclaimerEnabled(
          response.data.data.addendumDisclaimerEnabled
        );
        setAllowDownloadReport(response.data.data.allowDownloadReport);
        setS10User(response?.data?.data?.s10User);
        setS10Url(response?.data?.data?.s10Url);
        setFormatterAgentEnabled(response?.data?.data?.formatterAgentEnabled);
        setFormattedReportUsed(response?.data?.data?.formattedReportUsed);
        setShowPreliminaryActionPopup(
          response?.data?.data?.showPreliminaryActionPopup === true
        );
        setShowPathologySentences(response?.data?.data?.showPathologySentences !== false);
        let opt = [];
        let autoTemplateInd = [];
        let allowRestrictionForClientTemplate = response.data?.data?.allowRestrictionForClientTemplate;
        let allowCopyPasteForClientTemplate = response.data?.data?.allowCopyPaste;
        // const fetchedLlmTitle = response.data?.data?.llmreportTitle;
        const fetchedLlmTitle = response.data?.data?.LLMReportTitle;
        setLlmReportTitle(fetchedLlmTitle);
        setDefaultAgenticTemplate(response.data?.data?.defaultAgenticReport)
        // setLlmSessionId(generateRandomString(userId, response.data.data.id));
        let injectAgentic = (enableLlmReport && fetchedLlmTitle != undefined && fetchedLlmTitle != "" && !allReportTemplatesLoading && Object.keys(allReportTemplates).length != 0 && response.data.data.reportDoneStatus === 0 && response.data.data.reportSavedBy === 0);

        data.map((ele) => {
          if (allowRestrictionForClientTemplate != null && allowRestrictionForClientTemplate == true &&
            isClientReportExist != null &&
            isClientReportExist == true &&
            allowCopyPasteForClientTemplate != null && allowCopyPasteForClientTemplate == false &&
            (ele.isSuperSpecialReport == 1 ||
              ele.reportTemplateTitle.includes("BLANK"))
          ) {
            return null;
          }

          if (ele.isSuperSpecialReport && !enableLlmReport ) {
            let updatedFontSizeReport = convertFontSize(ele.finalReport);
            ele.finalReport = updatedFontSizeReport;
            autoTemplateInd.push(ele);
          } else if (!injectAgentic) {
            opt.push({
              key: ele.id,
              text: ele.reportTemplateTitle,
              isSuperSpecialReport: ele.isSuperSpecialReport,
              reportDetails: ele,
              addendum: ele.addendum,
              addendumEnabled: true,
            });
            capturedPagesCustomizedMapRef.current[ele.id] = !!ele.capturedPagesCustomized;
            if (ele.capturedPages && Array.isArray(ele.capturedPages)) {
              const sortedPages = [...ele.capturedPages].sort(
                (a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0)
              );
              capturedPagesMapRef.current[ele.id] = sortedPages.map(p => ({
                id: p.pageKey,
                columns: p.pageColumns,
                images: (p.images || [])
                  .slice()
                  .sort((a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0))
                  .map(img => ({
                    id: img.imageKey,
                    sopInstanceUid: img.sopInstanceUid,
                    scImageId: img.scImageId,
                    previewUrl: img.previewUrl,
                  })),
              }));
            }
          }
          if (ele.reportTemplateTitle.includes("LLM")) {
            setSelectedCategoryTemplate("dsrTemplate")
          }
        });

        if (injectAgentic) {
          allReportTemplates?.dsrReportTemplates?.forEach(rt => {
            if (rt.modality.name === response.data.data.modality) {
              opt.push({ key: rt.id, text: rt.title, reportDetails: rt });
              setCurrentActiveTab(rt.title);
            }
          })
        }
        if (autoTemplateInd != null && autoTemplateInd.length > 0) {
          autoTemplateInd.map((ele, index) => {
            opt.push({
              key: ele.id,
              text: ele.reportTemplateTitle,
              isSuperSpecialReport: ele.isSuperSpecialReport,
              reportDetails: ele,
              addendumEnabled: true,
            });
            capturedPagesCustomizedMapRef.current[ele.id] = !!ele.capturedPagesCustomized;
            if (ele.capturedPages && Array.isArray(ele.capturedPages)) {
              const sortedPages = [...ele.capturedPages].sort(
                (a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0)
              );
              capturedPagesMapRef.current[ele.id] = sortedPages.map(p => ({
                id: p.pageKey,
                columns: p.pageColumns,
                images: (p.images || [])
                  .slice()
                  .sort((a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0))
                  .map(img => ({
                    id: img.imageKey,
                    sopInstanceUid: img.sopInstanceUid,
                    scImageId: img.scImageId,
                    previewUrl: img.previewUrl,
                  })),
              }));
            }
          });

          setCurrentActiveTab(
            autoTemplateInd[autoTemplateInd.length - 1].reportTemplateTitle
          );
          if(changeReport){
            setModel(autoTemplateInd[autoTemplateInd.length - 1].finalReport);
          }
        }

        if (response.data?.data?.allowCopyPaste != null) {
          setAllowCopyPaste(response.data?.data?.allowCopyPaste);
        }
        if (response.data?.data?.allowRestrictionForClientTemplate != null) {
          setIsRestrictionsEnabled(response.data?.data?.allowRestrictionForClientTemplate);
        }
        setRaiseAlertListFunc(response.data?.data?.raiseAlertList, response.data?.data?.raiseAlert);
        if(changeReport){
          setPatientReports(opt);
        }
        setStudyId(response.data.data.id);
        const autosaveIntervalSec =
          Number(response.data.data?.reportAutosaveIntervalSeconds) || null;
        setReportAutosaveIntervalSec(autosaveIntervalSec);
        setUserActionLoading(false);
        handleValidationForKeyImagesAndTextAnnotation(response.data.data);
        handleValidation(response.data.data);
        handleFistolugramVisiblity(response.data.data);
        handleFibroidVisibility(response.data.data); //(Fibroid Modal): parallel visibility check
        // Cache patient sex for the fibroid modal's gender-conflict check (avoids a
        // separate API call that would otherwise hit a canEditStudy-gated endpoint).
        setStudyPatientSex(response.data.data?.patientSex ?? null);
        setReportingDoctorName(response.data.data.reportingDoctor);
        setQCFixerId(response.data.data.qcfixerId);
        setReportDoneStatusState(response.data.data.reportDoneStatus);
        setReportSavedBy(response.data.data.reportSavedBy);
        setSanitizeReportContentForHL7(response.data.data.sanitizeReportContentForHL7);
        setUseOldReportTemplate(response.data.data.useOldReportTemplate);
        setIsExternalStudyReport(response.data.data.externalFirmSubmittedReport)
        setObservationState({
          clinicalHistory: response.data.data?.studyObservations?.clinicalHistory,
          comparison: response.data.data?.studyObservations?.comparison,
          technique: response.data.data?.studyObservations?.technique,
          // impressions: response.data.data?.studyObservations?.impressions,
          findings: response.data.data?.studyObservations?.findings
        })
        setFindingSentence(() => {
          const finding = response.data.data?.studyObservations?.findings.find(f => f.pathologyName.toLowerCase() == "other");
          return finding ? finding?.findingSentences[finding?.findingSentences.length - 1].sentence : "";
        })

        if (!roles?.[0]?.includes?.(USERTYPES.FIRMTECHNICIAN) && closeSeriesMenuOnRefresh) {
          if (isReportSubmitted) {
            studyViewerData?.setSeriesMenu?.(response.data.data.autoOpenReportPanel ? false : isMobile ? false : refresh ? false : true);
          } else if (refresh) {
            studyViewerData?.setSeriesMenu?.(false);
          }
        }
        if (!isExternal && !isWidget)
          setDisableMarkAsSuspect(!response.data.data.markAsSuspectedDisplay);
        if (
          (response.data.data.reportDoneStatus === REPORTDONESTATUS.QC_FIX ||
            response.data.data.reportDoneStatus === REPORTDONESTATUS.PRELIMINARY_QC_FIX) &&
          response.data.data.qcfixerId === userId
        ) {

        }
        if (
          (response.data.data.reportDoneStatus === REPORTDONESTATUS.QC_FIX ||
            response.data.data.reportDoneStatus === REPORTDONESTATUS.PRELIMINARY_QC_FIX ||
            response.data.data.reportDoneStatus === REPORTDONESTATUS.QC_VERIFY ||
            response.data.data.reportDoneStatus === REPORTDONESTATUS.PRELIMINARY_QC_VERIFY) &&
          roles[0] === USERTYPES.SUPERVISOR
        ) {
          setShowQCReasonBadge(true);
        }
        setReviewerId(response.data.data.peerReviewAssignment?.reviewerId);
        setReviewStatus(response.data.data.peerReviewAssignment?.reviewStatus);
        setStudyReportPdf(response.data.data.studyReportPdf);
        setDisableEditReport(response.data.data.disableEditReport);
        // setShowToast((prev) => {
        //   return {
        //     ...prev,
        //     show: false,
        //     message: "",
        //     loading: false,
        //     state: "success",
        //   };
        // });
        if (
          externalReportingModalRef != null &&
          externalReportingModalRef.current != null
        ) {
          externalReportingModalRef.current.complete();
          externalReportingModalRef.current = null;
        }
        if (refresh || isExternal || isWidget) {
          setLoaderRunning(false);
          ref.current.complete();
        }

        if (
          changeReport &&
          (roles[0] === USERTYPES.RADIOLOGIST ||
            roles[0] === USERTYPES.TYPIST) &&
          !isWidget &&
          response.data.data?.id
        ) {
          try {
            const snapRes = await getReportSnapshotCheck(response.data.data.id);
            if (
              snapRes?.status === 200 &&
              snapRes?.data?.result === "SUCCESS"
            ) {
              const pdata = snapRes.data.data ?? {};
              const exists = pdata.snapshot_exists ?? pdata.snapshotExists;
              const differsFromOfficial = pdata.snapshotDiffersFromOfficial;
              const dto = pdata.studyReportSnapshot ?? pdata.snapshot ?? pdata;
              const snapList =
                dto?.editorExtension?.studyReportSaveDto?.studyReportList ??
                dto?.studyReportList ??
                pdata?.studyReportList ??
                pdata?.studyReportSnapshotList ??
                (dto?.reportTemplateId ? [dto] : []);
              const officialHasData = (opt?.length ?? 0) > 0;
              if (exists && (differsFromOfficial || !officialHasData) && snapList?.length > 0) {
                const mapped =
                  mapSnapshotStudyReportListToPatientReports(snapList);
                if (mapped?.length > 0) {
                  setSnapshotRecoveryReopenVisible(false);
                  setSnapshotOfficialPatientReports(
                    JSON.parse(JSON.stringify(opt))
                  );
                  setSnapshotDraftPatientReports(mapped);
                  setSnapshotRecoveryModalOpen(true);
                }
              }
            }
          } catch (snapshotErr) {
            console.debug("report snapshot check skipped", snapshotErr);
          }
        }

        return true;
      } else {
        setUserActionLoading(false);
        if (refresh || isExternal || isWidget) {
          setLoaderRunning(false);
          ref.current.complete();
        }
        setOpenReportModal(false);
        setAlertSuccessModal(() => {
          const newItem = { ...alertSuccessModal };
          newItem.show = true;
          newItem.heading = "Error";
          newItem.description = t("string-literals.failed-message");
          return newItem;
        });
      }
      setStopEffect(true);
    } catch (e) {
      console.error("[StudyReportState] report fetch failed:", e);
      setLoaderRunning(false);
      ref.current.complete();
      setOpenReportModal(false);
      setAlertSuccessModal(() => {
        const newItem = { ...alertSuccessModal };
        newItem.show = true;
        newItem.heading = "Error";
        newItem.description = t("string-literals.failed-message");
        return newItem;
      });
    }
  };

  const hideAlertSuccessModal = () => {
    setAlertSuccessModal(() => {
      const newItem = { ...alertSuccessModal };
      newItem.show = false;
      newItem.heading = "";
      newItem.description = "";
      return newItem;
    });

    setConfirmAlertModal(() => {
      const newItem = { ...confirmAlertModal };
      newItem.show = false;
      newItem.isConflictPopup = false;
      newItem.heading = "";
      newItem.type = "";
      newItem.description = "";
      return newItem;
    });
  };

  function convertFontSize(htmlString) {
    const fontSizeRegex = /font-size: (\d+)px;/g;
    if (fontSizeRegex.test(htmlString)) {
      const convertedHtml = htmlString.replace(
        fontSizeRegex,
        (match, fontSize) => {
          const convertedSize = Math.max(14, Math.floor((fontSize * 16) / 20));
          return `font-size: ${convertedSize}px;`;
        }
      );
      return convertedHtml;
    }
    return htmlString;
  }

  useEffect(() => {
    handleLockWarning(reportingDoctorName);
  }, [reportingDoctorName, roles, qcFixerId, reviewerId]);

  const handleLockWarning = (reportingDoctor) => {
    setUserRole(roles[0]);
    if (roles[0] != USERTYPES.RADIOLOGIST) {
      //setDisableAddPathology(true);
      setShowLockWarning(false);
      return;
    } else {
      //setDisableAddPathology(false);
    }
    if (reportingDoctor != null && reportingDoctor != undefined) {
      if (
        roles[0] == USERTYPES.RADIOLOGIST &&
        (reportingDoctor == username || qcFixerId === userId)
      ) {
        setAlreadyLocked(true);
        setShowLockWarning(false);
      } else if (roles[0] == USERTYPES.RADIOLOGIST && reviewerId === userId) {
        setAlreadyLocked(false);
        setShowLockWarning(false);
      } else {
        setLockedByOther(false);
        setShowLockWarning(true);
      }
    } else {
      if (qcFixerId === userId) {
        setAlreadyLocked(true);
        setShowLockWarning(false);
      } else {
        setAlreadyLocked(false);
        setLockedByOther(true);
        setHideLockWarningMessage(false);
        setShowLockWarning(true);
      }
    }

    {
      /* To Be ADDED */
    }

    {
      /*if (
      assignmentData.assignedRadiologist != username &&
      assignmentData.assignedRadiologist != null
    ) {
      setShowLockButton(false);
    } else {
      setShowLockButton(true);
    }*/
    }
  };

  useEffect(() => {
    if (allReportTemplates != null) {
      handleSwitchCategory();
    }
  }, [selectedCategoryTemplate]);

  useEffect(() => {
    if (studyId != null && !isExternal) {
      // getRaiseAlertList(studyId);
      //getAllReport(studyId);
    }
  }, [studyId]);

  useEffect(() => {
    if (studyParentId != null && isExternal) {
      getAllReport(studyParentId);
    }
  }, [studyParentId, isExternal]);

  useEffect(() => {

    if (selectedCategoryTemplate === "dsrTemplate" && patientReports.length === 0) {
      setDisableObservations(true);
      setActiveTab(1);
    } else {
      setDisableObservations(false)
    }
    // Auto-selection of the last patientReports entry is handled by the
    // effect at the line ~1609 below, which also accounts for studyReportPdfSelected.
    // Calling handleChangeTemplate here as well caused it to fire twice in a
    // row whenever patientReports changed.
  }, [patientReports]);

  const handleSwitchCategory = (clientReportTemplate) => {
    let opt = [];
    if (allReportTemplates != null) {
      switch (selectedCategoryTemplate) {
        case "deeptekReportTemplage":
          allReportTemplates.reportTemplates?.map((ele) => {
            opt.push({ key: ele.id, text: ele.title, reportDetails: ele });
          });
          break;
        case "rsnaReportTemplage":
          allReportTemplates.rsnaReportTemplates?.map((ele) => {
            opt.push({ key: ele.id, text: ele.title, reportDetails: ele });
          });
          break;
        case "radiologistReportTemplate":
          allReportTemplates.radiologistReportTemplates?.map((ele) => {
            opt.push({ key: ele.id, text: ele.title, reportDetails: ele });
          });
          break;
        case "clientReportTemplate":
          allReportTemplates.clientReportTemplates?.map((ele) => {
            opt.push({ key: ele.id, text: ele.title, reportDetails: ele });
          });
          break;
        case "dsrTemplate":
          allReportTemplates.dsrReportTemplates?.map((ele) => {
            opt.push({ key: ele.id, text: ele.title, reportDetails: ele });
          });
          break;
        default:
          break;
      }
    }
    if (clientReportTemplate != null && clientReportTemplate != undefined && clientReportTemplate == "clientReportTemplate") {
      opt = [];
      allReportTemplates.clientReportTemplates?.map((ele) => {
        opt.push({ key: ele.id, text: ele.title, reportDetails: ele });
      });
    }
    setDropdownSelectedTemplates(opt);
    setDropdownSelectedTemplatesStore(opt);
  };

  const handleUpdateReportSection = (allParentChildReports, studyId) => {

    let study = allParentChildReports[studyId];
    if (study != undefined) {
      let opt = [];
      let autoTemplateInd = [];
      study.studyReportList.map((ele) => {
        if (ele.isSuperSpecialReport) {
          let updatedFontSizeReport = convertFontSize(ele.finalReport);
          ele.finalReport = updatedFontSizeReport;
          autoTemplateInd.push(ele);
        } else {
          opt.push({
            key: ele.id,
            text: ele.reportTemplateTitle,
            isSuperSpecialReport: ele.isSuperSpecialReport,
            reportDetails: ele,
            finalReport: ele.finalReport,
            addendum: ele.addendum,
          });
        }
      });
      if (autoTemplateInd != null && autoTemplateInd.length > 0) {
        autoTemplateInd.map((ele, index) => {
          opt.push({
            key: ele.id,
            text: ele.reportTemplateTitle,
            isSuperSpecialReport: ele.isSuperSpecialReport,
            reportDetails: ele,
            finalReport: ele.finalReport,
          });
        });
      }
      
      if (autoTemplateInd != null && autoTemplateInd.length > 0) {
        setChildCurrentActiveTab(
          autoTemplateInd[autoTemplateInd.length - 1]?.text
        );
        setChildModel(autoTemplateInd[autoTemplateInd.length - 1]?.finalReport);
      } else if (opt.length > 0) {
        setChildCurrentActiveTab(opt[opt.length - 1]?.text);
        setChildModel(opt[opt.length - 1]?.finalReport);
      }
      setChildPatientReports(opt);
    }
  };

  const setRaiseAlertListFunc = (raiseAlertList, raiseAlertValue) => {
    let opt = [];
    let object = raiseAlertList;
    if (Object.keys(object)?.length > 0 && object?.hasOwnProperty(raiseAlertValue)) {
      setRaiseAlertValue(object[raiseAlertValue]);
    } else {
      setRaiseAlertValue(raiseAlertValue);
    }
    if (object != null && object != undefined && Object.keys(object)?.length > 0) {
      let keys = Object.keys(object);

      keys.forEach((key, index) => {
        opt.push({ value: key, label: object[key] });
      });
    }

    setRaiseAlertList(opt);
  };

  const getAllReport = async (studyId) => {
    if (isExternal || isWidget) {
      // setLoaderMessage("Loading report templates...");
      setLoaderRunning(true);
      ref.current.continuousStart();
    } else {
      setAllReportTemplateLoading(true);
    }

    try {
      const ret = await getReportTemplatesData(studyId, firmId);
      if (ret.status === 200) {
        setAllReportTemplateLoading(false);
        setShowAddendumDisclaimerPopup(true);

        if (ret?.data?.data?.dsrReportTemplates?.length > 0) {
          setIsDSRExists(true);
        }

        if (ret?.data?.data?.clientReportTemplates?.length > 0) {
          setIsClientReportExist(true);
          setIsClientReportExistExternalModal(true);
        } else {
          setIsClientReportExist(false);
          setIsClientReportExistExternalModal(false);
        }
        setAllReportTemplates(ret?.data?.data);

        let opt = [];
        let suggestList = [];
        ret.data.data.reportTemplates.map((ele) => {
          if (ele.title == "ELBOW" || ele.title == "HAND") {
            suggestList.push({
              key: ele.id,
              text: ele.title,
              reportDetails: ele,
            });
          }
          opt.push({ key: ele.id, text: ele.title, reportDetails: ele });
        });
        setSuggestedListReport(suggestList);
        setDropdownSelectedTemplates(opt);
        setDropdownSelectedTemplatesStore(opt);
        setAllReportTemplateLoading(false);
      }
    } catch (e) {
      console.log("---Exception---", e);
      setAllReportTemplateLoading(false);
    }
  };

  const handleFistolugramVisiblity = (studyData) => {
    if (
      (roles.includes(USERTYPES.RADIOLOGIST) &&
        (studyData.reportingDoctor == username ||
          studyData.qcFixerId == userId) &&
        studyData.reportDoneStatus != REPORTDONESTATUS.QC_REVIEW &&
        studyData.reportDoneStatus != REPORTDONESTATUS.PRELIMINARY_QC_REVIEW &&
        studyData.reportDoneStatus != REPORTDONESTATUS.QC_VERIFY &&
        studyData.reportDoneStatus != REPORTDONESTATUS.PRELIMINARY_QC_VERIFY) ||
      (qcReviewer == 1 &&
        studyData.qcreviewerId == userId &&
        (studyData.reportDoneStatus == REPORTDONESTATUS.QC_REVIEW ||
          studyData.reportDoneStatus == REPORTDONESTATUS.PRELIMINARY_QC_REVIEW)) ||
      (qcReviewer == 1 &&
        studyData.qcverifierId == userId &&
        (studyData.reportDoneStatus == REPORTDONESTATUS.QC_VERIFY ||
          studyData.reportDoneStatus == REPORTDONESTATUS.PRELIMINARY_QC_VERIFY))
    ) {
      if (studyData.modality == "MR" || studyData.modality == "MRI") {
        setShowFistolugram(true);
      } else {
        setShowFistolugram(false);
      }
      if (isExternal) {
        getFistulogramStorageKey(studyData.id);
      }
    } else {
      //hideFistulogramIcons();
      setShowFistolugram(false);
    }
  };

  const getFistulogramStorageKey = async (id) => {
    setFistolugramFilePath(null);
    const response = await getStorageKeyFistolugram(id);
    if (response?.data?.result == "SUCCESS") {
      setFistolugramFilePath(response.data.data);
    }
  };

  const downloadFistolugram = async (fistoAvailable) => {
    // setLoaderMessage("Downloading fistolugram...");
    setLoaderRunning(true);
    ref.current.continuousStart();
    var filePath = "";
    if (!fistoAvailable) {
      filePath = "REFERENCE_IMAGE/FISTULOGRAM/download.jpg";
    } else if (fistoAvailable) {
      filePath = fistolugramFilePath;
    }
    let response = await downloadFistolugramImage(filePath);
    if (response) {
      setLoaderRunning(false);
      ref.current.complete();
      showToastv2(TOAST_TYPE.SUCCESS, "Fistolugram Downloaded Successfully");
    } else {
      setLoaderRunning(false);
      ref.current.complete();
      showToastv2(TOAST_TYPE.ERROR, "Error while downloading fistolugram");
    }
  };

  const uploadFistolugramFunc = async (studyId, file) => {
    // setLoaderMessage("Uploading fistolugram...");
    setLoaderRunning(true);
    ref.current.continuousStart();
    try {
      let response = await uploadFistolugramService(studyId, file);
      if (response.data.result === "SUCCESS") {
        setLoaderRunning(false);
        ref.current.complete();
        getFistulogramStorageKey(studyId);
        showToastv2(TOAST_TYPE.SUCCESS, "Fistolugram Uploaded Successfully");
      } else {
        setLoaderRunning(false);
        ref.current.complete();
        showToastv2(TOAST_TYPE.ERROR, response.data.message);
      }
    } catch (e) {
      setLoaderRunning(false);
      ref.current.complete();
      console.log("-- Exception ---", e);
      showToastv2(TOAST_TYPE.ERROR, e.message);
    }

  };

  // Called from AnnotatedImageModal when the user clicks Save with no annotations
  // (Reset → Save scenario). Nulls out fistulogram_storage_key on the backend so the
  // green "edited" indicator disappears from the toolbar button. After the DB clear,
  // we refresh the local file path so the UI reflects the cleared state immediately.
  const deleteFistolugramFunc = async (studyId) => {
    setLoaderRunning(true);
    ref.current.continuousStart();
    try {
      let response = await deleteFistolugramService(studyId);
      if (response?.data?.result === "SUCCESS") {
        setFistolugramFilePath(null);
        showToastv2(TOAST_TYPE.SUCCESS, "Fistolugram cleared");
      } else {
        showToastv2(TOAST_TYPE.ERROR, response?.data?.message || "Could not clear fistolugram");
      }
    } catch (e) {
      console.log("-- Exception (deleteFistolugramFunc) ---", e);
      showToastv2(TOAST_TYPE.ERROR, e.message);
    } finally {
      setLoaderRunning(false);
      ref.current.complete();
    }
  };

  // ─── Fibroid Modal  ──────────────────────────────────────────────────

  const handleFibroidVisibility = (studyData) => {
    if (
      (roles.includes(USERTYPES.RADIOLOGIST) &&
        (studyData.reportingDoctor == username ||
          studyData.qcFixerId == userId) &&
        studyData.reportDoneStatus != REPORTDONESTATUS.QC_REVIEW &&
        studyData.reportDoneStatus != REPORTDONESTATUS.PRELIMINARY_QC_REVIEW &&
        studyData.reportDoneStatus != REPORTDONESTATUS.QC_VERIFY &&
        studyData.reportDoneStatus != REPORTDONESTATUS.PRELIMINARY_QC_VERIFY) ||
      (qcReviewer == 1 &&
        studyData.qcreviewerId == userId &&
        (studyData.reportDoneStatus == REPORTDONESTATUS.QC_REVIEW ||
          studyData.reportDoneStatus == REPORTDONESTATUS.PRELIMINARY_QC_REVIEW)) ||
      (qcReviewer == 1 &&
        studyData.qcverifierId == userId &&
        (studyData.reportDoneStatus == REPORTDONESTATUS.QC_VERIFY ||
          studyData.reportDoneStatus == REPORTDONESTATUS.PRELIMINARY_QC_VERIFY))
    ) {
      if (studyData.modality == "MR" || studyData.modality == "MRI") {
        setShowFibroid(true);
      } else {
        setShowFibroid(false);
      }
      if (isExternal) {
        getFibroidStorageKey(studyData.id);
      }
    } else {
      setShowFibroid(false);
    }
  };

  const getFibroidStorageKey = async (id) => {
    setFibroidFilePath(null);
    const response = await getStorageKeyFibroid(id);
    if (response?.data?.result == "SUCCESS") {
      setFibroidFilePath(response.data.data);
    }
  };

  const uploadFibroidFunc = async (studyId, file) => {
    setLoaderRunning(true);
    ref.current.continuousStart();
    try {
      let response = await uploadFibroidService(studyId, file);
      if (response.data.result === "SUCCESS") {
        setLoaderRunning(false);
        ref.current.complete();
        getFibroidStorageKey(studyId);
        showToastv2(TOAST_TYPE.SUCCESS, "Fibroid Uploaded Successfully");
      } else {
        setLoaderRunning(false);
        ref.current.complete();
        showToastv2(TOAST_TYPE.ERROR, response.data.message);
      }
    } catch (e) {
      setLoaderRunning(false);
      ref.current.complete();
      console.log("-- Exception (uploadFibroidFunc) ---", e);
      showToastv2(TOAST_TYPE.ERROR, e.message);
    }
  };

  // Mirrors deleteFistolugramFunc — clears the fibroid storage key on the backend.
  const deleteFibroidFunc = async (studyId) => {
    setLoaderRunning(true);
    ref.current.continuousStart();
    try {
      let response = await deleteFibroidService(studyId);
      if (response?.data?.result === "SUCCESS") {
        setFibroidFilePath(null);
        showToastv2(TOAST_TYPE.SUCCESS, "Fibroid cleared");
      } else {
        showToastv2(TOAST_TYPE.ERROR, response?.data?.message || "Could not clear fibroid");
      }
    } catch (e) {
      console.log("-- Exception (deleteFibroidFunc) ---", e);
      showToastv2(TOAST_TYPE.ERROR, e.message);
    } finally {
      setLoaderRunning(false);
      ref.current.complete();
    }
  };

  const handleValidationForKeyImagesAndTextAnnotation = (studyData) => {
    if (roles[0] === USERTYPES.RADIOLOGIST && studyData.peerReviewAssignment?.reviewerId == userId) {
      setShowKeyImagesAndTextAnnotation(false);
    } else if (roles[0] === USERTYPES.RADIOLOGIST ||
      (roles[0] === USERTYPES.SUPERVISOR &&
        (studyData.qcreviewerId === userId ||
          studyData.qcverifierId === userId) &&
        studyData.allowAddingTextAnnotationAndKeyImage == true)
    ) {
      setShowKeyImagesAndTextAnnotation(true);
    } else {
      setShowKeyImagesAndTextAnnotation(false);
    }
    // setShowKeyImagesAndTextAnnotation(true)
  };

  const handleValidation = (studyData) => {
    if (roles[0] == USERTYPES.RADIOLOGIST && userId == studyData.peerReviewAssignment?.reviewerId) {
      setDisableAddendumTab(true);
    } else if (studyData.reportDoneStatus != undefined && studyData?.reportDoneStatus == 2) {
      setDisableAddendumTab(false);
    } else {
      setDisableAddendumTab(true);
    }
    switch (true) {
      case roles.includes(USERTYPES.RADIOLOGIST):
        handleRadiologistValidation(studyData);
        break;

      case !roles.includes(USERTYPES.RADIOLOGIST):
        handleOtherRoleValidation(
          studyData.reportDoneStatus,
          studyData.qcreviewerId,
          studyData.qcverifierId,
          studyData.allowDownloadReport,
          studyData.showWord,
          studyData.enableSubmitForTypist,
          studyData.typistId
        );
        break;

      default:
        break;
    }
    /* in case report saved using word  */
    if (roles[0] == USERTYPES.RADIOLOGIST && userId == studyData.peerReviewAssignment?.reviewerId) {
      if (studyData.peerReviewAssignment?.wordFilePath != undefined && studyData.peerReviewAssignment?.wordFilePath != "") {
        setDisableSave(true);
        setDisableSubmit(true);
        setIsWordFilePath(true);
      }
      else {
        setIsWordFilePath(false);
      }
    } else {
      if (studyData.wordFilePath != undefined && studyData.wordFilePath != "") {
        setDisableSave(true);
        setDisableSubmit(true);
        setIsWordFilePath(true);
      } else {
        setIsWordFilePath(false);
      }
    }

  };

  const handleRadiologistValidation = (studyData) => {
    setDisablePenEye(false);
    setDisableRaiseAlert(false);
    switch (true) {
      //Submitted study
      case studyData.reportDoneStatus == 2:
        handleSubmitValidation(
          studyData.reportingDoctor,
          studyData.allowDownloadReport,
          studyData.peerReviewAssignment
        );
        handleWordValidation(studyData.showWord, studyData.reportingDoctor, studyData.peerReviewAssignment?.reviewerId);
        //handleSaveValidation(studyData.reportingDoctor);
        break;
      case studyData.reportDoneStatus === REPORTDONESTATUS.QC_FIX:
        if (studyData.qcfixerId === userId) {
          setDisableQcReason(false);
          setDisableSubmit(false);
          setDisableSubmitUntilQCReasonClick(true);
          if (studyData.showWord != undefined && studyData.showWord == true) {
            setShowMsWord(true);
          }
        } else {
          handleSubmitValidation(
            studyData.reportingDoctor,
            studyData.allowDownloadReport
          );
          handleWordValidation(studyData.showWord, studyData.reportingDoctor);
          // handleSaveValidation(studyData.reportingDoctor);
        }
        setDisableDownload(true);
        setDisablePreview(true);
        break;
      case studyData.reportDoneStatus === REPORTDONESTATUS.PRELIMINARY_QC_FIX:
        if (studyData.qcfixerId === userId) {
          setDisableQcReason(false);
          setDisableSave(false);
          setDisableSubmit(true);
          setDisableSubmitUntilQCReasonClick(true);
          if (studyData.showWord != undefined && studyData.showWord == true) {
            setShowMsWord(true);
          }
        } else {
          handleSubmitValidation(
            studyData.reportingDoctor,
            studyData.allowDownloadReport
          );
          handleWordValidation(studyData.showWord, studyData.reportingDoctor);
        }
        setDisableDownload(true);
        setDisablePreview(true);
        break;
      case studyData.reportDoneStatus === REPORTDONESTATUS.PRELIMINARY_QC_VERIFY:
        if (studyData.qcfixerId === userId) {
          setDisableSave(false);
          setDisableSubmit(true);
          if (studyData.showWord != undefined && studyData.showWord == true) {
            setShowMsWord(true);
          }
        } else {
          handleSubmitValidation(
            studyData.reportingDoctor,
            studyData.allowDownloadReport
          );
          handleWordValidation(studyData.showWord, studyData.reportingDoctor);
        }
        setDisableDownload(true);
        setDisablePreview(true);
        break;
      //Saved study
      case studyData.reportDoneStatus === 1:
        handleSaveValidation(studyData.reportingDoctor, studyData.reviewPendingForCTAndMR);
        handleWordValidation(studyData.showWord, studyData.reportingDoctor);
        break;
      default:
        handleUnreportedValidation(studyData.reportingDoctor, studyData.reviewPendingForCTAndMR);
        handleWordValidation(studyData.showWord, studyData.reportingDoctor);
        break;
    }

  };

  const handleOtherRoleValidation = (
    reportDoneStatus,
    qcReviewerId,
    qcVerifierId,
    allowDownloadReportFlag,
    isWordAccess,
    enableSubmitForTypist,
    typistId
  ) => {
    setDisableSubmit(true);
    setDisableSave(true);
    setDisableDownload(true);
    setDisablePreview(true);
    if (
      reportDoneStatus == 2 &&
      (allowDownloadReportFlag || roles.includes(USERTYPES.ADMIN))
    ) {

      setDisableDownload(false);
      setDisablePreview(false);

    } else {
      // setDisableDownload(true);
      // setDisablePreview(true);
      if (roles.includes(USERTYPES.TYPIST)) {
        setDisableDownload(true);
        setDisableSubmit(enableSubmitForTypist ? false : true);
        if (typistId === userId) {
          if (
            reportDoneStatus == 0 ||
            reportDoneStatus == 1 ||
            reportDoneStatus == REPORTDONESTATUS.DRAFT
          ) {
            setDisableSave(false);
            if (isWordAccess != undefined && isWordAccess == true) {
              setShowMsWord(true);
            }
            if (
              reportDoneStatus == 1 ||
              reportDoneStatus == REPORTDONESTATUS.DRAFT
            )
              setDisablePreview(false);
          }
        }
        else {
          setDisableSave(true);
          setShowMsWord(false);
          setDisableSubmit(true);
        }

      }
      if (qcReviewer) {
        if (reportDoneStatus === REPORTDONESTATUS.QC_REVIEW ||
            reportDoneStatus === REPORTDONESTATUS.PRELIMINARY_QC_REVIEW) {
          if (qcReviewerId != undefined && qcReviewerId === userId) {
            setDisableQCPass(false);
            setDisableQCReturn(false);
            setDisableRaiseAlert(false);
            if (isWordAccess != undefined && isWordAccess == true) {
              setShowMsWord(true);
            }
          }
        } else if (reportDoneStatus === REPORTDONESTATUS.QC_VERIFY ||
            reportDoneStatus === REPORTDONESTATUS.PRELIMINARY_QC_VERIFY) {
          if (qcVerifierId != undefined && qcVerifierId === userId) {
            setDisableQCPass(false);
            setDisableQCReturn(false);
            setDisableRaiseAlert(false);
            if (isWordAccess != undefined && isWordAccess == true) {
              setShowMsWord(true);
            }
          }
        }
      }
      if (roles.includes(USERTYPES.FIRMDOCTOR) && showSavedReport) {
        if (reportDoneStatus == 1)
          setDisablePreview(false);
      }
    }
  };

  const handleSubmitValidation = (reportingDoctor, allowDownloadReportFlag, peerReviewAssignment) => {
    if (allowDownloadReportFlag) {
      setDisableDownload(false);
      setDisablePreview(false);
    } else {
      setDisableDownload(true);
      setDisablePreview(true);
    }
    if (reportingDoctor == username && peerReviewAssignment?.reviewerId == null) {
      setDisableSubmit(false);
      setDisableSave(true);
      setDisablePreview(false);
    } else if (userId == peerReviewAssignment?.reviewerId && peerReviewAssignment?.reviewStatus == 1) {
      setDisableDownload(true);
      setDisablePreview(true);
      setDisableSubmit(false);
      setDisableSave(true);
      setDisableRaiseAlert(true);
    } else if (userId == peerReviewAssignment?.reviewerId && peerReviewAssignment?.reviewStatus == 2) {
      setDisableDownload(false);
      setDisablePreview(true);
      setDisableSubmit(true);
      setDisableSave(true);
      setDisableRaiseAlert(true);
    } else {
      setDisableSubmit(true);
      setDisableSave(true);
    }

    if(disableSubmitforResident){
      setDisableSubmit(true);
    }

    if(roles[0] === USERTYPES.TYPIST && !typistAllowSubmit){
      setDisableSubmit(true);
    }

    if(isBvpPlatform) {
      if(reportingDoctor !== username){
        setDisableSave(true);
      }
    }

    if(PlatformHelper.isFahes()){
      if(reportingDoctor !== username){
        setDisableSubmit(true);
        setDisablePositiveNegative(true);
      }
    }
  };

  const handleSaveValidation = (reportingDoctor, reviewPendingForCTAndMR) => {
    setDisableDownload(true);
    setDisablePreview(true);
    if (reportingDoctor == username) {
      setDisableSubmit(false);
      setDisableSave(false);
      setDisablePreview(false);
    } else {
      setDisableSubmit(true);
      setDisableSave(false);
    }

    if(disableSubmitforResident){
      setDisableSubmit(true);
    }

    if(roles[0] === USERTYPES.TYPIST && !typistAllowSubmit){
      setDisableSubmit(true);
    }

    if(isBvpPlatform) {
      if(reviewPendingForCTAndMR){
        setDisableSubmit(true);
      }

      if(reportingDoctor !== username){
        setDisableSave(true);
      }
    }

    if(PlatformHelper.isFahes()){
        setDisableSubmit(false);
        setDisablePositiveNegative(false);
    }
  };

  const handleUnreportedValidation = (reportingDoctor, reviewPendingForCTAndMR) => {
    setDisableDownload(true);
    setDisablePreview(true);

    switch (true) {
      case reportingDoctor == username:
        setDisableSubmit(false);
        setDisableSave(false);
        break;
      case reportingDoctor == undefined:
        // setHideLockWarningMessage(true);
        // setTimeout(() => {
        setDisableSubmit(true);
        setDisableSave((getEnv("REACT_APP_VDC_PLATFORM") == "true") ? true : false);
        // }, 1000);
        break;
      default:
        setDisableSubmit(true);
        setDisableSave((getEnv("REACT_APP_VDC_PLATFORM") == "true") ? true : false);

        break;
    }

    if(disableSubmitforResident){
      setDisableSubmit(true);
    }

    if(roles[0] === USERTYPES.TYPIST && !typistAllowSubmit){
      setDisableSubmit(true);
    }

    if(isBvpPlatform) {
      if(reviewPendingForCTAndMR){
        setDisableSubmit(true);
      }

      if(reportingDoctor !== username){
        setDisableSave(true);
      }
    }
    if(PlatformHelper.isFahes()){
       if(reportingDoctor === username && !reviewPendingForCTAndMR){
        setDisableSubmit(false);
        setDisablePositiveNegative(false);
       }
    }
    
  };

  const handleWordValidation = (isWordAccess, reportingDoctor, reviewerId) => {
    if (isWordAccess && (reportingDoctor == username || userId == reviewerId)) {
      setShowMsWord(true);
    } else {
      setShowMsWord(false);
    }
  };
  const refreshReport = () => {
    // setLoaderMessage("Refreshing report...");
    setLoaderRunning(true);
    ref.current.continuousStart();
    getData(true);
  };

  const fetchS10Report = async () => {
    // setLoaderMessage("Fetching S10 Report...");
    setLoaderRunning(true);
    ref.current.continuousStart();

    try {
      let allAddedTabs = patientReports;
      const response = await getS10ReportData(studyParentId);
      if (response.status === 200) {
        let obj = {
          finalReport: response.data.data,
          reportTemplateId: allReportTemplates.reportTemplates[0].id,
          reportTemplateTitle: allReportTemplates.reportTemplates[0].title,
          isSuperSpecialReport: 0,
        };
        const newKey = allReportTemplates.reportTemplates[0].id;

        // Check if the key already exists in allAddedTabs
        const existingTab = allAddedTabs.find((tab) => tab.key === newKey || tab.reportDetails.reportTemplateId === newKey);
        if (!existingTab) {
          allAddedTabs.push({
            key: newKey,
            text: allReportTemplates.reportTemplates[0].title,
            isSuperSpecialReport: 0,
            reportDetails: obj,
          });
        }
        else {
          existingTab.reportDetails.finalReport = obj.finalReport;
          existingTab.reportDetails.report = obj.finalReport;
        }

        setPatientReports(allAddedTabs);
        handleChangeTemplate(allAddedTabs[0]);

        setLoaderRunning(false);
        ref.current.complete();
        showToastv2(TOAST_TYPE.SUCCESS, "S10 Report fetched successfully.");
      }
      else {
        showToastv2(TOAST_TYPE.INFO, response.data.message);
      }
    }
    catch {
      setLoaderRunning(false);
      ref.current.complete();
      showToastv2(TOAST_TYPE.ERROR, "Some Error Occurred.");
    }
    // getData(true);
  };

  const handleRemoveTemplate = (e, removeKey, index) => {
    if(disableEditReport){
      showToastv2(TOAST_TYPE.INFO, "You are not allowed to remove reports.");
      return;
    }
    e.stopPropagation();
    // Drop the removed report's captured-image placements so they don't linger in memory or
    // resurface if the same template is re-added this session. The underlying SC images stay in
    // the library (they live in the Images table, independent of report placement), so removing a
    // report only discards that report's arrangement of them — it never deletes the captures.
    setPatientReports((current) => {
      const removed = current.filter((val) => val.text === removeKey);
      removed.forEach((val) => {
        if (val?.key != null && capturedPagesMapRef.current) {
          delete capturedPagesMapRef.current[val.key];
        }
      });
      return current.filter((val) => val.text !== removeKey);
    });
    markReportAutosaveDirty();
    setHasUnsavedChanges(false);
  };

  useEffect(() => {
    // CASE 1: No report templates left, PDF exists → select PDF
    if (patientReports.length === 0 && studyReportPdf?.isAttached) {
      setStudyReportPdfSelected(true);
      handleChangeTemplate(null);
      return;
    }
     if (patientReports.length === 0 && isexternalStudyReport) {
      handleChangeTemplate(null);
      return;
    }
    // CASE 2: Reports exist and PDF is NOT selected → select last report
    if (patientReports.length > 0 && !studyReportPdfSelected) {
      handleChangeTemplate(patientReports[patientReports.length - 1]);
    }
  }, [
    patientReports,
    studyReportPdf?.isAttached,
    isexternalStudyReport,
    studyReportPdfSelected,
  ]);

  useEffect(() => {
    if (patientReports.length !== 0) {
      return;
    }
    if (snapshotRecoveryModalOpen || snapshotRecoveryReopenVisible) {
      return;
    }
    autosaveDirtyRef.current = false;
    setReportAutosaveDirty(false);
    setReportAutosaveStatus((s) => {
      if (s === "saving") {
        return s;
      }
      return autoSaveReportPreference ? "on" : "off";
    });
  }, [
    patientReports.length,
    autoSaveReportPreference,
    snapshotRecoveryModalOpen,
    snapshotRecoveryReopenVisible,
  ]);

  useEffect(() => {
    if (activeTab == 2) {
      patientReports.map((ele, index) => {
        if (currentActiveTab == ele.text) {
          let tempReportDetails =
            ele.reportDetails == undefined ? ele.report : ele.reportDetails;
          if (ele.reportDetails?.report == undefined) {
            setAddendumModel(ele.reportDetails.addendum);
          } else {
            if (ele.reportDetails.addendum != undefined) {
              setAddendumModel(ele.reportDetails.addendum);
            } else {
              setAddendumModel("");
            }
          }
        }
      });
    } else if (activeTab != 4) {
      patientReports.map((ele, index) => {
        if (currentActiveTab == ele.text) {
          handleChangeTemplate(ele);
        }
      });
    }
  }, [activeTab]);

  const handleModelChange = (model, addendumOrNot) => {
    let obj = { updatedValue: model };
    let hasContentChanged = false;
    patientReports.map((ele, index) => {
      if (currentActiveTab == ele.text) {
        let tempReportDetails =
          ele.reportDetails == undefined ? ele.report : ele.reportDetails;
        if (activeTab == 2) {
          const previousAddendum = tempReportDetails?.addendum ?? "";
          hasContentChanged = hasContentChanged || previousAddendum !== model;
          if (ele.reportDetails?.report == undefined) {
            if (tempReportDetails?.addendum == undefined) {
              tempReportDetails["addendum"] = model;
            } else {
              tempReportDetails.addendum = model;
            }
          } else {
            if (tempReportDetails.addendum == undefined) {
              tempReportDetails["addendum"] = model;
            } else {
              tempReportDetails["addendum"] = model;
            }
          }
        } else {
          const previousReport =
            ele.reportDetails?.report == undefined
              ? tempReportDetails?.finalReport ?? ""
              : tempReportDetails?.report ?? "";
          hasContentChanged = hasContentChanged || previousReport !== model;
          if (ele.reportDetails?.report == undefined) {
            tempReportDetails.finalReport = model;
          } else {
            tempReportDetails.report = model;
          }
        }
        return { ...ele, reportDetails: tempReportDetails };
      } else {
        return ele;
      }
    });

    if (addendumOrNot == true) {
      setAddendumModel(model);
    } else {
      setModel(model);
    }

    
    if (skipNextExternalAutosaveDirtyRef.current) {
      skipNextExternalAutosaveDirtyRef.current = false;
    } else if (hasContentChanged && !(isExternal && userActionLoading)) {
      autosaveDirtyRef.current = true;
      setReportAutosaveDirty(true);
      setAutosaveScheduleVersion((v) => v + 1);
    }
  };

  const idCounterRef = useRef(0);
  const nextIdSuffix = () => {
    idCounterRef.current += 1;
    return idCounterRef.current;
  };
  const randSuffix = () => Math.random().toString(36).slice(2, 8);
  const makePageId = () => `pg_${Date.now()}_${nextIdSuffix()}_${randSuffix()}`;
  const makeImageId = () => `img_${Date.now()}_${nextIdSuffix()}_${randSuffix()}`;
  const CAPTURED_ROWS_PER_PAGE = 3;
  const getCapturedPageCapacity = (columns) => (Number(columns) || 2) * CAPTURED_ROWS_PER_PAGE;

  const addImageReferenceToTemplate = (templateKey, { sopInstanceUid, scImageId, previewUrl, targetPageId, targetIndex } = {}) => {
    if (!templateKey || !sopInstanceUid) return;
    const image = { id: makeImageId(), sopInstanceUid, scImageId, previewUrl };

    const computeUpdated = (existing) => {
      if (!existing || existing.length === 0) {
        return [{ id: makePageId(), columns: 2, images: [image] }];
      }
      const resolvedPageId =
        targetPageId && existing.some((p) => p.id === targetPageId)
          ? targetPageId
          : existing[existing.length - 1].id;
      const targetPage = existing.find((p) => p.id === resolvedPageId);
      const capacity = getCapturedPageCapacity(targetPage?.columns);
      const isAppend = !(typeof targetIndex === "number" && targetIndex >= 0 && targetIndex <= (targetPage?.images?.length || 0));
      if (targetPage && isAppend && targetPage.images.length >= capacity) {
        // Target page is full and this is an append: spill onto a fresh page instead of rejecting.
        // Pack onto the existing last page if it's a different page with room (so repeated adds
        // against the same full page fill one overflow page rather than minting a page per image);
        // otherwise append a new page at the end inheriting the target's column layout.
        const lastPage = existing[existing.length - 1];
        if (
          lastPage.id !== resolvedPageId
          && lastPage.images.length < getCapturedPageCapacity(lastPage.columns)
        ) {
          return existing.map((p) =>
            (p.id === lastPage.id ? { ...p, images: [...(p.images || []), image] } : p));
        }
        return [
          ...existing,
          { id: makePageId(), columns: targetPage.columns, images: [image] },
        ];
      }
      return existing.map((p) => {
        if (p.id !== resolvedPageId) return p;
        const imgs = [...(p.images || [])];
        if (typeof targetIndex === "number" && targetIndex >= 0 && targetIndex <= imgs.length) {
          imgs.splice(targetIndex, 0, image);
        } else {
          imgs.push(image);
        }
        return { ...p, images: imgs };
      });
    };

    if (capturedPagesOwnerKeyRef.current === templateKey) {
      setCapturedPages((prev) => {
        const updated = computeUpdated(prev);
        capturedPagesMapRef.current[templateKey] = updated;
        return updated;
      });
    } else {
      const updated = computeUpdated(capturedPagesMapRef.current[templateKey] || []);
      capturedPagesMapRef.current[templateKey] = updated;
    }
    autosaveDirtyRef.current = true;
    setReportAutosaveDirty(true);
    setAutosaveScheduleVersion((v) => v + 1);
  };

  // Batch-place a list of library images onto a report, starting at `startPageId` (or the last
  // page when not given / not found). The start page is filled to capacity first, then overflow
  // images spill into fresh pages inserted right after it — each new page inheriting the start
  // page's column layout (capacity = columns * CAPTURED_ROWS_PER_PAGE). Unlike calling
  // addImageReferenceToTemplate in a loop with a fixed targetPageId, this keeps overflow images
  // packed onto contiguous pages instead of giving each its own page.
  const addAllImagesToTemplate = (templateKey, items, startPageId) => {
    if (!templateKey || !Array.isArray(items) || items.length === 0) return;

    const computeUpdated = (existing) => {
      const pages = (existing && existing.length > 0)
        ? existing.map((p) => ({ ...p, images: [...(p.images || [])] }))
        : [{ id: makePageId(), columns: 2, images: [] }];

      let startIdx = startPageId ? pages.findIndex((p) => p.id === startPageId) : -1;
      if (startIdx === -1) startIdx = pages.length - 1;

      const columns = pages[startIdx].columns;
      let curIdx = startIdx;
      items.forEach((it) => {
        if (!it || !it.sopInstanceUid) return;
        if (pages[curIdx].images.length >= getCapturedPageCapacity(pages[curIdx].columns)) {
          pages.splice(curIdx + 1, 0, { id: makePageId(), columns, images: [] });
          curIdx += 1;
        }
        pages[curIdx].images.push({
          id: makeImageId(),
          sopInstanceUid: it.sopInstanceUid,
          scImageId: it.scImageId,
          previewUrl: it.previewUrl,
        });
      });
      return pages;
    };

    if (capturedPagesOwnerKeyRef.current === templateKey) {
      setCapturedPages((prev) => {
        const updated = computeUpdated(prev);
        capturedPagesMapRef.current[templateKey] = updated;
        return updated;
      });
    } else {
      const updated = computeUpdated(capturedPagesMapRef.current[templateKey] || []);
      capturedPagesMapRef.current[templateKey] = updated;
    }
    autosaveDirtyRef.current = true;
    setReportAutosaveDirty(true);
    setAutosaveScheduleVersion((v) => v + 1);
  };

  // Convert a server CapturedPageDto list into the in-memory page shape used by the UI.
  const serverPagesToLocal = (pages) => {
    if (!Array.isArray(pages)) return [];
    // The library entry is authoritative for how to render each SC (newly-captured PNGs and
    // pre-existing secondary captures / adv key images have different preview endpoints), so
    // prefer its previewUrl over the server-derived one when available.
    const libByUid = new Map((scDicomLibrary || []).map((it) => [it.sopInstanceUid, it]));
    return [...pages]
      .sort((a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0))
      .map((p) => ({
        id: p.pageKey,
        columns: p.pageColumns,
        images: (p.images || [])
          .slice()
          .sort((a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0))
          .map((img) => {
            const lib = libByUid.get(img.sopInstanceUid);
            return {
              id: img.imageKey,
              sopInstanceUid: img.sopInstanceUid,
              scImageId: img.scImageId ?? lib?.scImageId,
              previewUrl: lib?.previewUrl || img.previewUrl,
            };
          }),
      }));
  };

  // Replace the first report's captured pages with what the server returned.
  const applyServerCapturedPagesToFirstReport = (serverPages) => {
    const firstReportKey = (patientReports && patientReports[0]?.key) || activeTabKey;
    if (!firstReportKey) return;
    const localPages = serverPagesToLocal(serverPages);
    capturedPagesMapRef.current[firstReportKey] = localPages;
    if (capturedPagesOwnerKeyRef.current === firstReportKey) {
      setCapturedPages(localPages);
    }
    // Note: don't flag a "new capture" here — this also runs on popup-open refresh,
    // which would falsely bump the badge. The capture entry points own that signal.
    setAutosaveScheduleVersion((v) => v + 1);
  };

  // Apply the per-report effective layout returned by the server (studyReportId -> pages). Each
  // report column is populated from its OWN layout, so the study-wide default (which belongs to
  // the first report only) is never mis-attributed to a newly added or reordered report — the bug
  // where a second report mirrored the first report's captured images. Reports with no server row
  // (e.g. added in-session, not yet saved) keep their existing in-memory bucket untouched.
  const applyServerCapturedPagesByReport = (byReport) => {
    if (!byReport || typeof byReport !== "object") return;
    const liveOwner = capturedPagesOwnerKeyRef.current;
    const entries = Object.entries(byReport);
    const tabKeys = new Set((patientReports || []).map((r) => String(r?.key)).filter(Boolean));
    entries.forEach(([reportId, serverPages]) => {
      // Server keys are studyReportId strings; the report tab `key` is normally that same id
      // (ele.id). But in the regenerate / agentic-LLM flow they diverge (see fallback below) — an
      // id no tab reads. Skip storing those: leaving them in the map doesn't make them render
      // anywhere, it only leaks into getLibraryItemUsage as a phantom "Used in" row (Key Images
      // popup shows a "Report" entry with no matching report/page) once folded onto a real tab below.
      if (!tabKeys.has(String(reportId))) return;
      const localPages = serverPagesToLocal(serverPages);
      capturedPagesMapRef.current[reportId] = localPages;
      if (liveOwner != null && String(liveOwner) === String(reportId)) {
        setCapturedPages(localPages);
      }
    });

    // Key-identity fallback for the regenerate / agentic-LLM flow. There the visible report tab is
    // keyed by the agentic template id (getData's injectAgentic branch pushes `key: rt.id`), but the
    // server keys the effective layout by the persisted study_report row id — so every bucket set
    // above lands under an id no tab ever reads, and the popup shows an empty page even though the
    // server returned the captures. When exactly one report came back and NONE of the server keys
    // match a current report tab, fold that report's pages onto the active/first tab so they render.
    // Restricted to the single-report case so a genuine multi-report study is never collapsed.
    const anyKeyMatchesTab = entries.some(([reportId]) => tabKeys.has(String(reportId)));
    if (!anyKeyMatchesTab && entries.length === 1) {
      // Fold onto the FIRST report, not the live/active one. The Images popup's default
      // "End of report" view renders the first report's bucket only, so folding onto whichever tab
      // happens to be active (e.g. a template the user just added, which becomes active) hides the
      // study's captures behind an off-screen bucket — the popup then shows an empty page with
      // every library image still marked "Available".
      const targetKey = (patientReports && patientReports[0]?.key) || liveOwner || activeTabKey;
      if (targetKey) {
        const localPages = serverPagesToLocal(entries[0][1]);
        capturedPagesMapRef.current[targetKey] = localPages;
        if (
          (liveOwner != null && String(liveOwner) === String(targetKey)) ||
          String(activeTabKey) === String(targetKey)
        ) {
          setCapturedPages(localPages);
        }
      }
    }

    setAutosaveScheduleVersion((v) => v + 1);
  };

  // Record a freshly captured SC as "pending": bump the popup badge immediately and remember
  // its SOP UID. The image is pushed to the acceptor and ingested into object storage
  // asynchronously, so it isn't renderable yet — the popup shows a loader, polls the library,
  // and auto-places it once it appears (see resolvePendingCapture / CapturedImagesTab).
  const markPendingCapture = (sopInstanceUid) => {
    if (!sopInstanceUid) return;
    setPendingCaptureSops((prev) => (prev.includes(sopInstanceUid) ? prev : [...prev, sopInstanceUid]));
    setHasNewCapturedImage(true);
    setNewCapturedImageCount((c) => c + 1);
  };

  // Drop a SOP UID from the pending set once it has been resolved (placed on a page or timed out).
  const resolvePendingCapture = (sopInstanceUid) => {
    if (!sopInstanceUid) return;
    setPendingCaptureSops((prev) => prev.filter((s) => s !== sopInstanceUid));
  };

  // Refresh first report's captured pages from the DB. Called when the popup opens
  // so users see captures that were persisted in earlier sessions or other tabs.
  const refreshCapturedPagesFromServer = async () => {
    if (!studyId) return;
    try {
      // Prefer the per-report effective layout so every report column reflects its own pages.
      const byReportRes = await getStudyCapturedPagesByReport(studyId);
      const byReportData =
        byReportRes && byReportRes.result === "SUCCESS" ? byReportRes.data : null;
      if (byReportData && typeof byReportData === "object" && Object.keys(byReportData).length > 0) {
        applyServerCapturedPagesByReport(byReportData);
      } else {
        // Empty map (or older backend): the study has no persisted per-report layout — e.g. the
        // study_report row has not been created yet (study loaded, report not drafted/saved). Fall
        // back to the first-report effective layout, which the backend derives study-wide from the
        // captures even when no report row exists, so freshly captured images still auto-place.
        const res = await getStudyCapturedPages(studyId);
        if (res && res.result === "SUCCESS" && Array.isArray(res.data)) {
          applyServerCapturedPagesToFirstReport(res.data);
        }
      }
    } catch (err) {
      console.error("Failed to fetch captured pages", err);
    }
    try {
      const flagRes = await getStudyKeyImageTitleFlag(studyId);
      if (flagRes && flagRes.result === "SUCCESS" && flagRes.data) {
        setShowKeyImageTitle(flagRes.data.showKeyImageTitle !== false);
        setAppendCapturedImagesAtEnd(flagRes.data.appendCapturedImagesAtEnd !== false);
      }
    } catch (err) {
      console.error("Failed to fetch key-image-title flag", err);
    }
  };

  // Persist the "Images" popup state in a single call — independent of the report save/submit
  // flow. Saves the captured-image layout for every report (pages, columns, image order across
  // reports) plus the per-study "show key image title" flag, without touching report content.
  // Layout is keyed by studyReportId (the patientReports `key`, i.e. the StudyReport row id
  // loaded in getData). Reports added in-session but not yet saved have no matching row and are
  // skipped server-side — their captured pages still persist on the next full report save.
  const persistCapturedPages = async (showKeyImageTitleFlag, appendAtEndFlag) => {
    if (typeof showKeyImageTitleFlag === "boolean") setShowKeyImageTitle(showKeyImageTitleFlag);
    const appendAtEnd = typeof appendAtEndFlag === "boolean" ? appendAtEndFlag : appendCapturedImagesAtEnd;
    if (typeof appendAtEndFlag === "boolean") setAppendCapturedImagesAtEnd(appendAtEndFlag);
    if (!studyId) return null;
    // Use the live `capturedPages` for the currently-owned tab; the map for the rest.
    const liveOwner = capturedPagesOwnerKeyRef.current;
    const allMap = { ...(capturedPagesMapRef.current || {}) };
    if (liveOwner) allMap[liveOwner] = capturedPages;

    // Resolve each report tab's template id. The layout is now persisted keyed by
    // (study, reportTemplateId), which is save-state-independent, so a layout can be saved even
    // before the report has a StudyReport row. The tab `key` is the StudyReport row id once the
    // report is saved, but only the report template id while it's still an unsaved template tab.
    const templateIdByTabKey = {};
    (patientReports || []).forEach((pr) => {
      if (pr == null || pr.key == null) return;
      const tplId = pr.reportDetails?.reportTemplateId ?? Number(pr.key);
      if (Number.isFinite(Number(tplId))) templateIdByTabKey[pr.key] = Number(tplId);
    });

    const reports = Object.entries(allMap)
      .map(([key, pages]) => {
        const keyNum = Number(key);
        const reportTemplateId = templateIdByTabKey[key] ?? (Number.isFinite(keyNum) ? keyNum : null);
        // Send studyReportId only when the tab key is a real StudyReport row id (distinct from the
        // template id). For an unsaved template tab the key IS the template id, so we leave
        // studyReportId null and let the backend persist the layout unlinked (study + template).
        const studyReportId =
          Number.isFinite(keyNum) && reportTemplateId != null && keyNum !== reportTemplateId ? keyNum : null;
        return {
          key,
          studyReportId,
          reportTemplateId,
          capturedPages: (pages || []).map((p, pi) => ({
            pageKey: p.id,
            pageColumns: p.columns,
            displayOrder: pi,
            images: (p.images || []).map((img, ii) => ({
              imageKey: img.id,
              sopInstanceUid: img.sopInstanceUid,
              scImageId: img.scImageId,
              displayOrder: ii,
            })),
          })),
        };
      })
      // A report we can't resolve a template for can't be keyed server-side — skip it.
      .filter((r) => r.reportTemplateId != null);

    try {
      const res = await updateStudyCapturedPages(studyId, reports, showKeyImageTitleFlag, appendAtEnd);
      // Persisting from the popup makes each of these reports' layouts authoritative. Mirror the
      // server flag locally (keyed by the tab key) so a subsequent report save round-trips
      // capturedPagesCustomized=true and the backend keeps rendering this arrangement.
      if (res?.result !== "FAILURE") {
        reports.forEach(({ key }) => {
          capturedPagesCustomizedMapRef.current[key] = true;
        });
      }
      return res;
    } catch (err) {
      console.error("Failed to persist captured pages", err);
      return null;
    }
  };

  const removeCapturedImageFromReport = (imageId) => {
    setCapturedPages((prev) => {
      const updated = prev.map((p) => ({
        ...p,
        images: p.images.filter((img) => img.id !== imageId),
      }));
      const ownerKey = capturedPagesOwnerKeyRef.current;
      if (ownerKey) {
        capturedPagesMapRef.current[ownerKey] = updated;
      }
      return updated;
    });
    autosaveDirtyRef.current = true;
  };

  const reorderImageInCapturedPage = (pageId, fromIndex, toIndex) => {
    setCapturedPages((prev) =>
      prev.map((p) => {
        if (p.id !== pageId) return p;
        if (
          fromIndex < 0 ||
          toIndex < 0 ||
          fromIndex >= p.images.length ||
          toIndex >= p.images.length
        ) {
          return p;
        }
        const images = [...p.images];
        const [moved] = images.splice(fromIndex, 1);
        images.splice(toIndex, 0, moved);
        return { ...p, images };
      }),
    );
  };

  const moveImageBetweenPages = (fromPageId, fromIndex, toPageId, toIndex) => {
    setCapturedPages((prev) => {
      const fromPage = prev.find((p) => p.id === fromPageId);
      if (!fromPage || fromIndex < 0 || fromIndex >= fromPage.images.length) return prev;
      const image = fromPage.images[fromIndex];
      return prev.map((p) => {
        if (p.id === fromPageId && p.id === toPageId) {
          const images = [...p.images];
          images.splice(fromIndex, 1);
          const insertAt = toIndex < 0 ? images.length : Math.min(toIndex, images.length);
          images.splice(insertAt, 0, image);
          return { ...p, images };
        }
        if (p.id === fromPageId) {
          const images = [...p.images];
          images.splice(fromIndex, 1);
          return { ...p, images };
        }
        if (p.id === toPageId) {
          const images = [...p.images];
          const insertAt = toIndex < 0 ? images.length : Math.min(toIndex, images.length);
          images.splice(insertAt, 0, image);
          return { ...p, images };
        }
        return p;
      });
    });
  };

  const addCapturedPage = (afterPageId) => {
    const newPage = { id: makePageId(), columns: 2, images: [] };
    setSelectedCapturedPageId(newPage.id);
    if (afterPageId == null) {
      setCapturedPages((prev) => [...prev, newPage]);
    } else {
      setCapturedPages((prev) => {
        const idx = prev.findIndex((p) => p.id === afterPageId);
        if (idx === -1) return [...prev, newPage];
        const next = [...prev];
        next.splice(idx + 1, 0, newPage);
        return next;
      });
    }
  };

  const removeCapturedPage = (pageId) => {
    if (pageId == null) return;
    setSelectedCapturedPageId((prev) => (prev === pageId ? null : prev));
    setCapturedPages((prev) => {
      const updated = prev.filter((p) => p.id !== pageId);
      const ownerKey = capturedPagesOwnerKeyRef.current;
      if (ownerKey) {
        capturedPagesMapRef.current[ownerKey] = updated;
      }
      return updated;
    });
    autosaveDirtyRef.current = true;
  };

  const bulkLoadCapturedPagesFromLibrary = (templateKey, { items = [], mode = "append" } = {}) => {
    if (!templateKey || !Array.isArray(items) || items.length === 0) return;
    const COLUMNS = 2;
    const ROWS = 3;
    const SLOTS = COLUMNS * ROWS;

    const toImage = (it) => ({
      id: makeImageId(),
      sopInstanceUid: it.sopInstanceUid,
      scImageId: it.scImageId,
      previewUrl: it.previewUrl,
    });

    const buildNewPagesFrom = (remaining) => {
      const pages = [];
      for (let i = 0; i < remaining.length; i += SLOTS) {
        const slice = remaining.slice(i, i + SLOTS);
        pages.push({
          id: makePageId(),
          columns: COLUMNS,
          images: slice.map(toImage),
        });
      }
      return pages;
    };

    const compute = (existing) => {
      if (mode === "replace" || !existing || existing.length === 0) {
        const newPages = buildNewPagesFrom(items);
        return { updated: newPages, lastPageId: newPages.length > 0 ? newPages[newPages.length - 1].id : null };
      }

      // Append mode: first try filling the selected page (or the last page) up to
      // its capacity (page.columns * ROWS) before creating new pages.
      const targetId = selectedCapturedPageId && existing.some((p) => p.id === selectedCapturedPageId)
        ? selectedCapturedPageId
        : existing[existing.length - 1].id;
      const targetIdx = existing.findIndex((p) => p.id === targetId);
      const target = existing[targetIdx];
      const targetCapacity = Math.max(0, (target.columns || COLUMNS) * ROWS - target.images.length);
      const fillCount = Math.min(targetCapacity, items.length);

      let updatedExisting = existing;
      if (fillCount > 0) {
        const filled = {
          ...target,
          images: [...target.images, ...items.slice(0, fillCount).map(toImage)],
        };
        updatedExisting = existing.map((p, i) => (i === targetIdx ? filled : p));
      }

      const remaining = items.slice(fillCount);
      const newPages = buildNewPagesFrom(remaining);
      const updated = [...updatedExisting, ...newPages];
      const lastPageId = newPages.length > 0 ? newPages[newPages.length - 1].id : targetId;
      return { updated, lastPageId };
    };

    let finalLastPageId = null;
    if (capturedPagesOwnerKeyRef.current === templateKey) {
      setCapturedPages((prev) => {
        const { updated, lastPageId } = compute(prev);
        finalLastPageId = lastPageId;
        capturedPagesMapRef.current[templateKey] = updated;
        return updated;
      });
    } else {
      const { updated, lastPageId } = compute(capturedPagesMapRef.current[templateKey] || []);
      finalLastPageId = lastPageId;
      capturedPagesMapRef.current[templateKey] = updated;
    }
    if (finalLastPageId) setSelectedCapturedPageId(finalLastPageId);
    autosaveDirtyRef.current = true;
    setReportAutosaveDirty(true);
    setAutosaveScheduleVersion((v) => v + 1);
  };

  // Live, UI-only title update: rewrites the in-memory library title so every place that
  // derives a label from it (preview panel, library row, page cells) reflects the edit as
  // the user types. No API call and no autosave trigger — persistence happens on Enter
  // (setLibraryItemTitle) or on the final Save.
  const setLibraryItemTitleLocal = (sopInstanceUid, title) => {
    if (!sopInstanceUid) return;
    const cleaned = (title || "").trim();
    setScDicomLibrary((prev) =>
      (prev || []).map((it) =>
        it.sopInstanceUid === sopInstanceUid ? { ...it, title: cleaned } : it,
      ),
    );
  };

  const setLibraryItemTitle = (sopInstanceUid, title) => {
    if (!sopInstanceUid) return;
    const cleaned = (title || "").trim();
    if (!cleaned) return;
    const existing = (scDicomLibrary || []).find((it) => it.sopInstanceUid === sopInstanceUid);
    setScDicomLibrary((prev) =>
      (prev || []).map((it) =>
        it.sopInstanceUid === sopInstanceUid ? { ...it, title: cleaned } : it,
      ),
    );
    // If this item is tracked as an Advanced Viewer key image, persist the title there too.
    if (existing && existing.imageId != null && studyId) {
      updateAdvKeyImagesAPI(studyId, [
        { imageId: existing.imageId, isEnabled: existing.enabled !== false, title: cleaned, imageURL: existing.imageURL || "" },
      ]).catch((e) => console.error("Failed to persist adv key image title", e));
    }
    autosaveDirtyRef.current = true;
    setReportAutosaveDirty(true);
    setAutosaveScheduleVersion((v) => v + 1);
  };

  const removeLibraryItem = (sopInstanceUid) => {
    if (!sopInstanceUid) return;
    const existing = (scDicomLibrary || []).find((it) => it.sopInstanceUid === sopInstanceUid);
    setScDicomLibrary((prev) => (prev || []).filter((it) => it.sopInstanceUid !== sopInstanceUid));
    // Soft-delete by clearing the Advanced Viewer enabled flag on the backend if tracked there.
    if (existing && existing.imageId != null && studyId) {
      updateAdvKeyImagesAPI(studyId, [
        { imageId: existing.imageId, isEnabled: false, title: existing.title || "Image", imageURL: existing.imageURL || "" },
      ]).catch((e) => console.error("Failed to disable adv key image", e));
    }

    const stripFromPages = (pages) =>
      (pages || []).map((p) => ({
        ...p,
        images: (p.images || []).filter((img) => img.sopInstanceUid !== sopInstanceUid),
      }));

    Object.keys(capturedPagesMapRef.current || {}).forEach((tplKey) => {
      capturedPagesMapRef.current[tplKey] = stripFromPages(capturedPagesMapRef.current[tplKey]);
    });

    setCapturedPages((prev) => {
      const updated = stripFromPages(prev);
      const ownerKey = capturedPagesOwnerKeyRef.current;
      if (ownerKey) capturedPagesMapRef.current[ownerKey] = updated;
      return updated;
    });

    autosaveDirtyRef.current = true;
    setReportAutosaveDirty(true);
    setAutosaveScheduleVersion((v) => v + 1);
  };

  const getLibraryItemUsage = (sopInstanceUid) => {
    if (!sopInstanceUid) return [];
    const usage = [];
    const liveOwner = capturedPagesOwnerKeyRef.current;
    const allMap = { ...(capturedPagesMapRef.current || {}) };
    if (liveOwner) allMap[liveOwner] = capturedPages;
    Object.entries(allMap).forEach(([tplKey, pages]) => {
      (pages || []).forEach((p, pageIdx) => {
        (p.images || []).forEach((img) => {
          if (img.sopInstanceUid === sopInstanceUid) {
            usage.push({ templateKey: tplKey, pageId: p.id, pageIndex: pageIdx });
          }
        });
      });
    });
    return usage;
  };

  const moveCapturedImageAcrossTemplates = (
    fromTemplateKey,
    fromPageId,
    imageId,
    toTemplateKey,
    toPageId,
    toIndex,
  ) => {
    if (!fromTemplateKey || !toTemplateKey) return;

    const readPages = (key) =>
      capturedPagesOwnerKeyRef.current === key
        ? capturedPages
        : capturedPagesMapRef.current[key] || [];

    const writePages = (key, pages) => {
      capturedPagesMapRef.current[key] = pages;
      if (capturedPagesOwnerKeyRef.current === key) setCapturedPages(pages);
    };

    if (fromTemplateKey === toTemplateKey) {
      const pages = readPages(fromTemplateKey).map((p) => ({ ...p, images: [...(p.images || [])] }));
      const fromPage = pages.find((p) => p.id === fromPageId);
      if (!fromPage) return;
      const fromIdx = fromPage.images.findIndex((img) => img.id === imageId);
      if (fromIdx < 0) return;
      const [moved] = fromPage.images.splice(fromIdx, 1);
      const targetPage = pages.find((p) => p.id === toPageId) || pages[pages.length - 1];
      if (!targetPage) return;
      const insertAt = typeof toIndex === "number" && toIndex >= 0 ? Math.min(toIndex, targetPage.images.length) : targetPage.images.length;
      targetPage.images.splice(insertAt, 0, moved);
      writePages(fromTemplateKey, pages);
      autosaveDirtyRef.current = true;
      setReportAutosaveDirty(true);
      setAutosaveScheduleVersion((v) => v + 1);
      return;
    }

    const fromPages = readPages(fromTemplateKey).map((p) => ({ ...p, images: [...(p.images || [])] }));
    const fromPage = fromPages.find((p) => p.id === fromPageId);
    if (!fromPage) return;
    const fromIdx = fromPage.images.findIndex((img) => img.id === imageId);
    if (fromIdx < 0) return;
    const [moved] = fromPage.images.splice(fromIdx, 1);
    writePages(fromTemplateKey, fromPages);

    addImageReferenceToTemplate(toTemplateKey, {
      sopInstanceUid: moved.sopInstanceUid,
      scImageId: moved.scImageId,
      previewUrl: moved.previewUrl,
      targetPageId: toPageId,
      targetIndex: toIndex,
    });
  };

  // Re-flow a report's captured images across its pages after one page's column count changes.
  // Capacity is per-page (columns * CAPTURED_ROWS_PER_PAGE), so changing a single page's columns
  // can leave pages over- or under-filled (e.g. 6 images at 2 cols = one full page; switch to 1 col
  // and that page would hold 6 rows). We treat the report's images as one ordered stream and
  // greedily refill each page to ITS OWN capacity in page order: overflow spills into fresh pages
  // appended at the end (inheriting the edited page's new column count), and pages packed empty at
  // the tail are dropped (always keeping at least one). No image is lost — only repositioned — so
  // every page stays within the 3-row limit and the popup keeps matching the printed report.
  const reflowCapturedPagesForColumns = (pages, pageId, safeColumns) => {
    if (!Array.isArray(pages) || pages.length === 0) return pages;
    const withCols = pages.map((p) => (p.id === pageId ? { ...p, columns: safeColumns } : p));
    const stream = withCols.flatMap((p) => p.images || []);
    const result = [];
    let cursor = 0;
    withCols.forEach((p) => {
      const cap = getCapturedPageCapacity(p.columns);
      const slice = stream.slice(cursor, cursor + cap);
      cursor += slice.length;
      result.push({ ...p, images: slice });
    });
    // Images still unplaced (capacity shrank) spill into fresh pages at the edited column count.
    while (cursor < stream.length) {
      const slice = stream.slice(cursor, cursor + getCapturedPageCapacity(safeColumns));
      cursor += slice.length;
      result.push({ id: makePageId(), columns: safeColumns, images: slice });
    }
    // Drop pages emptied by packing upward (capacity grew), but always keep at least one page.
    let end = result.length;
    while (end > 1 && (result[end - 1].images || []).length === 0) end -= 1;
    return result.slice(0, end);
  };

  const setCapturedPageColumns = (pageId, columns) => {
    const safe = Math.max(1, Math.min(columns || 2, 4));
    setCapturedPages((prev) => reflowCapturedPagesForColumns(prev, pageId, safe));
  };

  const addCapturedPageForTemplate = (templateKey, afterPageId) => {
    if (!templateKey) return;
    if (capturedPagesOwnerKeyRef.current === templateKey) {
      addCapturedPage(afterPageId);
      autosaveDirtyRef.current = true;
      setReportAutosaveDirty(true);
      setAutosaveScheduleVersion((v) => v + 1);
      return;
    }
    const newPage = { id: makePageId(), columns: 2, images: [] };
    const prev = capturedPagesMapRef.current[templateKey] || [];
    let updated;
    if (afterPageId == null) {
      updated = [...prev, newPage];
    } else {
      const idx = prev.findIndex((p) => p.id === afterPageId);
      if (idx === -1) {
        updated = [...prev, newPage];
      } else {
        updated = [...prev];
        updated.splice(idx + 1, 0, newPage);
      }
    }
    capturedPagesMapRef.current[templateKey] = updated;
    autosaveDirtyRef.current = true;
    setReportAutosaveDirty(true);
    setAutosaveScheduleVersion((v) => v + 1);
  };

  const removeCapturedPageForTemplate = (templateKey, pageId) => {
    if (!templateKey || pageId == null) return;
    if (capturedPagesOwnerKeyRef.current === templateKey) {
      removeCapturedPage(pageId);
      setAutosaveScheduleVersion((v) => v + 1);
      return;
    }
    const prev = capturedPagesMapRef.current[templateKey] || [];
    const updated = prev.filter((p) => p.id !== pageId);
    capturedPagesMapRef.current[templateKey] = updated;
    autosaveDirtyRef.current = true;
    setReportAutosaveDirty(true);
    setAutosaveScheduleVersion((v) => v + 1);
  };

  const removeCapturedImageForTemplate = (templateKey, imageId) => {
    if (!templateKey || !imageId) return;
    if (capturedPagesOwnerKeyRef.current === templateKey) {
      removeCapturedImageFromReport(imageId);
      setReportAutosaveDirty(true);
      setAutosaveScheduleVersion((v) => v + 1);
      return;
    }
    const prev = capturedPagesMapRef.current[templateKey] || [];
    const updated = prev.map((p) => ({
      ...p,
      images: (p.images || []).filter((img) => img.id !== imageId),
    }));
    capturedPagesMapRef.current[templateKey] = updated;
    autosaveDirtyRef.current = true;
    setReportAutosaveDirty(true);
    setAutosaveScheduleVersion((v) => v + 1);
  };

  const setCapturedPageColumnsForTemplate = (templateKey, pageId, columns) => {
    if (!templateKey) return;
    const safe = Math.max(1, Math.min(columns || 2, 4));
    if (capturedPagesOwnerKeyRef.current === templateKey) {
      setCapturedPageColumns(pageId, safe);
      autosaveDirtyRef.current = true;
      setReportAutosaveDirty(true);
      setAutosaveScheduleVersion((v) => v + 1);
      return;
    }
    const prev = capturedPagesMapRef.current[templateKey] || [];
    const updated = reflowCapturedPagesForColumns(prev, pageId, safe);
    capturedPagesMapRef.current[templateKey] = updated;
    autosaveDirtyRef.current = true;
    setReportAutosaveDirty(true);
    setAutosaveScheduleVersion((v) => v + 1);
  };

  const moveCapturedPage = (pageId, direction) => {
    setCapturedPages((prev) => {
      const idx = prev.findIndex((p) => p.id === pageId);
      if (idx === -1) return prev;
      const target = idx + (direction === "up" ? -1 : 1);
      if (target < 0 || target >= prev.length) return prev;
      const next = [...prev];
      [next[idx], next[target]] = [next[target], next[idx]];
      return next;
    });
  };

  const handleChangeTemplate = (val) => {
    if (!val) {
      if (activeTabKey) {
        capturedPagesMapRef.current[activeTabKey] = capturedPages;
        capturedPageSelectedIdMapRef.current[activeTabKey] = selectedCapturedPageId;
      }
      capturedPagesOwnerKeyRef.current = "";
      setCapturedPages([]);
      setSelectedCapturedPageId(null);
      setActiveTab(1);
      setCurrentActiveTab(null);
      setModel("");
      setAddendumModel("");
      setStudyReportPdfSelected(true);
      setDisableAddendumTab(true);
      handleActiveTab(null);
      return;
    }

    let reportDetails =
      val?.reportDetails == undefined ? val.report : val.reportDetails;

    const key = val.key;
    if (activeTabKey && activeTabKey !== key) {
      capturedPagesMapRef.current[activeTabKey] = capturedPages;
      capturedPageSelectedIdMapRef.current[activeTabKey] = selectedCapturedPageId;
    }
    if(key){
      const restoredPages = capturedPagesMapRef.current[key] || [];
      capturedPagesOwnerKeyRef.current = key;
      setCapturedPages(restoredPages);
      setSelectedCapturedPageId(capturedPageSelectedIdMapRef.current[key] || null);
      setActiveTabKey(key);
      setReportTitle(val.text || reportDetails.title);
      if (restoredPages.length === 0) {
        setActiveTab(1);
      }
    }
    setCurrentActiveTab(
      reportDetails?.report == undefined
        ? reportDetails.reportTemplateTitle
        : reportDetails.title
    );
    skipNextExternalAutosaveDirtyRef.current = true;
    setModel(
      reportDetails?.report == undefined
        ? reportDetails?.finalReport
        : reportDetails?.report
    );
    //Updating the Addendum too
    setAddendumModel(reportDetails?.addendum ?? "");
    
    // Set disableAddendumTab based on global study state and current report's addendumEnabled property
    let isAddendumDisabled = true;
    if (roles[0] == USERTYPES.RADIOLOGIST && userId == reviewerId) {
      isAddendumDisabled = true;
    } else if (reportDoneStatusState == 2) {
      isAddendumDisabled = val.addendumEnabled === false ? true : false;
    } else {
      isAddendumDisabled = true;
    }
    setDisableAddendumTab(isAddendumDisabled);

    if (isAddendumDisabled) {
      setActiveTab(1);
    }
    
    setStudyReportPdfSelected(false);
    setTimeout(() => {
      handleActiveTab(val);
    }, 100);
  };

  const handleChildChangeTemplate = (val) => {
    setActiveTab(1);
    let reportDetails =
      val?.reportDetails == undefined ? val.report : val.reportDetails;
    setChildCurrentActiveTab(
      reportDetails?.report == undefined
        ? reportDetails.reportTemplateTitle
        : reportDetails.title
    );
    setChildModel(
      reportDetails?.report == undefined
        ? reportDetails?.finalReport
        : reportDetails?.report
    );

    setStudyReportPdfSelected(false);
    setTimeout(() => {
      handleActiveTab(val);
    }, 100);
  };

  const handleActiveTab = (report) => {
    let element = document.getElementById(report?.text);

    const ulItem = document.getElementById("horizontal-list");
    if (!ulItem) return;
    const allTabs = ulItem.children;

    // STEP 1: Always clear active class from ALL tabs
    for (let i = 0; i < allTabs.length; i++) {
      if (isStudyList) {
        allTabs[i].classList.remove(themeName + "-active-li");
      } else {
        allTabs[i].classList.remove("active-li");
      }
    }

    // STEP 2: If report is null → stop here (PDF selected)
    if (!report) return;

    const listItems = ulItem?.getElementsByTagName("li");
    if (listItems != undefined)
      for (let i = 0; i <= listItems.length - 1; i++) {
        if (listItems[i].id == report?.text) {
          element = listItems[i];
          break;
        }
      }

    if (report != null) {
      if (element != null) {
        if (isStudyList) {
          if (element?.classList != null)
            element?.classList.add(themeName + "-active-li");
        } else {
          if (element?.classList != null) element?.classList.add("active-li");
        }
      }
    }

    if (document.getElementById("horizontal-list") != null) {
      if (allTabs.length > 0) {
        for (var i = 0; i < allTabs.length; i++) {
          if (
            allTabs[i].id != report?.text &&
            report != null &&
            allTabs[i] != null
          ) {
            if (isStudyList) {
              if (allTabs[i].classList.contains(themeName + "-active-li"))
                allTabs[i].classList.remove(themeName + "-active-li");
            } else {
              if (allTabs[i].classList.contains("active-li"))
                allTabs[i].classList.remove("active-li");
            }
          }
        }
      }
    }
  };

  const handleRaiseAlertDropdown = (newVal, val) => {
    if (newVal?.value != null || newVal?.value != undefined) {
      setRaiseAlertValue(newVal.value);
    } else {
      setRaiseAlertValue("");
    }
  };

  const lockStudy = async (val, assignmentData) => {
    if (val == false) {
      setConfirmAlertModal(() => {
        const newItem = { ...confirmAlertModal };
        newItem.show = true;
        newItem.heading = "Alert";
        newItem.type = "lock";
        newItem.description = "Are you sure, you want to lock this study?";
        return newItem;
      });
      return;
    } else if (val == true) {
      setConfirmAlertModal(() => {
        const newItem = { ...confirmAlertModal };
        newItem.show = false;
        newItem.heading = "";
        newItem.type = "";
        newItem.description = "";
        return newItem;
      });
    }
    // setLoaderMessage("Locking study...");
    setLoaderRunning(true);
    ref.current.continuousStart();
    // setShowToast((prev) => {
    //   return {
    //     ...prev,
    //     show: false,
    //     message: "",
    //     loading: true,
    //     state: "success",
    //   };
    // });
    let body = {};
    if (assignmentData.studyId != null) {
      body = {
        studyId: assignmentData.studyId,
        clientId: assignmentData.clientId,
        firmId: assignmentData.firmId,
        assignedProviderId: assignmentData.providerId,
      };
    }

    let res = await assignStudy(true, body);
    if (res.data.result == "SUCCESS") {
      let loaded = await getData(true, true, false, false);
      if (loaded) {
        setLoaderRunning(false);
        ref.current.complete();
      }
      showToastv2(TOAST_TYPE.SUCCESS, "Study Locked Successfully");
    } else {
      setLoaderRunning(false);
      ref.current.complete();
      showToastv2(TOAST_TYPE.ERROR, res?.data?.message != null ? res.data.message : t("study-list.messages.assign-error"));
    }
  };

  const lockStudySupervisor = async (
    val,
    assignmentData,
    setChangeLockIcon
  ) => {
    setLoaderRunning(true);
    ref.current.continuousStart();

    let body = {};
    if (assignmentData.studyId != null) {
      body = {
        reportingProviderDto: {
          studyId: assignmentData.studyId,
          clientId: assignmentData.clientId,
          firmId: assignmentData.firmId,
          assignedProviderId: (assignmentData.qcreviewerId != null || assignmentData?.qcverifierId != null) ? "S" + userId : false
        },
        isAssign: true,
        isReviewer: assignmentData?.qcreviewerId === null ? true : false,
      };
    }
    const response = await assignMeSupervisor(body);
    if (response.status === 200 && response.data.result === "SUCCESS") {
      let loaded = await getData(true, true, true, false);
      if (loaded) {
        setLoaderRunning(false);
        ref.current.complete();
      }
      setChangeLockIcon(true);
      showToastv2(TOAST_TYPE.SUCCESS, "Study Locked Successfully");
    } else {
      setLoaderRunning(false);
      ref.current.complete();
      showToastv2(TOAST_TYPE.ERROR, "Error while locking study");
    }
  };

  const unlockStudy = async (studyId, isOtherReason, mainCategory, subCategory, returnOtherStudiesInGroup = false) => {
    if (mainCategory === "select") {
      setShowModal(() => {
        const newItem = { ...showModal };
        newItem.show = true;
        newItem.type = MODAL_TYPE.ALERT_MODAL;
        newItem.heading = "Alert";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = t("string-literals.no-values-selected");
        return newItem;
      });
      return;
    }
    // setLoaderMessage("Unlocking study...");
    setLoaderRunning(true);
    ref.current.continuousStart();
    setShowReturnStudyModal(false);
    const data = {
      studyId: studyId,
      mainCategory: mainCategory,
      subCategory: subCategory,
      returnOtherStudiesInGroup: returnOtherStudiesInGroup,
    };
    const params = new URLSearchParams(window.location.search);
    const blitzSession = params.get("blitzSession");

    const response = await ReturnStudyApi(data, blitzSession);
    if (response.data.result == "SUCCESS") {
      let loaded = await getData(true, true, true, false);
      setLoaderRunning(false);
      ref.current.complete();
      if (loaded)
        showToastv2(TOAST_TYPE.SUCCESS, "Study Unlocked Successfully");

      if (blitzSession) {
        window.parent.goToNextStudy(false);
      } else {
        setTimeout(() => {
          window.close();
        }, 2000);
      }
    } else {
      setLoaderRunning(false);
      ref.current.complete();
      showToastv2(TOAST_TYPE.ERROR, "Error while unlocking study");

    }

    // props.setShowConfirmModal(true);
    // props.setShowReturnStudyResponse(true);
    // props.setReturnStudyResponseMsg(response.data.message);
  };

  const releaseStudy = async (studyId) => {
    setLoaderRunning(true);
    ref.current.continuousStart();
    const response = await ReleaseStudyApi(studyId);
    if (response.data.result == "SUCCESS") {
      let loaded = await getData(true, true, true, false);
      setLoaderRunning(false);
      ref.current.complete();
      if (loaded)
        showToastv2(TOAST_TYPE.SUCCESS, "Study Released Successfully");
      setTimeout(() => {
        window.close();
      }, 2000);
    } else {
      setLoaderRunning(false);
      ref.current.complete();
      showToastv2(TOAST_TYPE.ERROR, "Error while releasing study");
    }
  };

  /** Release from Preliminary popup — calls ReleasePreliminaryStudyApi. */
  const handleReleasePreliminary = async (studyId) => {
    if (studyId == null) {
      return;
    }
    setLoaderRunning(true);
    ref.current.continuousStart();
    const response = await ReleasePreliminaryStudyApi(studyId);
    if (response?.data?.result == "SUCCESS") {
      let loaded = await getData(true);
      setLoaderRunning(false);
      ref.current.complete();
      if (loaded) {
        showToastv2(TOAST_TYPE.SUCCESS, t("string-literals.release-preliminary-success"));
      }
      setTimeout(() => {
        window.close();
      }, 2000);
    } else {
      setLoaderRunning(false);
      ref.current.complete();
      showToastv2(
        TOAST_TYPE.ERROR,
        response?.data?.message || t("string-literals.release-preliminary-error")
      );
    }
  };

  const handleAnnotationJsonData = (data) => {
    let tempAnnotation = [];
    if (data != null && data.length > 0) {
      data.map((item, index) => {
        if (item.is_annotated == true && item.is_locked == true)
          tempAnnotation.push(item.id);
      });
    }
    setAnnotationsJson("[" + tempAnnotation.toString() + "]");
  };

  const handleDropdown = (newVal, val) => {
    if (patientReports.find((e) => e.text === newVal.text)) {
      handleChangeTemplate(newVal);
      setReset(true);
      return;
    }
    const newReport = {
      ...newVal,
      addendumEnabled: false
    };
    setPatientReports((current) => [...current, newReport]);
    autosaveDirtyRef.current = true;
    setReportAutosaveDirty(true);
    setAutosaveScheduleVersion((v) => v + 1);
    setReset(true);
  };

  const handleDropdownWithContext = (newVal, isRSNAModal) => {
    if (patientReports.length >= 1 && !patientReports.some(report => report.key === newVal.key || report.reportDetails.reportTemplateId === newVal.key)
      && roles[0] === USERTYPES.RADIOLOGIST
      && (getEnv("REACT_APP_VDC_PLATFORM") == "true" || getEnv("REACT_APP_VDC_PLATFORM") == true)) {

      setConfirmMultipleTemplateModalContent({
        header: (
          <ModalHeader
            heading="Alert"
            updatedModal={true}
            handleCancel={() => {
              setConfirmMultipleTemplateOpen(false);
            }}
          />
        ),
        body: (
          <div className="return-study-container">
            <div className="return-study-content">
              <div className="ReturnStudyContentContainer">
                <div className="content-1">
                  <p style={{ fontWeight: "bold" }}>Do you want to open another template ?</p>
                </div>
              </div>
            </div>
          </div>
        ),
        footer: (
          <ModalFooter
            PrimaryButtonList={[
              {
                title: 'Yes',
                onclick: () => {
                  setConfirmMultipleTemplateOpen(false);
                  handleDropdownWithContextUpdated(newVal, isRSNAModal);
                },
              },
            ]}
            DefaultButtonList={[
              {
                title: 'No',
                onclick: () => {
                  setConfirmMultipleTemplateOpen(false);
                },
              },
            ]}
          />
        ),
        width: "400px",
      });
      setConfirmMultipleTemplateOpen(true);
      return;
    }

    handleDropdownWithContextUpdated(newVal, isRSNAModal);
  }

  const handleDropdownWithContextUpdated = (newVal, isRSNAModal) => {
    if (newVal.text == REPORT_TITLE.HRCT_CHEST_ILD) {
      setReportModalState(() => {
        const newItem = { ...reportModalState };
        newItem.hrctChestILD = true;
        newItem.hrctChestCovid = false;
        newItem.ctBrain = false;
        newItem.content = newVal;
        newItem.id = newVal.key;
        return newItem;
      });
      return;
    } else if (newVal.text == REPORT_TITLE.CT_BRAIN) {
      setReportModalState(() => {
        const newItem = { ...reportModalState };
        newItem.hrctChestILD = false;
        newItem.hrctChestCovid = false;
        newItem.ctBrain = true;
        newItem.content = newVal;
        newItem.id = newVal.key;
        return newItem;
      });
      return;
    } else if (newVal.text == REPORT_TITLE.HRCT_CHEST_COVID) {
      setReportModalState(() => {
        const newItem = { ...reportModalState };
        newItem.hrctChestILD = true;
        newItem.hrctChestCovid = false;
        newItem.ctBrain = false;
        newItem.content = newVal;
        newItem.id = newVal.key;
        return newItem;
      });
      return;
    } else if (newVal.text == REPORT_TITLE.HRCT_CHEST_COVID_SR) {
      setReportModalState(() => {
        const newItem = { ...reportModalState };
        newItem.hrctChestCovid = true;
        newItem.hrctChestILD = false;
        newItem.ctBrain = false;
        newItem.content = newVal;
        newItem.id = newVal.key;
        return newItem;
      });
      return;
    } else if (newVal.text == REPORT_TITLE.MRI_SPINE_SR) {
      setReportModalState(() => {
        const newItem = { ...reportModalState };
        newItem.hrctChestCovid = false;
        newItem.hrctChestILD = false;
        newItem.ctBrain = false;
        newItem.mriSpine = true;
        newItem.content = newVal;
        newItem.id = newVal.key;
        return newItem;
      });
      return;
    }

    if (isRSNAModal) {
      setOpenRSNAModal(true);
      let item = dropdownSelectedTemplates.filter((ele, index) => {
        if (ele.text == newVal.text) {
          return ele;
        }
      });
      setRSNAModalContent(item[0]);
      return;
    }
    if (patientReports.length == 0) {
      handleChangeTemplate(newVal);
      setFirstReportAdded(true);
    }

    if(!(enableLlmReport && isLLMAgentPresent(modality, studyDescription)))
    {
      if (selectedCategoryTemplate === "dsrTemplate") {
        const anyDSRTemplate = patientReports.filter(report => report.text.includes("Agentic"));
        if (anyDSRTemplate.length !== 0) {
          setPatientReports([]);
        } else {
          setOldPatientReports(patientReports);
          setPatientReports([]);
        }

      } else {
        const anyDSRTemplate = patientReports.filter(report => report.text.includes("Agentic"));
        if (anyDSRTemplate.length !== 0) {
          setPatientReports(oldPatientReports);
          setOldPatientReports(anyDSRTemplate);
        }
      }
    }

    const existingTemplate = patientReports.find((e) => e.text === newVal.text);

    if (existingTemplate && !newVal.reportDetails.blankTemplate) {
      autosaveDirtyRef.current = true;
      setReportAutosaveDirty(true);
      setAutosaveScheduleVersion((v) => v + 1);
      handleChangeTemplate(newVal);
      return;
    } else {
      if (selectedCategoryTemplate === "dsrTemplate" && newVal.text.includes("Other")) {
        setDisableObservations(true);
        setActiveTab(1);
      } else {
        setDisableObservations(false);
      }

      let newTemplate = {
        ...newVal,
        reportDetails: JSON.parse(JSON.stringify(newVal.reportDetails)),
        addendumEnabled: false
      };

      if (newTemplate.reportDetails?.blankTemplate) {
        const baseText = newTemplate.text;
        let counter = 1;
        let uniqueText = baseText;

        const existingTexts = patientReports.map((r) => r.text);
        while (existingTexts.includes(uniqueText)) {
          uniqueText = `${baseText}_${counter}`;
          counter++;
        }

        newTemplate.text = uniqueText;
        newTemplate.reportDetails.title = uniqueText;
      }

      setPatientReports((current) => [...current, newTemplate]);
      autosaveDirtyRef.current = true;
      setReportAutosaveDirty(true);
      setAutosaveScheduleVersion((v) => v + 1);
    }
  };

  const downloadReport = async (type, studyId, useDraftSnapshot) => {
    if (studyId == null || studyId == undefined) {
      studyId = studyParentId;
    }
    // Parse to integer to break taint chain from document.location
    const safeStudyId = parseInt(studyId, 10);
    // setLoaderMessage("Downloading report...");
    setLoaderRunning(true);
    ref.current.continuousStart();
    // setShowToast((prev) => {
    //   return {
    //     ...prev,
    //     show: false,
    //     message: "",
    //     loading: true,
    //     state: "success",
    //   };
    // });
    // OLD: leftover Amplitude call from before the amplitude code was removed.
    // logAmplitudeEventForReport was never actually defined/exported, so this threw
    // "ReferenceError: logAmplitudeEventForReport is not defined" and broke report download.
    // logAmplitudeEventForReport(type, safeStudyId);
    try {
      let res = await downloadPdfReport(safeStudyId, type, useDraftSnapshot);
      if (res.status == 200 && res.data.result === "SUCCESS") {
        setLoaderRunning(false);
        ref.current.complete();
        
        if(!isVdcPlatform){
          setDownloadedStudyIds((prev) => {
            if (!prev.includes(studyId)) {
              return [...prev, studyId];
            }
            return prev;
          });
        }
        if (res.data.data.paymentStatus == VDCLIMS.PaymentStatusCodes.PAID) {
          showToastv2(TOAST_TYPE.SUCCESS, "Download Successful");
          setDownloadedStudyIds((prev) => {
            if (!prev.includes(studyId)) {
              return [...prev, studyId];
            }
            return prev;
          });
        }
        if (
          res.data.data.paymentStatus == VDCLIMS.PaymentStatusCodes.DUE ||
          res.data.data.paymentStatus == VDCLIMS.PaymentStatusCodes.ERROR
        ) {
          setAlertSuccessModal(() => {
            const newItem = { ...alertSuccessModal };
            newItem.show = true;
            newItem.heading = "Alert";
            newItem.description =
              res.data.data.paymentStatus == VDCLIMS.PaymentStatusCodes.DUE
                ? t("payment-status.payment-due-message")
                : t("payment-status.payment-error-message");
            return newItem;
          });
        }
      } else {
        // alert("Something goes wrong");
        setLoaderRunning(false);
        ref.current.complete();
        showToastv2(TOAST_TYPE.ERROR, t("string-literals.error-msg"));
      }
    } catch (e) {
      setLoaderRunning(false);
      ref.current.complete();
      showToastv2(TOAST_TYPE.ERROR, t("string-literals.error-msg"));
    }
  };

  /* 
    Author: Tushar Saxena 
    Description: Download AI report
    Date: 02-02-2024 
  */
  const downloadAIReport = async (studyId) => {
    if (studyId == null || studyId == undefined) {
      studyId = studyParentId;
    }
    // Parse to integer to break taint chain from document.location
    const safeStudyId = parseInt(studyId, 10);
    // setLoaderMessage("Downloading report...");
    setLoaderRunning(true);
    ref.current.continuousStart();
    try {
      let res = await downloadAIReportAPI(safeStudyId);

      if (res.status == 200 && res.data.result === "SUCCESS") {
        setLoaderRunning(false);
        ref.current.complete();
        showToastv2(TOAST_TYPE.SUCCESS, "Download Successful");
      } else {
        setLoaderRunning(false);
        ref.current.complete();
        showToastv2(TOAST_TYPE.ERROR, t("string-literals.error-msg"));
      }
    } catch (e) {
      setLoaderRunning(false);
      ref.current.complete();
      showToastv2(TOAST_TYPE.ERROR, t("string-literals.error-msg"));
    }
  };

  const handlePreviewReport = async (studyParamId, reportDoneStatus, useDraftSnapshot) => {
    // setLoaderMessage("Loading report preview...");
    setLoaderRunning(true);
    ref.current.continuousStart();
    try {
      let actualStudyId = (studyParamId && studyParamId.nativeEvent) ? studyId : studyParamId;
      let reportStatus = reportDoneStatus != null && reportDoneStatus != undefined ? reportDoneStatus : reportDoneStatusState;
      let res = await previewPdfReport(actualStudyId, reportStatus, useDraftSnapshot);
      if (res?.data?.result === "SUCCESS") {
        if (res.data.data.paymentStatus == VDCLIMS.PaymentStatusCodes.PAID) {
          // showToastv2(TOAST_TYPE.SUCCESS, "Preview Successfull");
        }
        setLoaderRunning(false);
        ref.current.complete();
        if (reportStatus == REPORTDONESTATUS.REPORTED &&
          (res.data.data.paymentStatus == VDCLIMS.PaymentStatusCodes.DUE ||
            res.data.data.paymentStatus == VDCLIMS.PaymentStatusCodes.ERROR)
        ) {
          setAlertSuccessModal(() => {
            const newItem = { ...alertSuccessModal };
            newItem.show = true;
            newItem.heading = "Alert";
            newItem.description =
              res.data.data.paymentStatus == VDCLIMS.PaymentStatusCodes.DUE
                ? t("payment-status.payment-due-message")
                : t("payment-status.payment-error-message");
            return newItem;
          });
        }
      } else {
        setLoaderRunning(false);
        ref.current.complete();
        if (res?.data?.errorCode === "009") {
          showToastv2(TOAST_TYPE.ERROR, "You don't have access to the study");
        } else {
          showToastv2(TOAST_TYPE.ERROR, t("string-literals.error-msg"));
        }
      }
    } catch (e) {
      setLoaderRunning(false);
      ref.current.complete();
      showToastv2(TOAST_TYPE.ERROR, t("string-literals.error-msg"));
    }
  };

  const handlePreviewReportWithKeyImage = async (studyParamId, reportDoneStatus, useDraftSnapshot) => {
    setLoaderRunning(true);
    ref.current.continuousStart();
    try {
      let actualStudyId = (studyParamId && studyParamId.nativeEvent) ? studyId : studyParamId;
      let reportStatus = reportDoneStatus != null && reportDoneStatus != undefined ? reportDoneStatus : reportDoneStatusState;
      let res = await previewPdfWithKeyImageReport(actualStudyId, reportStatus, useDraftSnapshot);
      if (res?.data?.result === "SUCCESS") {
        setLoaderRunning(false);
        ref.current.complete();
        if (reportStatus == REPORTDONESTATUS.REPORTED &&
          (res.data.data.paymentStatus == VDCLIMS.PaymentStatusCodes.DUE ||
            res.data.data.paymentStatus == VDCLIMS.PaymentStatusCodes.ERROR)
        ) {
          setAlertSuccessModal(() => {
            const newItem = { ...alertSuccessModal };
            newItem.show = true;
            newItem.heading = "Alert";
            newItem.description =
              res.data.data.paymentStatus == VDCLIMS.PaymentStatusCodes.DUE
                ? t("payment-status.payment-due-message")
                : t("payment-status.payment-error-message");
            return newItem;
          });
        }
      } else {
        setLoaderRunning(false);
        ref.current.complete();
        showToastv2(TOAST_TYPE.ERROR, t("string-literals.error-msg"));
      }
    } catch (e) {
      setLoaderRunning(false);
      ref.current.complete();
      showToastv2(TOAST_TYPE.ERROR, t("string-literals.error-msg"));
    }
  };

  const handlePreviewReportVersion = async (versionParamId) => {
    // setLoaderMessage("Loading report preview...");
    setLoaderRunning(true);
    ref.current.continuousStart();
    try {
      let res = await previewPdfReportVersion(versionParamId);
      if (res?.data?.result === "SUCCESS") {
        if (res.data.data.paymentStatus == VDCLIMS.PaymentStatusCodes.PAID) {
          // showToastv2(TOAST_TYPE.SUCCESS, "Preview Successfull");
        }

        setLoaderRunning(false);
        ref.current.complete();
        if (
          res.data.data.paymentStatus == VDCLIMS.PaymentStatusCodes.DUE ||
          res.data.data.paymentStatus == VDCLIMS.PaymentStatusCodes.ERROR
        ) {
          setAlertSuccessModal(() => {
            const newItem = { ...alertSuccessModal };
            newItem.show = true;
            newItem.heading = "Alert";
            newItem.description =
              res.data.data.paymentStatus == VDCLIMS.PaymentStatusCodes.DUE
                ? t("payment-status.payment-due-message")
                : t("payment-status.payment-error-message");
            return newItem;
          });
        }
      } else {
        setLoaderRunning(false);
        ref.current.complete();
        showToastv2(TOAST_TYPE.ERROR, t("string-literals.error-msg"));
      }
    } catch (e) {
      setLoaderRunning(false);
      ref.current.complete();
      showToastv2(TOAST_TYPE.ERROR, t("string-literals.error-msg"));
    }
  };

  // const validateQCPass = async(studyId,)

  const handleQcPass = async (
    studyId,
    keyImages,
    qcData,
    allTextToolData,
    checkKeyImagesAndTextAnnotation = true,
    skipFormattingForAgenticReport = false
  ) => {

    if (checkKeyImagesAndTextAnnotation) {
      if (
        keyImagesPresent(keyImages) &&
        Object.keys(allTextToolData).length !== 0
      ) {
        setIsKeyImagesPresent(true);
        setIsTextAnnotationPresent(true);
        setOpenQCPassConfirmModal(true);
        return;
      }

      if (keyImagesPresent(keyImages)) {
        setIsKeyImagesPresent(true);
        setOpenQCPassConfirmModal(true);
        return;
      }
      if (Object.keys(allTextToolData).length !== 0) {
        setIsTextAnnotationPresent(true);
        setOpenQCPassConfirmModal(true);
        return;
      }
    }
    const qcParams = {
      studyId,
      keyImages,
      qcData,
      allTextToolData,
      checkKeyImagesAndTextAnnotation,
    };

    setQCPassParams(qcParams);

    if (sanitizeReportContentForHL7) {
      let result = CheckAndRemoveUnparsableHtmlCharactersFromReport();
      if (result?.report?.replacedCounts > 0 || result?.report?.removedCounts > 0) {
        // Build message
        // Get unique replaced and removed values
        const replacedSet = new Set(result.report.replacements.map(r => `${r.original} → ${r.replacedWith}`));
        const removedSet = new Set(result.report.removals.map(r => `${r.original}`));

        const replacedList = Array.from(replacedSet).join("\n");
        const removedList = Array.from(removedSet).join("\n");

        let message = "Some unsupported characters were found in the report and have been removed/replaced to ensure compatibility.";
        if (replacedList) {
          message += `\n\nReplaced:\n${replacedList}`;
        }
        if (removedList) {
          message += `\n\nRemoved:\n${removedList}`;
        }

        setUnparsableDialogMessage(message);
        setShowUnparsableDialog(true);
        return;
      }
    }
    
    if (reportDoneStatusState !== 2 && formatterAgentEnabled && !formattedReportUsed && !isExternal && conflictSave == "0" && !skipFormattingForAgenticReport) {
      setPendingQCPass(() => proceedWithQCPass);
      setShowFormatterPopup(true);
      return;
    }
    proceedWithQCPass(qcParams);
  }

  const proceedWithQCPass = async (qcParams) => {
    if (!qcPassParams && !qcParams) return;
    let data = !qcPassParams ? qcParams : qcPassParams;

    const requestData = {
      studyId: data.studyId,
      clientId: data.qcData.clientId,
      firmId: data.qcData.firmId,
      providerId: 0,
      reasons: "",
      raiseAlert: raiseAlertValue,
      studyKeyImages: data.keyImages,
      imageToolAnnotationMeasurements: [],
      studyReportList: await getFormattedReports(),
      conflictSave: conflictSave,
      formattedReportAction: formattedReportAction
    };
    // setLoaderMessage("Submitting QC Review...");
    setLoaderRunning(true);
    ref.current.continuousStart();

    const params = new URLSearchParams(window.location.search);
    const blitzSession = params.get("blitzSession");

    const response = await submitQC(requestData, data.allTextToolData, blitzSession);
    if (response.status === 200) {
      setLoaderRunning(false);
      ref.current.complete();

      if (reportDoneStatusState === REPORTDONESTATUS.QC_REVIEW ||
          reportDoneStatusState === REPORTDONESTATUS.PRELIMINARY_QC_REVIEW) {
        showToastv2(TOAST_TYPE.SUCCESS, "QC Review Successful !");
      } else {
        showToastv2(TOAST_TYPE.SUCCESS, "QC Verify Successful !");
      }
      
      if (blitzSession) {
        window.parent.goToNextStudy(false);
      }
      setUpdateDoneSubmitDone(() => {
        const newItem = { ...updateRowSubmitDone };
        newItem.id = data.studyId;
        newItem.show = true;
        return newItem;
      });
      setTimeout(() => {
        window.close();
      }, 2000);
    } else {
      setLoaderRunning(false);
      ref.current.complete();
      if (response.data.result == "FAILURE") {
        if (
          response?.data?.message != null &&
          response?.data?.message?.includes(
            "Found conflict in patient sex and report content in"
          )
        ) {
          let conflictSaveTemp = response?.data?.message?.includes(
            "Found conflict in patient sex and report content in"
          )
            ? "1"
            : "0";
          setConflictSave("1");
          if (conflictSaveTemp == "1") {
            setConfirmAlertModal(() => {
              const newItem = { ...confirmAlertModal };
              newItem.isConflictPopup = true;
              newItem.show = true;
              newItem.type = "qcPass";
              newItem.heading = "Alert";
              newItem.description = response.data.message;
              newItem.qcData = data.qcData;
              newItem.allTextToolData = data.allTextToolData;
              newItem.checkKeyImagesAndTextAnnotation = data.checkKeyImagesAndTextAnnotation;
              return newItem;
            });
          }
        } else {
          showToastv2(TOAST_TYPE.ERROR, "QC Verify Failed");
        }
      } else if (reportDoneStatusState === REPORTDONESTATUS.QC_REVIEW ||
          reportDoneStatusState === REPORTDONESTATUS.PRELIMINARY_QC_REVIEW) {
        showToastv2(TOAST_TYPE.ERROR, "QC Review Failed");
      } else {
        showToastv2(TOAST_TYPE.ERROR, "QC Verify Failed");
      }
    }
  };

  const validateQCFields = (
    qcReason,
    otherReason,
    providerId,
    setIsError,
    setErrorMessage
  ) => {
    if (qcReason === null || qcReason === "") {
      setIsError(true);
      setErrorMessage(t("QC.specify-reason"));
      return false;
    } else if (
      qcReason === "Other" &&
      (otherReason === null || otherReason === undefined || otherReason === "")
    ) {
      setIsError(true);
      setErrorMessage(t("QC.specify-other-reason"));
      return false;
    } else if (
      providerId === null ||
      providerId === undefined ||
      providerId === ""
    ) {
      setIsError(true);
      setErrorMessage(t("QC.select-qc-radiologist"));
      return false;
    }
    return true;
  };

  const handleQCReasonClick = async () => {
    setDisableSubmitUntilQCReasonClick(false);
  };

  const handleQcReturn = async (
    studyId,
    qcData,
    keyImages,
    qcReason,
    otherReason,
    providerId,
    setIsError,
    setErrorMessage,
    allTextToolData
  ) => {
    if (
      !validateQCFields(
        qcReason,
        otherReason,
        providerId,
        setIsError,
        setErrorMessage
      )
    ) {
      return;
    }

    const requestData = {
      studyId: studyId,
      clientId: qcData.clientId,
      firmId: qcData.firmId,
      providerId: providerId,
      reasons: qcReason === "Other" ? otherReason : qcReason,
      raiseAlert: raiseAlertValue,
      studyKeyImages: keyImages,
      imageToolAnnotationMeasurements: [],
      // studyReportList : await getFormattedReports(),
    };
    // setLoaderMessage("Processing QC Return...");
    setLoaderRunning(true);
    ref.current.continuousStart();

    const params = new URLSearchParams(window.location.search);
    const blitzSession = params.get("blitzSession");

    const response = await submitQC(requestData, allTextToolData, blitzSession); 
    if (response.status === 200 && response.data.result === "SUCCESS") {
      setLoaderRunning(false);
      ref.current.complete();
      showToastv2(TOAST_TYPE.SUCCESS, "QC Return Successful !");
      
      if (blitzSession) {
        window.parent.goToNextStudy(false);
      }
      setUpdateDoneSubmitDone(() => {
        const newItem = { ...updateRowSubmitDone };
        newItem.id = studyId;
        newItem.show = true;
        return newItem;
      });
      setTimeout(() => {
        window.close();
      }, 2000);
    } else {
      //showToastv2(TOAST_TYPE.ERROR, "QC Return Failed");
      setLoaderRunning(false);
      ref.current.complete();
      setAlertSuccessModal(() => {
        const newItem = { ...alertSuccessModal };
        newItem.show = true;
        newItem.heading = "Error";
        newItem.description = t("string-literals.error-msg");
        return newItem;
      });
    }
  };


  const BACKEND_TZ = getEnv("REACT_APP_BACKEND_TIMEZONE");
  
 const getConsistentDateFormat = (date) => {
  if (!date) return "No Date";

  const rawUserTz = localStorage.getItem("userTimeZone");
  const userTz = normalizeTimeZone(rawUserTz);
  const systemTz = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const momentDate = moment.tz(
    date,
    "DD-MMM-YY HH:mm",
    true,
    BACKEND_TZ
  );

  if (!momentDate.isValid()) return "No Date";

  // 🎯 Decide display timezone
  const displayTz = userTz || systemTz;

  return momentDate
    .tz(displayTz)
    .format("DD-MMM-YY hh:mm A");
};

const getConsistentDateFormatFromUTC = (date) => {
  if (!date) return "No Date";

  const rawUserTz = localStorage.getItem("userTimeZone");
  const userTz = normalizeTimeZone(rawUserTz);
  const systemTz = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // 🔥 Parse date AS BACKEND timezone
  const momentDate = moment.tz(
    date,
    "DD-MMM-YY HH:mm",
    true,"UTC"
  );

  if (!momentDate.isValid()) return "No Date";

  // 🎯 Decide display timezone
  const displayTz = userTz || systemTz;

  return momentDate
    .tz(displayTz)
    .format("DD-MMM-YY hh:mm A");
};


const getConsistentCustomDateFormat = (date) => {
  if (!date) return "No Date";

  const rawUserTz = localStorage.getItem("userTimeZone");
  const userTz = normalizeTimeZone(rawUserTz);
  const systemTz = Intl.DateTimeFormat().resolvedOptions().timeZone;

  let momentDate;

  // 🔥 ISO string coming from backend TZ
  if (moment(date, moment.ISO_8601, true).isValid()) {
    momentDate = moment.tz(date, BACKEND_TZ);
  }
  // 🔥 Legacy backend format
  else if (moment(date, "DD-MMM-YY HH:mm", true).isValid()) {
    momentDate = moment.tz(
      date,
      "DD-MMM-YY HH:mm",
      true,
      BACKEND_TZ
    );
  }
  else {
    return "No Date";
  }

  // 🎯 Decide display timezone
  const displayTz = userTz || systemTz;

  return momentDate
    .tz(displayTz)
    .format("DD-MMM-YY hh:mm A");
};

const normalizeTimeZone = (tz) => {
  if (!tz) return null;
  if (tz === "null" || tz === "undefined") return null;
  return tz;
};


// const getConsistentDateFormat = (date) => {
//   if (!date) return "No Date";

//   const timezone = localStorage.getItem("userTimeZone");
//   const momentDate = moment(date, "DD-MMM-YY HH:mm", true); // strict parse

//   if (!momentDate.isValid()) return "No Date";

//   if (!timezone) {
//     return momentDate.format("DD-MMM-YY hh:mm A");
//   }

//   return momentDate
//     .tz(timezone)
//     .format("DD-MMM-YY hh:mm A");
// };

// const getConsistentCustomDateFormat = (date) => {
//   if (!date) return "No Date";

//   const timezone = localStorage.getItem("userTimeZone");
//   let momentDate;

//   // ISO format
//   if (moment(date, moment.ISO_8601, true).isValid()) {
//     momentDate = moment(date);
//   }
//   // Legacy backend format
//   else if (moment(date, "DD-MMM-YY HH:mm", true).isValid()) {
//     momentDate = moment(date, "DD-MMM-YY HH:mm");
//   }
//   else {
//     return "No Date";
//   }

//   if (!timezone) {
//     return momentDate.format("DD-MMM-YY hh:mm A");
//   }

//   return momentDate
//     .tz(timezone)
//     .format("DD-MMM-YY hh:mm A");
// };




  const handleQcReturnButtonClick = async (studyId, qcData) => {
    const response = await getQCProvidersList({
      studyId: studyId,
      clientId: qcData.clientId,
      firmId: qcData.firmId,
    });
    const radiologistList = response.data.data.radiologists;
    const providerList = response.data.data.providers;
    let tempProviderList = [];

    providerList.forEach((provider) => {
      tempProviderList.push({
        value: "F" + provider.id,
        label:
          provider.qcType === ""
            ? provider.name
            : provider.qcType + " - " + provider.name,
      });
    });

    radiologistList.forEach((provider) => {
      const radiologistName = getRadiologistDisplayName({
        firstName: provider.firstName,
        lastName: provider.lastName,
        specialist: provider.specialist,
      });
      tempProviderList.push({
        value: "R" + provider.id,
        label:
          provider.qcType === ""
            ? radiologistName
            : provider.qcType + " - " + radiologistName,
      });
    });

    setQcProviderList(tempProviderList);

    setOpenQcModal(true);
  };

  const checkIfCancelOrNot = (
    val,
    keyImages,
    annotationData,
    annotationDataAI,
    allTextToolAnnotation,
    activeViewportIndex,
    passConflictTemp,
    qcData,
  ) => {
    if (confirmAlertModal.type == "qcPass") {
      handleQcPass(
        studyParentId,
        keyImages,
        qcData,
        allTextToolAnnotation,
        false
      )
    }
    else if (confirmAlertModal.type == "save") {
      handleSaveReport(
        val,
        keyImages,
        annotationData,
        annotationDataAI,
        allTextToolAnnotation,
        activeViewportIndex,
        passConflictTemp
      );
    } else {
      let addendumDisclaimerAddedByRadVal = false;
      let showAddendumDisclaimerPopupVal = false;
      handleSubmitReport(
        val,
        keyImages,
        annotationData,
        annotationDataAI,
        allTextToolAnnotation,
        activeViewportIndex,
        passConflictTemp,
        addendumDisclaimerAddedByRad,
        showAddendumDisclaimerPopupVal,
        undefined,undefined,positive
      );
    }

    setConfirmAlertModal(() => {
      const newItem = { ...confirmAlertModal };
      newItem.show = false;
      newItem.heading = "";
      newItem.description = "";
      newItem.type = "save";
      return newItem;
    });
    // console.log("Inside checkIfCancelOrNot "+val);
  };

  /** Save Draft: persist working Draft via /auto-save. */
  const handleSaveDraft = async (
    state,
    keyImages,
    annotationData,
    annotationDataAI,
    allTextToolAnnotation,
    activeViewportIndex
  ) => {
    if (isWidget) {
      return;
    }
    setLoaderRunning(true);
    setExternalReportingLoading(true);
    ref.current.continuousStart();
    try {
      setReportAutosaveStatus("saving");
      const body = await getFormatedData(
        keyImages,
        annotationData,
        annotationDataAI,
        allTextToolAnnotation,
        activeViewportIndex,
        null,
        false,
        undefined,
        undefined,
        undefined
      );
      if (body == null) {
        setLoaderRunning(false);
        ref.current.complete();
        setExternalReportingLoading(false);
        setReportAutosaveStatus(autoSaveReportPreference ? "on" : "off");
        return;
      }
      if (body?.loaded == true && body?.content == null) {
        setLoaderRunning(false);
        ref.current.complete();
        setExternalReportingLoading(false);
        setReportAutosaveStatus(autoSaveReportPreference ? "on" : "off");
        setAlertSuccessModal(() => {
          const newItem = { ...alertSuccessModal };
          newItem.show = true;
          newItem.heading = "Alert";
          newItem.description =
            patientReports.length == 0
              ? t("string-literals.no-reports-added")
              : t("string-literals.empty-report");
          return newItem;
        });
        return;
      }
      if (!body?.loaded || body?.content == null) {
        setLoaderRunning(false);
        ref.current.complete();
        setExternalReportingLoading(false);
        setReportAutosaveStatus(autoSaveReportPreference ? "on" : "off");
        return;
      }

      const params = new URLSearchParams(window.location.search);
      const blitzSession = params.get("blitzSession");
      const response = await autosaveReportData(body.content, blitzSession);
      if (
        response?.status === 200 &&
        (response?.data?.result === "SUCCESS" ||
          response?.data?.result === "WARNING")
      ) {
        setReportAutosaveBlocked(false);
        autosaveDirtyRef.current = false;
        setReportAutosaveDirty(false);
        setReportAutosaveOffReason("");
        setReportAutosaveLastSavedAt(new Date());
        setReportAutosaveStatus("saved");
        window.setTimeout(() => {
          setReportAutosaveStatus((prev) => (prev === "saved" ? "on" : prev));
        }, 2500);
        if (response.data.result === "WARNING" && response.data.message) {
          showToastv2(TOAST_TYPE.INFO, response.data.message);
        }
        showToastv2(TOAST_TYPE.SUCCESS, t("string-literals.save-draft"));
      } else {
        const failureMessage =
          response?.data?.message || t("string-literals.draft-not-saved");
        setReportAutosaveBlocked(true);
        setReportAutosaveOffReason(
          response?.data?.message ||
            t("string-literals.autosave-draft-failed")
        );
        setReportAutosaveStatus("off");
        showToastv2(TOAST_TYPE.ERROR, failureMessage);
      }
    } catch (e) {
      console.debug("manual draft save failed", e);
      setReportAutosaveBlocked(true);
      setReportAutosaveOffReason(
        t("string-literals.autosave-draft-failed")
      );
      setReportAutosaveStatus("off");
      showToastv2(TOAST_TYPE.ERROR, t("string-literals.draft-not-saved"));
    } finally {
      setLoaderRunning(false);
      ref.current.complete();
      setExternalReportingLoading(false);
    }
  };

  /** Preliminary (renamed Save button): official version via existing /save API (reportDoneStatus = 1). */
  const handleSaveReport = async (
    state,
    keyImages,
    annotationData,
    annotationDataAI,
    allTextToolAnnotation,
    activeViewportIndex,
    passConflictTemp,
    formattedReportAction,
    updatedReports
  ) => {
    if (!enableLlmReport && enableReportRegenerate == true && !isClientReportExist) {
      setConfirmAlertModal(() => {
        const newItem = { ...confirmAlertModal };
        newItem.show = true;
        newItem.type = "save";
        newItem.heading = "Alert";
        newItem.description =
          "There are unsaved changes. Are you sure you want to continue without regenerating report ?";
        return newItem;
      });
      if (state == true) {
        return;
      }
    }
    // setLoaderMessage("Saving report...");
    setLoaderRunning(true);
    setExternalReportingLoading(true);
    autosaveDirtyRef.current = false;
    setReportAutosaveDirty(false);
    ref.current.continuousStart();
    try {
      let body = await getFormatedData(
        keyImages,
        annotationData,
        annotationDataAI,
        allTextToolAnnotation,
        activeViewportIndex,
        passConflictTemp,
        false,
        formattedReportAction,
        updatedReports
      );
      if (body == null) {
        setLoaderRunning(false);
        ref.current.complete();
        return;
      }
      if (body?.loaded == true && body?.content == null) {
        setLoaderRunning(false);
        ref.current.complete();
        setExternalReportingLoading(false);
        setAlertSuccessModal(() => {
          const newItem = { ...alertSuccessModal };
          newItem.show = true;
          newItem.heading = "Alert";
          newItem.description =
            patientReports.length == 0
              ? t("string-literals.no-reports-added")
              : t("string-literals.empty-report");
          return newItem;
        });
        return;
      } else if (body.loaded == true && body.content != null) {

        if (sanitizeReportContentForHL7) {
          let result = CheckAndRemoveUnparsableHtmlCharactersFromReport(updatedReports);
          if (result?.report?.replacedCounts > 0 || result?.report?.removedCounts > 0) {
            // Build message
            // Get unique replaced and removed values
            const replacedSet = new Set(result.report.replacements.map(r => `${r.original} → ${r.replacedWith}`));
            const removedSet = new Set(result.report.removals.map(r => `${r.original}`));

            const replacedList = Array.from(replacedSet).join("\n");
            const removedList = Array.from(removedSet).join("\n");

            let message = "Some unsupported characters were found in the report and have been removed/replaced to ensure compatibility.";
            if (replacedList) {
              message += `\n\nReplaced:\n${replacedList}`;
            }
            if (removedList) {
              message += `\n\nRemoved:\n${removedList}`;
            }
            setLoaderRunning(false);
            ref.current.complete();
            setUnparsableDialogMessage(message);
            setShowUnparsableDialog(true);

            return;
          }
        }

        const params = new URLSearchParams(window.location.search);
        const blitzSession = params.get("blitzSession");

        let response = await saveReportTemplatesData(body.content, blitzSession);
        if (
          (response.status === 200 && (response.data.result == "SUCCESS" || response.data.result == "WARNING")) ||
          (passConflictTemp != null &&
            passConflictTemp == true &&
            response.status === 200 &&
            (response.data.result == "SUCCESS" || response.data.result == "WARNING"))
        ) {
          let eventProperties = {};
          logAmplitudeEventWithUsernameAndRole(
            "EVENT_BASIC_SAVE_REPORT",
            eventProperties,
            username
          );
          getData(false, false);
          autosaveDirtyRef.current = false;
          setReportAutosaveDirty(false);
          setReportAutosaveStatus(autoSaveReportPreference ? "on" : "off");
          if (!isExternal && !isWidget) {
            setReportSaveSuccess((prev) => !prev);
          } else {
            //setOpenReportModal(false);
            if (roles[0] == USERTYPES.TYPIST) {
              setIsExternal(false);
              setIsWidget(false);
              setIsClientReportExistExternalModal(null);
              setUpdateDoneSubmitDone(() => {
                const newItem = { ...updateRowSubmitDone };
                newItem.id = studyId;
                newItem.show = true;
                return newItem;
              });
              setOpenReportModal(false);
            }
          }
          if (response.data.result == "WARNING") {
            showToastv2(
              TOAST_TYPE.INFO,
              response.data.message
            );
          }
          setLoaderRunning(false);
          ref.current.complete();
          showToastv2(
            TOAST_TYPE.SUCCESS,
            t("string-literals.preliminary-report")
          );
          setExternalReportingLoading(false);

          const url = response?.data?.data?.url;
          // Do not auto-preview when study entered Preliminary QC Review (mirror Final QC status 3)
          const enteredPreliminaryQc =
            reportDoneStatusState === REPORTDONESTATUS.PRELIMINARY_QC_REVIEW ||
            response?.data?.data?.reportDoneStatus === REPORTDONESTATUS.PRELIMINARY_QC_REVIEW;
          setTimeout(() => {
            if (url && !enteredPreliminaryQc) {
              try {
                const p = new URL(url);
                window.open(getSafeRedirectUrl(url), "_blank", "noopener,noreferrer");
              } catch (e) { /* invalid url */ }
            }
          }, 2000);   

        } else if (response.data.result == "FAILURE") {
          if (
            response?.data?.message != null &&
            response?.data?.message?.includes(
              "Found conflict in patient sex and report content in"
            )
          ) {
            let conflictSaveTemp = response?.data?.message?.includes(
              "Found conflict in patient sex and report content in"
            )
              ? "1"
              : "0";
            setConflictSave("1");

            if (conflictSaveTemp == "1")
              setConfirmAlertModal(() => {
                const newItem = { ...confirmAlertModal };
                newItem.isConflictPopup = true;
                newItem.show = true;
                newItem.type = "save";
                newItem.heading = "Alert";
                newItem.description = response.data.message;
                return newItem;
              });
          } else {
            switch (true) {
              case response.data.message ==
                t("string-literals.study-already-submitted"):
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              case response.data.message ==
                t("string-literals.study-already-saved-form-msword"):
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              case response.data.message ==
                t("string-literals.typist-cannot-save-study"):
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              case response.data.message ==
                t(
                  "string-literals.study-can-not-save-study-assigned-to-other-radiologist"
                ):
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              case response.data.message ==
                t(
                  "string-literals.study-can-not-mark-preliminary-assigned-to-other-radiologist"
                ):
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              case response.data.message ==
                t(
                  "string-literals.can-not-save-or-submit-expired-study"
                ):
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              case response.data.message ==
                t(
                  "string-literals.can-not-save-closed-study"
                ):
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              case response.data.message ==
                t(
                  "string-literals.can-not-save-closed-study"
                ):
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              case response.data.message ==
                t(
                  "string-literals.can-not-save-or-submit-firm-deactivated"
                ):
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              default:
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Error";
                  newItem.description = t("string-literals.error-msg");
                  return newItem;
                });
                break;
            }
          }
          setLoaderRunning(false);
          ref.current.complete();
          setExternalReportingLoading(false);
        }
      }
    } catch (e) {
      setLoaderRunning(false);
      ref.current.complete();
      showToastv2(
        TOAST_TYPE.ERROR,
        t("string-literals.error-msg") + " Error Log: " + e.message
      );
    }
  };

  const isAddendumTextPresentInReport = () => {
    let isAddendumTextPresent = false;
    let poweredByFroalaRegex =
      /<p[^>]*>\s*Powered by\s*<a[^>]*>Froala Editor<\/a>\s*<\/p>/gi;
    patientReports.map((ele, index) => {
      ele.reportDetails == undefined
        ? (ele.reportDetails = ele.report)
        : (ele.reportDetails = ele.reportDetails);
      if (ele.reportDetails != undefined && ele.reportDetails != null) {
        if (
          ele.reportDetails.addendum !== "" &&
          ele.reportDetails.addendum != undefined
        ) {
          let modifiedHtmlString = ele.reportDetails.addendum;
          if (poweredByFroalaRegex.test(ele.reportDetails.addendum)) {
            modifiedHtmlString = ele.reportDetails.addendum.replace(
              poweredByFroalaRegex,
              ""
            );
          }
          if (modifiedHtmlString !== "") {
            isAddendumTextPresent = true;
          }
        }
      }
    });
    return isAddendumTextPresent;
  };


  const handleSubmitReport = async (
    state,
    keyImages,
    annotationData,
    annotationDataAI,
    allTextToolAnnotation,
    activeViewportIndex,
    passConflictTemp,
    addendumDisclaimerAddedByRadVal,
    showAddendumDisclaimerPopupVal,
    formattedReportAction,
    updatedReports,isPositive
  ) => {
    setPositive(isPositive);
    if (!enableLlmReport && enableReportRegenerate == true && !isClientReportExist && (PlatformHelper.isFahes() ? isPositive : true)) {
      setConfirmAlertModal(() => {
        const newItem = { ...confirmAlertModal };
        newItem.show = true;
        newItem.type = "submit";
        newItem.heading = "Alert";
        newItem.description =
          "There are unsaved changes. Are you sure you want to continue without regenerating report ?";
        return newItem;
      });
      if (state == true) {
        return;
      }
    }
    let isAddendumTextPresent = isAddendumTextPresentInReport();
    setShowAddendumDisclaimerPopup(showAddendumDisclaimerPopupVal);

    if (forceReinferenceInProgress) {
      setShowForceReinferenceModal(true);
      return;
    }
    if (
      isAddendumTextPresent &&
      addendumDisclaimerEnabled &&
      showAddendumDisclaimerPopup
    ) {
      setShowConfirmModal(true);
      setShowAddendumDisclaimerModal(true);
      return;
    }
    setAddendumDisclaimerAddedByRad(addendumDisclaimerAddedByRadVal); //state didn't get updated

    if (reportDoneStatusState === 2
      && (getEnv("REACT_APP_VDC_PLATFORM") == "true" || getEnv("REACT_APP_VDC_PLATFORM") == true)
      && userId != reviewerId
    ) {
      setConfirmAlertModal(() => {
        const newItem = { ...confirmAlertModal };
        newItem.show = true;
        newItem.type = "resubmit";
        newItem.heading = "Alert";
        newItem.description =
          "This report has already been submitted. If you still want to proceed, click 'Yes' Otherwise, click 'No'. Please remember to use the amendment format when making changes to any report.";
          return newItem;
      });
      if (state == true) {
        return;
      }
    }

    const submissionData = {
      keyImages,
      annotationData,
      annotationDataAI,
      allTextToolAnnotation,
      activeViewportIndex,
      passConflictTemp,
      addendumDisclaimerAddedByRadVal,
      formattedReportAction,
      updatedReports,
      isPositive
    };

    setSubmissionParams(submissionData);


    if ((patientReports.length == 0 && updatedReports?.length == 0) || !checkReportContent(updatedReports)) {
      setLoaderRunning(false);
      ref.current.complete();
      setExternalReportingLoading(false);
      setAlertSuccessModal(() => {
        const newItem = { ...alertSuccessModal };
        newItem.show = true;
        newItem.heading = "Alert";
        newItem.description =
          patientReports.length == 0
            ? t("string-literals.no-reports-added")
            : t("string-literals.empty-report");
        return newItem;
      });
      return;
    }    

    if (sanitizeReportContentForHL7) {

      let result = CheckAndRemoveUnparsableHtmlCharactersFromReport(updatedReports);
      if (result?.report?.replacedCounts > 0 || result?.report?.removedCounts > 0) {
        // Build message
        // Get unique replaced and removed values
        const replacedSet = new Set(result.report.replacements.map(r => `${r.original} → ${r.replacedWith}`));
        const removedSet = new Set(result.report.removals.map(r => `${r.original}`));

        const replacedList = Array.from(replacedSet).join("\n");
        const removedList = Array.from(removedSet).join("\n");

        let message = "Some unsupported characters were found in the report and have been removed/replaced to ensure compatibility.";
        if (replacedList) {
          message += `\n\nReplaced:\n${replacedList}`;
        }
        if (removedList) {
          message += `\n\nRemoved:\n${removedList}`;
        }

        setUnparsableDialogMessage(message);
        setShowUnparsableDialog(true);
        return;
      }
    }

    if (reportDoneStatusState !== 2 && formatterAgentEnabled && !formattedReportUsed && !isExternal && conflictSave == "0") {
      setPendingSubmission(() => proceedWithSubmission);
      setShowFormatterPopup(true);
      return;
    }
    proceedWithSubmission(submissionData);
  };

function CheckAndRemoveUnparsableHtmlCharactersFromReport(updatedReports) {
  let allReplacements = [];
  let allRemovals = [];
  let replacementCount = 0;
  let removalCount = 0;
  let result;

  const newReports = (updatedReports || patientReports).map((ele) => {
    let tempReportDetails = ele.reportDetails ?? { report: ele.report };
    if (tempReportDetails.report === undefined) {
      result = normalizeForHL7(tempReportDetails.finalReport);
      replacementCount += result?.report?.summary?.totalReplacements || 0;
      removalCount    += result?.report?.summary?.totalRemovals || 0;
      allReplacements.push(...(result?.report?.replacements || []));
      allRemovals.push(...(result?.report?.removals || []));
      tempReportDetails.finalReport = result.text;
    } else {
      result = normalizeForHL7(tempReportDetails.report);
      replacementCount += result?.report?.summary?.totalReplacements || 0;
      removalCount    += result?.report?.summary?.totalRemovals || 0;
      allReplacements.push(...(result?.report?.replacements || []));
      allRemovals.push(...(result?.report?.removals || []));
      tempReportDetails.report = result.text;
    }
    if(tempReportDetails.addendum) {
      result = normalizeForHL7(tempReportDetails.addendum);
      replacementCount += result?.report?.summary?.totalReplacements || 0;
      removalCount    += result?.report?.summary?.totalRemovals || 0;
      allReplacements.push(...(result?.report?.replacements || []));
      allRemovals.push(...(result?.report?.removals || []));
      tempReportDetails.addendum = result.text;
    }
    return { ...ele, reportDetails: tempReportDetails };
  });
  setPatientReports(newReports);
  return {
    report: {
      replacedCounts: replacementCount,
      removedCounts: removalCount,
      replacements: allReplacements,
      removals: allRemovals
    }
  };
}

function normalizeForHL7(input) {
  if (typeof input !== "string") input = String(input || "");

  // input = input.replace(/&nbsp;|\u00A0/g, " ");
  const replacements = []; // { original, replacedWith, index }
  const removals = [];     // { original, index }
  const replacedCounts = {}; // map replacementKey -> count
  const removedCounts = {};  // map original->count

  // First: replace entities (named & numeric)
  let text = input.replace(ENTITY_REGEX, (match, group, offset) => {
    // group: either '#123' or '#x1F' or 'amp' etc
    if (group.startsWith("#")) {
      // numeric entity
      let codePoint;
      if (group.startsWith("#x") || group.startsWith("#X")) {
        codePoint = parseInt(group.slice(2), 16);
      } else {
        codePoint = parseInt(group.slice(1), 10);
      }
      if (Number.isFinite(codePoint)) {
        const ch = String.fromCodePoint(codePoint);
        // If the decoded character is in CHAR_TO_TEXT, use that mapping
        if (charMap.has(ch)) {
          const replacement = charMap.get(ch);
          replacements.push({ original: match, replacedWith: replacement, index: offset });
          replacedCounts[replacement] = (replacedCounts[replacement] || 0) + 1;
          return replacement;
        }
        // else if the decoded char is an ASCII-safe char (printable), keep it
        if (isSafePrintable(ch)) {
          replacements.push({ original: match, replacedWith: ch, index: offset });
          replacedCounts[ch] = (replacedCounts[ch] || 0) + 1;
          return ch;
        }
        // not recognized -> remove
        removals.push({ original: match, index: offset });
        removedCounts[match] = (removedCounts[match] || 0) + 1;
        return "";
      } else {
        // can't parse -> remove
        removals.push({ original: match, index: offset });
        removedCounts[match] = (removedCounts[match] || 0) + 1;
        return "";
      }
    } else {
      // named entity
      const name = group; // e.g., 'amp', 'nbsp'
      if (namedMap.has(name)) {
        const replacement = namedMap.get(name);
        replacements.push({ original: match, replacedWith: replacement, index: offset });
        replacedCounts[replacement] = (replacedCounts[replacement] || 0) + 1;
        return replacement;
      }
      // Some named entities are numeric-like (e.g., "apos" sometimes missing in some old lists)
      // If not in namedMap -> remove
      removals.push({ original: match, index: offset });
      removedCounts[match] = (removedCounts[match] || 0) + 1;
      return "";
    }
  });

  // Second: replace direct Unicode characters based on CHAR_TO_TEXT
  // We'll walk text and replace characters present in charMap.
  // Use a regex built from keys to make it efficient.
  const charPattern = buildCharRegex(Array.from(charMap.keys()));
  if (charPattern) {
    text = text.replace(charPattern, (match, offset) => {
      const replacement = charMap.get(match);
      replacements.push({ original: match, replacedWith: replacement, index: offset });
      replacedCounts[replacement] = (replacedCounts[replacement] || 0) + 1;
      return replacement;
    });
  }

  // Third: collapse multiple spaces introduced (e.g., " and " around amp)
  text = text.replace(/[ \t\v\f\r]+/g, " ");
  text = text.replace(/&nbsp;|\u00A0/g, "");
  text = text.replace(/\u00A0/g, ""); // just in case some remain
  text = text.trim();

  // Remove unwanted control characters (keep \n and \r and \t as sensible)
  const beforeCtrl = text;
  text = text.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]+/g, "");
  if (text.length !== beforeCtrl.length) {
    // For reporting, we won't list every control char; just say they were removed
    removals.push({ original: "control-chars", index: -1 });
    removedCounts["control-chars"] = (removedCounts["control-chars"] || 0) + 1;
  }

  text = text.replace(/[\x80-\uFFFF]/g, (ch, offset) => {
  removals.push({ original: ch, index: offset });
  removedCounts[ch] = (removedCounts[ch] || 0) + 1;
  return "";
});
// Remove caret '^'
text = text.replace(/\^/g, (ch, offset) => {
  removals.push({ original: ch, index: offset });
  removedCounts[ch] = (removedCounts[ch] || 0) + 1;
  return "";
});
  // Trim
  text = text.trim();

  // Build a compact summary
  const summary = {
    replacedCounts,
    removedCounts,
    totalReplacements: Object.values(replacedCounts).reduce((a, b) => a + b, 0),
    totalRemovals: Object.values(removedCounts).reduce((a, b) => a + b, 0)
  };

  return {
    text,
    report: {
      replacements,
      removals,
      summary
    }
  };
}

/** helper: simple printable check for basic ASCII and a few common punctuation */
function isSafePrintable(ch) {
  const code = ch.codePointAt(0);
  return (code >= 32 && code <= 126) || code === 10 || code === 13 || code === 9;
}

/** helper: build regex that matches any of the characters in keys (escaped), sorted by length desc */
function buildCharRegex(chars) {
  if (!chars || chars.length === 0) return null;
  // sort by length desc to match multi-char sequences first (if any)
  chars.sort((a, b) => b.length - a.length);
  const escaped = chars.map(c => escapeForRegex(c)).join("|");
  return new RegExp(escaped, "g");
}

function escapeForRegex(s) {
  // escape special regex chars
  return s.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
}


  useEffect(() => {
    if (!showFormatterPopup && pendingSubmission) {
      proceedWithSubmission();
      setPendingSubmission(null);
    }

    if (!showFormatterPopup && pendingQCPass) {
      proceedWithQCPass();
      setPendingQCPass(null);
    }
  }, [showFormatterPopup]);

  const proceedWithSubmission = async (submissionData) => {
    if (!submissionParams && !submissionData) return;

    let data = !submissionParams ? submissionData : submissionParams;
    // setLoaderMessage("Submitting report...");
    setLoaderRunning(true);
    setExternalReportingLoading(true);
    ref.current.continuousStart();

    const params = new URLSearchParams(window.location.search);
    const blitzSession = params.get("blitzSession");

    try {
      let body = await getFormatedData(
        data.keyImages,
        data.annotationData,
        data.annotationDataAI,
        data.allTextToolAnnotation,
        data.activeViewportIndex,
        data.passConflictTemp,
        data.addendumDisclaimerAddedByRadVal,
        data.formattedReportAction ? data.formattedReportAction : formattedReportAction,
        data.updatedReports,
        data.isPositive
      );
      if (body?.loaded == true && body?.content == null) {
        setLoaderRunning(false);
        ref.current.complete();
        setExternalReportingLoading(false);
        setAlertSuccessModal(() => {
          const newItem = { ...alertSuccessModal };
          newItem.show = true;
          newItem.heading = "Alert";
          newItem.description =
            patientReports.length == 0
              ? t("string-literals.no-reports-added")
              : t("string-literals.empty-report");
          return newItem;
        });
        return;
      } else if (body.loaded == true && body.content != null) {
        let response = await submitReportTemplatesData(body.content, blitzSession);
        
        if (
          (response.status === 200 && (response.data.result == "SUCCESS" || response.data.result == "WARNING")) ||
          (data.passConflictTemp != null &&
            data.passConflictTemp == true &&
            data.response.status === 200 &&
            (response.data.result == "SUCCESS" || response.data.result == "WARNING"))
        ) {
          if (enableLlmReport && agenticInterfaceRef?.current?.logSubmitEvents) {
            agenticInterfaceRef.current.logSubmitEvents();
          }

          if (!isExternal && !isWidget) {
            getData(false, false);
          } else {
            setIsExternal(false);
            setIsWidget(false);
            setIsClientReportExistExternalModal(null);
            setUpdateDoneSubmitDone(() => {
              const newItem = { ...updateRowSubmitDone };
              newItem.id = studyId;
              newItem.show = true;
              return newItem;
            });
            setOpenReportModal(false);
          }
          setLoaderRunning(false);
          ref.current.complete();
          setExternalReportingLoading(false);
          if (response.data.result == "WARNING") {
            showToastv2(
              TOAST_TYPE.INFO,
              response.data.message
            );
          }

          if (blitzSession) {
            window.parent.goToNextStudy(false);
          }

          const url = response?.data?.data?.reportPreviewUrl?.url;    
          setShowSubmitTick(true);
          if (response.data.result == "WARNING") {
            setTimeout(() => {
              if (url) {
                try {
                  const p = new URL(url);
                 window.open(getSafeRedirectUrl(url), "_blank", "noopener,noreferrer");
                } catch (e) { /* invalid url */ }
              }
              window.close();
              setShowSubmitTick(false);
            }, 3000);
          } else {
            setTimeout(() => {
              if (url) {
                try {
                  const p = new URL(url);
                  window.open(getSafeRedirectUrl(url), "_blank", "noopener,noreferrer");
                } catch (e) { /* invalid url */ }
              }
              window.close();
              setShowSubmitTick(false);
            }, 2000);
          }

        } else if (response.data.result == "FAILURE") {
          if (
            response?.data?.message != null &&
            response?.data?.message?.includes(
              "Found conflict in patient sex and report content in"
            )
          ) {
            let conflictSaveTemp = response?.data?.message?.includes(
              "Found conflict in patient sex and report content in"
            )
              ? "1"
              : "0";
            setConflictSave("1");
            if (conflictSaveTemp == "1")
              setConfirmAlertModal(() => {
                const newItem = { ...confirmAlertModal };
                newItem.isConflictPopup = true;
                newItem.show = true;
                newItem.type = "submit";
                newItem.heading = "Alert";
                newItem.description = response.data.message;
                return newItem;
              });
          } else {
            switch (true) {
              case response?.data?.message != null &&
                response.data.message.includes(
                  t("string-literals.not-allowed-submit-report")
                ):
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              case response.data.message ==
                t("string-literals.study-already-submitted-from-msword"):
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              case response.data.message ==
                t("string-literals.message.can.not.submitted.study"):
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              case response.data.message.includes(
                t(
                  "string-literals.cannot.submit.study.report.incomplete.findings.impression"
                )
              ):
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              case response.data.message ==
                t(
                  "string-literals.can-not-save-or-submit-expired-study"
                ):
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              case response.data.message ==
                t(
                  "string-literals.not-locked-study"
                ):
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              case response.data.message ==
                t(
                  "string-literals.can-not-submit-closed-study"
                ):
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              case response.data.message ==
                t(
                  "string-literals.can-not-submit-closed-study"
                ):
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              case response.data.message ==
                t(
                  "string-literals.can-not-submit-already-submitted-study"
                ):
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              case response.data.message ==
                t(
                  "string-literals.can-not-submit-peer-review-study"
                ):
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              case response.data.message ==
                t(
                  "string-literals.can-not-submit-unassigned-study"
                ):
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              case response.data.message ==
                t(
                  "string-literals.can-not-submit-as-submission-disabled"
                ):
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              case response.data.message ==
                t(
                  "string-literals.can-not-submit-before-preliminary-qc-pass"
                ):
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              case response.data.message ==
                "Study cannot be submitted as its already submitted":
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              case response.data.message ==
                t(
                  "string-literals.can-not-save-or-submit-firm-deactivated"
                ):
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              default:
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Error";
                  newItem.description = t("string-literals.error-msg");
                  return newItem;
                });
                break;
            }
          }
          //alert("Something goes wrong");
          //showToastv2(TOAST_TYPE.ERROR, t("string-literals.goesWrong"));
          setLoaderRunning(false);
          ref.current.complete();
          setExternalReportingLoading(false);
        }
      }
    } catch (e) {
      console.log(e);
      setLoaderRunning(false);
      ref.current.complete();
      setExternalReportingLoading(false);
      showToastv2(
        TOAST_TYPE.ERROR,
        t("string-literals.error-msg") + " Error Log: " + e.message
      );
    }
  };

  const reformateBoundingBox = async (
    annotationData,
    annotationDataAI,
    activeViewportIndex
  ) => {
    const activeViewport = await getViewport(activeViewportIndex);

    if (activeViewport != null || activeViewport != undefined) {
      let data = {};
      let allAnnotationUID = new Set();
      // `?.` only guards a null viewport; getImageData() itself returns undefined when the
      // viewport has no image loaded (e.g. after all key images are removed). Resolve it once
      // here so the inner maps can skip the world->index conversion instead of destructuring
      // `imageData` off undefined and throwing.
      const viewportImageData = activeViewport?.getImageData?.();
      for (const key in annotationData) {
        if (!data[key]) {
          data[key] = {};
        }

        for (const key2 in annotationData[key]) {
          if (annotationData[key] != undefined) {
            annotationData[key][key2]?.map((ele, ind) => {
              allAnnotationUID.add(ele.annotation.annotationUID);
            });
            let temp = [];
            temp = (annotationData[key][key2]?.map((ele, ind) => {
              const { imageData, dimensions } = viewportImageData || {};
              if (!imageData) return null;

              let updatedPoints = [];
              updatedPoints.push(
                imageData.worldToIndex(ele.annotation.data.handles.points[0])
              );
              updatedPoints.push(
                imageData.worldToIndex(ele.annotation.data.handles.points[1])
              );
              updatedPoints.push(
                imageData.worldToIndex(ele.annotation.data.handles.points[2])
              );
              updatedPoints.push(
                imageData.worldToIndex(ele.annotation.data.handles.points[3])
              );

              let updatedJson = savingBoundingBoxJsonData(
                updatedPoints,
                ele.annotation.annotationUID
              );
              return JSON.stringify(updatedJson);
            }) || []).filter((x) => x != null);
            if (temp.length == 0) {
              continue;
            } else {
              data[key][key2] = temp;
            }
          }
        }
      }

      for (const key in annotationDataAI) {
        if (!data[key]) {
          data[key] = {};
        }

        for (const key2 in annotationDataAI[key]) {
          if (annotationDataAI[key] != undefined) {
            // Filter out AI annotations whose UID was already handled by the
            // annotationData loop above (user-edited or user-added versions
            // take priority and must not be overwritten).
            const newAiEntries = (annotationDataAI[key][key2] || []).filter(
              (ele) => !allAnnotationUID.has(ele.annotation.annotationUID)
            );

            newAiEntries.forEach((ele) =>
              allAnnotationUID.add(ele.annotation.annotationUID)
            );

            let temp = (newAiEntries.map((ele, ind) => {
              const { imageData, dimensions } = viewportImageData || {};
              if (!imageData) return null;

              let updatedPoints = [];
              updatedPoints.push(
                imageData.worldToIndex(ele.annotation.data.handles.points[0])
              );
              updatedPoints.push(
                imageData.worldToIndex(ele.annotation.data.handles.points[1])
              );
              updatedPoints.push(
                imageData.worldToIndex(ele.annotation.data.handles.points[2])
              );
              updatedPoints.push(
                imageData.worldToIndex(ele.annotation.data.handles.points[3])
              );

              let updatedJson = savingBoundingBoxJsonData(
                updatedPoints,
                ele.annotation.annotationUID
              );
              return JSON.stringify(updatedJson);
            }) || []).filter((x) => x != null);

            if (temp.length === 0) {
              // No new AI-only entries; keep any user entries that already exist
              continue;
            } else if (data[key][key2]) {
              // Merge: append AI-only entries after the user-added entries
              data[key][key2] = [...data[key][key2], ...temp];
            } else {
              data[key][key2] = temp;
            }
          }
        }
      }
      data["AnnotationUIDs"] = allAnnotationUID;
      return { loadedComplete: true, measurementData: data };
    }
  };

  const getAnnotationData = (annotationId) => {
    for (let i = 0; i < reportAnnotationState.annotations_stuff.length; i++) {
      if (reportAnnotationState.annotations_stuff[i].id === annotationId) {
        return reportAnnotationState.annotations_stuff[i];
      }
    }
  };

  function getSelected_Ai_Annotations() {
    let selected_annotations = [];
    let annotation_stuff = reportAnnotationState.annotations_stuff;

    for (let i = 0; i < annotation_stuff.length; i++) {
      let annotationObj = annotation_stuff[i];
      let id = annotationObj.id;
      if (
        annotationObj.is_present === 1 &&
        annotationObj.ai_predicted === 1 &&
        (annotationObj.is_locked === true ||
          annotationObj.is_locked_check === true)
      ) {
        selected_annotations.push(id);
      }
    }

    return selected_annotations.sort();
  }

  const getSourceId = () => {
    switch (true) {
      case window?.location?.pathname?.includes(REPORT_SUBMIT_SOURCE.STUDYLIST):
        return 1;
      case window?.location?.pathname?.includes(
        REPORT_SUBMIT_SOURCE.ADVANCE_VIEWER
      ):
        return 3;
      case !window?.location?.pathname?.includes(
        REPORT_SUBMIT_SOURCE.ADVANCE_VIEWER
      ):
        return 2;
      default:
        return 2;
    }
  };

  function getNonSelected_Ai_Annotations() {
    let annotations = [];
    let annotation_stuff = reportAnnotationState.annotations_stuff;

    for (let i = 0; i < annotation_stuff.length; i++) {
      let annotationObj = annotation_stuff[i];
      let id = annotationObj.id;
      if (
        annotationObj.is_present === 1 &&
        annotationObj.ai_predicted === 1 &&
        (annotationObj.is_locked === false ||
          annotationObj.is_locked_check === false)
      ) {
        annotations.push(id);
      }
    }
    // iterate over deleted annotatiosn & send them as non selected annotaions
    for (
      let i = 0;
      i < addStoreAnnotationState?.annotations_stuff?.length;
      i++
    ) {
      let annotation_obj = addStoreAnnotationState?.annotations_stuff[i];
      let id = annotation_obj.id;
      if (
        annotation_obj.is_present === 1 &&
        annotation_obj.ai_predicted === 1 &&
        !annotations.includes(id)
      ) {
        annotations.push(id);
      }
    }
    return annotations.sort();
  }

  const getFormattedReports = async () => {
    // let data = await reformateBoundingBox(
    //   annotationData,
    //   annotationDataAI,
    //   activeViewportIndex
    // );

    // if (isExternal || isAdvanceViewer) {
    let opt = [];

    // Carry the live "Images" popup layout into the report payload so the QC pass / report save
    // round-trips the captured-image arrangement instead of dropping it (which made the backend
    // fall back to the default layout and collapse all images onto the first report). Same source
    // and shape as persistCapturedPages: live `capturedPages` for the owned tab, the map for the
    // rest, keyed by the tab key (the StudyReport row id once saved).
    const liveOwner = capturedPagesOwnerKeyRef.current;
    const capturedPagesByTabKey = { ...(capturedPagesMapRef.current || {}) };
    if (liveOwner) capturedPagesByTabKey[liveOwner] = capturedPages;
    const toCapturedPagesPayload = (pages) =>
      (pages || []).map((p, pi) => ({
        pageKey: p.id,
        pageColumns: p.columns,
        displayOrder: pi,
        images: (p.images || []).map((img, ii) => ({
          imageKey: img.id,
          sopInstanceUid: img.sopInstanceUid,
          scImageId: img.scImageId,
          displayOrder: ii,
        })),
      }));

    patientReports.map((ele, index) => {
      ele.reportDetails == undefined
        ? (ele.reportDetails = ele.report)
        : (ele.reportDetails = ele.reportDetails);
      if (ele.reportDetails != undefined && ele.reportDetails != null) {
        // Only send capturedPages when a layout exists for this tab; otherwise leave it null so the
        // backend preserves the existing DB layout rather than treating the report as having none.
        const hasLayout = Object.prototype.hasOwnProperty.call(
          capturedPagesByTabKey,
          ele.key
        );
        opt.push({
          reportTemplateId:
            ele.reportDetails.reportTemplateId == undefined
              ? ele.reportDetails.id
              : ele.reportDetails.reportTemplateId,
          reportTemplateTitle:
            ele.reportDetails.title == undefined
              ? ele.reportDetails.reportTemplateTitle
              : ele.reportDetails.title,
          finalReport:
            ele.reportDetails.report == undefined
              ? ele.reportDetails.finalReport
              : ele.reportDetails.report,
          isSuperSpecialReport:
            ele.reportDetails.isSuperSpecialReport == undefined
              ? 0
              : ele.reportDetails.isSuperSpecialReport,
          addendum:
            ele.reportDetails.addendum == undefined
              ? ""
              : ele.reportDetails.addendum,
          capturedPages: hasLayout
            ? toCapturedPagesPayload(capturedPagesByTabKey[ele.key])
            : null,
          capturedPagesCustomized: !!capturedPagesCustomizedMapRef.current[ele.key],
        });
      }
    });

    let flag = true;
    opt.map((ele, index) => {
      const aux = document.createElement("div");
      aux.innerHTML = ele.finalReport;
      const regexPattern = /[^\x09][^\x0A][^\x0D][^\x20][^\x20-\uD7FF][^\uE000-\uFFFD\u{10000}-\u{10FFFF}][^\uD800-\uDBFF]/gu;

      if (ele?.finalReport != null && ele.finalReport != undefined) {
        var poweredByFroalaRegex =
          /<p[^>]*>\s*Powered by\s*<a[^>]*>Froala Editor<\/a>\s*<\/p>/gi;

        if (poweredByFroalaRegex.test(ele.finalReport)) {
          var modifiedHtmlString = ele.finalReport.replace(
            poweredByFroalaRegex,
            ""
          );
          ele.finalReport = modifiedHtmlString;
        } else {
        }
      }

      if (ele?.addendum != null && ele.addendum != undefined) {
        var poweredByFroalaRegex =
          /<p[^>]*>\s*Powered by\s*<a[^>]*>Froala Editor<\/a>\s*<\/p>/gi;

        if (poweredByFroalaRegex.test(ele.addendum)) {
          var modifiedHtmlString = ele.addendum.replace(
            poweredByFroalaRegex,
            ""
          );
          ele.addendum = modifiedHtmlString;
        } 
      }

      const trimmedContent = aux.innerText.trim();
      if (ele)
        if (
          trimmedContent == "" ||
          trimmedContent == "Powered by Froala Editor"
        ) {
          flag = false;
        }
    });

    if (!flag) {
      return null;
    }

    if (patientReports.length == 0) {
      return null;
    }
    return opt;
    // }
  }

  const getFormatedData = async (
    keyImages,
    annotationData,
    annotationDataAI,
    allTextToolAnnotation,
    activeViewportIndex,
    passConflictTemp,
    addendumDisclaimerAddedByRadVal,
    formattedReportAction,
    updatedReports,
    isPositive
  ) => {
    let data = await reformateBoundingBox(
      annotationData,
      annotationDataAI,
      activeViewportIndex
    );
    if (
      (data != undefined && data?.loadedComplete == true) ||
      isExternal || isWidget || 
      isAdvanceViewer
    ) {
      let flag = checkReportContent(updatedReports);

      if (!flag) {
        return { loaded: true, content: null };
      }

      if (patientReports.length == 0 && (updatedReports === undefined || updatedReports?.length == 0)) {
        return { loaded: true, content: null };
      }

      // let annotations = JSON.stringify(getAllSelectedAnnotation());
      // if(matches != null && matches.length > 0 ){
      //   return null;
      // }
      let final_ai_annotations = {};
      let options_json = "";
      let extra_data = null;
      if (!isExternal && !isAdvanceViewer && !isWidget) {
        let locked_groups = {};
        let keys = Object.keys(reportAnnotationState.group_selections);
        keys.forEach((key) => {
          let annotation = getAnnotationData(parseInt(key));
          if (
            annotation.is_locked == true ||
            annotation.is_locked_check == true
          ) {
            locked_groups[key] = reportAnnotationState.group_selections[key];
          }
        });
        let groups_json = JSON.stringify(locked_groups);
        let locked_selections = {};
        keys = Object.keys(reportAnnotationState.selections);
        keys.forEach((key) => {
          let annotation = getAnnotationData(parseInt(key));
          if (
            annotation.is_locked == true ||
            annotation.is_locked_check == true
          ) {
            locked_selections[key] = reportAnnotationState.selections[key];
          }
        });

        let nonSelectedAiAnnotation = getNonSelected_Ai_Annotations();
        let selectedAiAnnotation = getSelected_Ai_Annotations();

         nonSelectedAiAnnotation.forEach((a) => {
          final_ai_annotations[a] = 0;
        });
        selectedAiAnnotation.forEach((a) => {
          final_ai_annotations[a] = 1;
        });
        options_json = JSON.stringify(locked_selections);
        extra_data = JSON.stringify(reportAnnotationState.extra_value);
      } else {
      }

      const findings = observationState?.findings?.map(f => {
        if (f.pathologyName.toLowerCase() == "other") {
          f.findingSentences[0].sentence = findingSentence;
          return f;
        } else {
          return f;
        }
      })

      const body = {
        studyReportSaveDto: {
          id: studyId,
          annotationJson:
            isExternal || isAdvanceViewer || isWidget ? null : annotationsJson,
          aiAnnotationJson: JSON.stringify(
            isExternal || isAdvanceViewer || isWidget ? "" : final_ai_annotations
          ),
          studyOptionsJson: options_json,
          extraValue: extra_data,
          conflictSave:
            passConflictTemp != null && passConflictTemp == true
              ? conflictSave == "0"
                ? "0"
                : "1"
              : "0",
          raiseAlert: raiseAlertValue,
          reportDoneStatus: 1,
          smartReportSubmittedValuesJson: null,
          studyReportList: getReportContent(updatedReports),
          imageAnnotationMeasurements: [],
          imageToolAnnotationMeasurements: [],
          studyKeyImages: isExternal || isAdvanceViewer || isWidget ? [] : keyImages,
          assignmentIds: [],
          addendumDisclaimerAddedByRad: addendumDisclaimerAddedByRadVal,
          formattedReportAction: formattedReportAction,
          source: getSourceId(),
          studyObservationDto: selectedCategoryTemplate === "dsrTemplate" ? {
            clinicalHistory: observationState.clinicalHistory,
            technique: observationState.technique,
            impression: observationState.impressions,
            comparison: observationState.comparison,
            findings: findings == null || findings.length == 0 ? [{
              pathologyName: "other",
              findingSentences: [{ sentence: "No Findings", aiSentence: false, selected: true }]
            }] : findings
          } : null,
          timeTakenToSubmit: Date.now() - pageOpenTime,
          isPositive:isPositive
        },
        isExternal: isExternal || isAdvanceViewer || isWidget,
        annotationJson: isExternal || isAdvanceViewer || isWidget ? null : annotationsJson,
        studyOptionsJson: options_json,
        allBoundingBox:
          isExternal || isAdvanceViewer || isWidget ? [] : data.measurementData,
        allTextToolData:
          isExternal || isAdvanceViewer || isWidget ? [] : allTextToolAnnotation,
      };

      return { loaded: true, content: body };
    }
  };

  const runAutosaveDraft = async () => {
    if (isWidget) {
      return;
    }
    const {
      keyImages,
      annotationData,
      annotationDataAI,
      allTextToolAnnotation,
      activeViewportIndex,
    } = autosaveDepsRef.current;

    if (!studyId || !autosaveDirtyRef.current) {
      return;
    }

    try {
      setReportAutosaveStatus("saving");
      const body = await getFormatedData(
        keyImages,
        annotationData,
        annotationDataAI,
        allTextToolAnnotation,
        activeViewportIndex,
        null,
        false,
        undefined,
        undefined,
        undefined
      );
      if (!body?.loaded || body?.content == null) {
        setReportAutosaveStatus(autoSaveReportPreference ? "on" : "off");
        return;
      }
      const params = new URLSearchParams(window.location.search);
      const blitzSession = params.get("blitzSession");
      const response = await autosaveReportData(body.content, blitzSession);
      if (!response) {
        setReportAutosaveBlocked(true);
        setReportAutosaveOffReason(
          t("string-literals.autosave-draft-failed")
        );
        setReportAutosaveStatus("off");
        showToastv2(
          TOAST_TYPE.ERROR,
          t("string-literals.draft-could-not-save")
        );
        return;
      }
      if (
        response?.status === 200 &&
        (response?.data?.result === "SUCCESS" ||
          response?.data?.result === "WARNING")
      ) {
        setReportAutosaveBlocked(false);
        autosaveDirtyRef.current = false;
        setReportAutosaveDirty(false);
        setReportAutosaveOffReason("");
        setReportAutosaveLastSavedAt(new Date());
        setReportAutosaveStatus("saved");
        window.setTimeout(() => {
          setReportAutosaveStatus((prev) =>
            prev === "saved" ? "on" : prev
          );
        }, 2500);
      } else {
        const failureMessage =
          response?.data?.message || t("string-literals.draft-not-saved");
        setReportAutosaveBlocked(true);
        setReportAutosaveOffReason(
          response?.data?.message ||
            t("string-literals.autosave-draft-failed")
        );
        setReportAutosaveStatus("off");
        showToastv2(TOAST_TYPE.ERROR, failureMessage);
      }
    } catch (e) {
      console.debug("report autosave failed", e);
      setReportAutosaveBlocked(true);
      setReportAutosaveOffReason(
        t("string-literals.autosave-draft-failed")
      );
      setReportAutosaveStatus("off");
      showToastv2(TOAST_TYPE.ERROR, t("string-literals.draft-not-saved"));
    }
  };

  useEffect(() => {
    const isTypist = roles[0] === USERTYPES.TYPIST;
    const isRadiologist = roles[0] === USERTYPES.RADIOLOGIST;
    const isStudyContextReady =
      studyId != null &&
      reportDoneStatusState != null &&
      (isTypist || reportingDoctorName != null);
    const isReportingDoctorResolved =
      reportingDoctorName !== null &&
      reportingDoctorName !== undefined &&
      reportingDoctorName !== "";
    const shouldWaitForExternalAssignment =
      isExternal && !isTypist && !isReportingDoctorResolved;
    const isReportedOrQcState =
      reportDoneStatusState === REPORTDONESTATUS.REPORTED ||
      reportDoneStatusState === REPORTDONESTATUS.QC_REVIEW ||
      reportDoneStatusState === REPORTDONESTATUS.QC_FIX ||
      reportDoneStatusState === REPORTDONESTATUS.QC_VERIFY ||
      reportDoneStatusState === REPORTDONESTATUS.PRELIMINARY_QC_REVIEW ||
      reportDoneStatusState === REPORTDONESTATUS.PRELIMINARY_QC_FIX ||
      reportDoneStatusState === REPORTDONESTATUS.PRELIMINARY_QC_VERIFY;
    const isDraftEligibleRole = isRadiologist || isTypist;
    // Radiologist assignment is lock/reportingDoctor based; typist uses existing save enablement.
    const isAssignedEditor = isRadiologist
      ? reportingDoctorName === username
      : isTypist
        ? !disableSave
        : false;
    const eligible =
      autoSaveReportPreference &&
      isDraftEligibleRole &&
      !reportAutosaveBlocked &&
      (isExternal || reportMenu === true) &&
      isAssignedEditor &&
      studyId &&
      !isWidget &&
      !isReportedOrQcState &&
      !disableEditReport;


    if (!isStudyContextReady) {
      return undefined;
    }

    if (shouldWaitForExternalAssignment) {
      return undefined;
    }

    if (!eligible) {
      let reason = "";
      if (!autoSaveReportPreference) reason = "Auto-save off";
      else if (!isDraftEligibleRole) reason = "Auto-save off";
      else if (!isExternal && !reportMenu) reason = "Auto-save off";
      else if (reportAutosaveBlocked)
        reason = t("string-literals.autosave-draft-failed");
      else if (!isAssignedEditor)
        reason = "Auto-save off: study unassigned";
      else if (isReportedOrQcState) reason = "Auto-save off: report in QC/submitted state";
      else if (disableEditReport) reason = "Auto-save off: editing disabled";
      setReportAutosaveOffReason(reason);
      if (autoSaveReportPreference && isDraftEligibleRole) {
        setReportAutosaveStatus((s) => (s === "saved" ? s : "off"));
      }
      return undefined;
    }

    setReportAutosaveOffReason("");
    setReportAutosaveStatus((s) => (s === "saving" ? "saving" : "on"));

    const intervalSec = Number(reportAutosaveIntervalSec);
    if (!intervalSec || intervalSec <= 0) {
      setReportAutosaveStatus("off");
      setReportAutosaveOffReason("Auto-save off: interval not configured");
      return undefined;
    }
    const ms = intervalSec * 1000;
    const timer = window.setTimeout(() => {
      if (autosaveDirtyRef.current) {
        runAutosaveDraft();
      }
    }, ms);

    return () => window.clearTimeout(timer);
  }, [
    autosaveScheduleVersion,
    autoSaveReportPreference,
    reportMenu,
    reportAutosaveBlocked,
    reportingDoctorName,
    username,
    disableSave,
    studyViewerData?.checkStudyExpired,
    studyId,
    isExternal,
    isWidget,
    isAdvanceViewer,
    reportDoneStatusState,
    disableEditReport,
    roles[0],
    reportAutosaveIntervalSec,
  ]);

  useEffect(() => {
    if (!studyParentId || isWidget || !firmId) {
      return undefined;
    }
    let cancelled = false;
    (async () => {
      try {
        const prefRes = await userPreference();
        if (
          cancelled ||
          prefRes?.status !== 200 ||
          prefRes?.data?.result !== "SUCCESS"
        ) {
          return;
        }
        const v = !!prefRes?.data?.data?.userPreference?.autoSaveReport;
        const autoPopulate = !!prefRes?.data?.data?.userPreference?.autoPopulateManualPathology;
        setAutoSaveReportPreference(v);
        setAutoPopulateManualPathology(autoPopulate);
        setReportAutosaveStatus(v ? "on" : "off");
      } catch (_) {
        /* ignore */
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [studyParentId, isExternal, isWidget, firmId]);

  useEffect(() => {
    autosaveDirtyRef.current = false;
    setReportAutosaveDirty(false);
  }, [studyParentId, isExternal, isWidget]);

  const keepReportPanelOpenAfterSnapshotAction = () => {
    studyViewerData?.setReportMenu?.(true);
  };

  const handleSnapshotRecoveryAccept = () => {
    if (!snapshotDraftPatientReports?.length) {
      setSnapshotRecoveryModalOpen(false);
      keepReportPanelOpenAfterSnapshotAction();
      return;
    }
    setPatientReports(snapshotDraftPatientReports);
    handleChangeTemplate(
      snapshotDraftPatientReports[snapshotDraftPatientReports.length - 1]
    );
    setSnapshotRecoveryModalOpen(false);
    setSnapshotRecoveryReopenVisible(false);
    setSnapshotDraftPatientReports([]);
    setSnapshotOfficialPatientReports([]);
    autosaveDirtyRef.current = false;
    setReportAutosaveDirty(false);
    setAutosaveScheduleVersion((v) => v + 1);
    keepReportPanelOpenAfterSnapshotAction();
  };

  const handleSnapshotRecoveryReject = async () => {
    if (studyId) {
      try {
        await discardReportSnapshot(studyId);
      } catch (_) {
        /* ignore */
      }
    }
    setSnapshotRecoveryModalOpen(false);
    setSnapshotRecoveryReopenVisible(false);
    setSnapshotDraftPatientReports([]);
    setSnapshotOfficialPatientReports([]);
    autosaveDirtyRef.current = false;
    setReportAutosaveDirty(false);
    setAutosaveScheduleVersion((v) => v + 1);
    keepReportPanelOpenAfterSnapshotAction();
  };

  const handleSnapshotRecoveryClose = () => {
    setSnapshotRecoveryModalOpen(false);
    setSnapshotRecoveryReopenVisible(true);
    autosaveDirtyRef.current = false;
    setReportAutosaveDirty(false);
    keepReportPanelOpenAfterSnapshotAction();
  };

  const handleSnapshotRecoveryReopen = () => {
    setSnapshotRecoveryModalOpen(true);
    setSnapshotRecoveryReopenVisible(false);
  };

  useEffect(() => {
    if (reportAutosaveDirty) {
      setSnapshotRecoveryReopenVisible(false);
    }
  }, [reportAutosaveDirty]);

  const checkReportContent = (updatedReports) => {
    let opt = getReportContent(updatedReports);
    let matches = [];
    let flag = true;
    opt.map((ele, index) => {
      const aux = document.createElement("div");
      aux.innerHTML = ele.finalReport;

      const regexPattern =
        /[^\x09][^\x0A][^\x0D][^\x20][^\x20-\uD7FF][^\uE000-\uFFFD\u{10000}-\u{10FFFF}][^\uD800-\uDBFF]/gu;


      if (ele?.finalReport != null && ele.finalReport != undefined) {
        var poweredByFroalaRegex =
          /<p[^>]*>\s*Powered by\s*<a[^>]*>Froala Editor<\/a>\s*<\/p>/gi;

        if (poweredByFroalaRegex.test(ele.finalReport)) {
          var modifiedHtmlString = ele.finalReport.replace(
            poweredByFroalaRegex,
            ""
          );
          ele.finalReport = modifiedHtmlString;
        }
      }

      if (ele?.addendum != null && ele.addendum != undefined) {
        var poweredByFroalaRegex =
          /<p[^>]*>\s*Powered by\s*<a[^>]*>Froala Editor<\/a>\s*<\/p>/gi;

        if (poweredByFroalaRegex.test(ele.addendum)) {
          var modifiedHtmlString = ele.addendum.replace(
            poweredByFroalaRegex,
            ""
          );
          ele.addendum = modifiedHtmlString;
        }
      }

      const trimmedContent = aux.innerText.trim();
      if (ele)
        if (
          trimmedContent == "" ||
          trimmedContent == "Powered by Froala Editor"
        ) {
          flag = false;
        }
    });

    return flag;
  }

  const getReportContent = (updatedReports) => {
    let opt = [];
    let reports = updatedReports ? updatedReports : patientReports;

    reports.map((ele, index) => {
      ele.reportDetails == undefined
        ? (ele.reportDetails = ele.report)
        : (ele.reportDetails = ele.reportDetails);
      if (ele.reportDetails != undefined && ele.reportDetails != null) {
        opt.push({
          reportTemplateId:
            ele.reportDetails.reportTemplateId == undefined
              ? ele.reportDetails.id
              : ele.reportDetails.reportTemplateId,
          reportTemplateTitle:
            ele.reportDetails.title == undefined
              ? ele.reportDetails.reportTemplateTitle
              : ele.reportDetails.title,
          finalReport:
            ele.reportDetails.report == undefined
              ? ele.reportDetails.finalReport
              : ele.reportDetails.report,
          isSuperSpecialReport:
            ele.reportDetails.isSuperSpecialReport == undefined
              ? 0
              : ele.reportDetails.isSuperSpecialReport,
          addendum:
            ele.reportDetails.addendum == undefined
              ? ""
              : ele.reportDetails.addendum,
          // Round-trip the customization flag: when false the backend ignores any persisted pages
          // and renders the derived default layout (so captures print without opening the popup).
          // Treat a report as customized whenever we are sending it captured pages — the flag ref and
          // the pages ref are populated separately (the flag only in persistCapturedPages' success
          // callback), so they can drift out of sync; deriving from the pages keeps the second report's
          // images from collapsing onto the first when only the flag was lost.
          capturedPagesCustomized:
            !!capturedPagesCustomizedMapRef.current[ele.key] ||
            (capturedPagesMapRef.current[ele.key] || []).length > 0,
          capturedPages: (capturedPagesMapRef.current[ele.key] || []).map((p, pi) => ({
            pageKey: p.id,
            pageColumns: p.columns,
            displayOrder: pi,
            images: (p.images || []).map((img, ii) => ({
              imageKey: img.id,
              sopInstanceUid: img.sopInstanceUid,
              scImageId: img.scImageId,
              displayOrder: ii,
            })),
          })),
        });
      }
    });

    return opt;
  }

  const regenerateClick = () => {
    let allAddedTabs = patientReports;
    let flag = false;
    allAddedTabs.map((ele, index) => {
      if (ele.text == RSNAModalContent.text) {
        flag = true;
        return;
      }
    });

    if (flag) {
      allAddedTabs = patientReports.filter((ele, index) => {
        if (ele.text != RSNAModalContent.text) {
          return ele;
        }
      });
    }
    setPatientReports(allAddedTabs);
    let generatedReport = generateRSNAReport();
    if (flag) {
      let rsnaContent = RSNAModalContent;
      if (rsnaContent.report.report != undefined) {
        rsnaContent.report.report = generatedReport;
      }
      allAddedTabs = patientReports.map((ele, index) => {
        if (ele.text === RSNAModalContent.text) {
          ele.reportDetails = rsnaContent.report;
        }
        return ele;
      });
    } else {
      let obj = {
        finalReport: generatedReport,
        reportTemplateId: RSNAModalContent.id,
        reportTemplateTitle: RSNAModalContent.text,
        isSuperSpecialReport: 0,
      };
      allAddedTabs.push({
        key: RSNAModalContent.key,
        text: RSNAModalContent.text,
        isSuperSpecialReport: 0,
        reportDetails: obj,
      });
    }
    setPatientReports(allAddedTabs);

    let temp = allAddedTabs.filter((ele, ind) => {
      if (ele.text == RSNAModalContent.text) {
        return ele;
      }
    });
    handleChangeTemplate(temp[0]);

    autosaveDirtyRef.current = true;
    setReportAutosaveDirty(true);
    setAutosaveScheduleVersion((v) => v + 1);
  };

  const regenerateHRCT = (props) => {
    let allAddedTabs = patientReports;

    let flag = false;

    allAddedTabs.map((ele, index) => {
      if (
        ele.reportDetails?.reportTemplateId == props.content.key ||
        ele.reportDetails?.id == props.content.key
      ) {
        flag = true;
        return;
      }
    });
    if (flag) {
      allAddedTabs = patientReports.map((ele, ind) => {
        if (
          ele.reportDetails?.reportTemplateId == props.content.key ||
          ele.reportDetails?.id == props.content.key
        ) {
          ele.reportDetails = props.content.reportDetails;
          if (ele.reportDetails.reportTemplateId != undefined) {
            ele.reportDetails.reportTemplateId = props.content.key;
          } else {
            ele.reportDetails.id = props.content.key;
          }
        }
        return ele;
      });
    } else {
      let tempReport = props.content;
      tempReport.reportTemplateId = props.content.key;
      allAddedTabs.push({
        key: props.content.key,
        text: props.content.text,
        isSuperSpecialReport: 0,
        reportDetails: props.content.reportDetails,
      });
    }
    setPatientReports(allAddedTabs);
    setHasUnsavedChanges(true);
    autosaveDirtyRef.current = true;
    setReportAutosaveDirty(true);
    setAutosaveScheduleVersion((v) => v + 1);
    let temp = allAddedTabs.filter((ele, ind) => {
      if (ele.text.includes(props.content.text)) {
        return ele;
      }
    });
    handleChangeTemplate(temp[0]);
  };

  const updatedHTMLString = (str) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = DOMPurify.sanitize(str);
    const elements = tempDiv.querySelectorAll("div");
    for (const element of elements) {
      if (
        element.textContent.includes("CORADS:") ||
        element.textContent.includes("CT SEVERITY SCORE:")
      ) {
        element.style.height = "";
      }
    }
    return tempDiv.innerHTML;
  };

  const generateRSNAReportAPICall = async (data, props) => {

    const layerElement = document.getElementById("fluent-default-layer-host");
    if (layerElement) {
      layerElement.style.display = 'block';
    }

    let s = "";
    if (data[2] != undefined) {
      data[2].value.map((ele, ind) => {
        s += ele + ",";
      });
    }
    let body = {
      dto: {
        templateName: data[1].value,
        studyId: studyParentId,
        reportOrder: s,
        values: data[0].value,
      },
    };
    try {
      let res = await generateRSNADynamicReport(body);
      if (res.data.result == "SUCCESS") {
        let result = res.data?.data?.data?.study_report_info;
        if (
          result.length > 0 &&
          props?.content?.text == REPORT_TITLE.HRCT_CHEST_COVID_SR
        ) {
          result[0].finalReport = updatedHTMLString(result[0].finalReport);
        }

        if (res.data.data?.data?.study_report_info.length > 0) {
          let allAddedTabs = patientReports;
          let flag = false;
          allAddedTabs.map((ele, index) => {
            if (ele.reportDetails?.reportTemplateId == props.content.key) {
              flag = true;
              return;
            }
          });
          if (flag) {
            allAddedTabs = patientReports.map((ele, ind) => {
              if (ele.reportDetails?.reportTemplateId == props.content.key) {
                ele.reportDetails = result[0];
                ele.reportDetails.reportTemplateId = props.content.key;
              }
              return ele;
            });
          } else {
            let tempReport = result[0];
            tempReport.reportTemplateId = props.content.key;
            allAddedTabs.push({
              key: props.content.key,
              text: result[0].reportTemplateTitle,
              isSuperSpecialReport: result[0].isSuperSpecialReport,
              reportDetails: tempReport,
            });
          }

          setPatientReports(allAddedTabs);
          setHasUnsavedChanges(true);
          autosaveDirtyRef.current = true;
          setReportAutosaveDirty(true);
          setAutosaveScheduleVersion((v) => v + 1);
          let temp = allAddedTabs.filter((ele, ind) => {
            if (ele.text.includes(result[0].reportTemplateTitle)) {
              return ele;
            }
          });

          handleChangeTemplate(temp[0]);
          props.hideModal();
        }
      } else {
        setAlertSuccessModal(() => {
          const newItem = { ...alertSuccessModal };
          newItem.show = true;
          newItem.heading = "Error";
          newItem.description = res?.data?.message;
          return newItem;
        });
      }
    } catch (e) {
      setAlertSuccessModal(() => {
        const newItem = { ...alertSuccessModal };
        newItem.show = true;
        newItem.heading = "Error";
        newItem.description = t("string-literals.failed-message");
        return newItem;
      });
    }
  };

  const regenerateSmartReport = (result) => {
    result.map((tempVariableReport, ind) => {
      let allAddedTabs = patientReports;
      let flag = false;
      // 0 for checking it

      allAddedTabs.map((ele, index) => {
        if (ele.text.includes(tempVariableReport.reportTemplateTitle)) {
          flag = true;
          // return;
        }
      });
      // AI/auto reports carry reportTemplateId === 0 (they aren't template-backed). A 0 key is
      // falsy and silently breaks tab routing — handleChangeTemplate's `if(key)` guard, the
      // captured-images popup's active/non-active resolution, and the `if(!templateKey)` guards
      // in the captured-page handlers all treat it as "no key". Fall back to a stable, unique,
      // truthy key derived from the title (the same identity the dedup below matches on). The
      // tab key is a client-side identity only; the real reportTemplateId still lives in
      // reportDetails, so report submission is unaffected.
      const resolvedReportKey =
        tempVariableReport.reportTemplateId ||
        `auto::${tempVariableReport.reportTemplateTitle}`;
      let regeneratedReport = null;
      if (flag) {
        allAddedTabs = patientReports.map((ele, ind) => {
          if (ele.text.includes(tempVariableReport.reportTemplateTitle)) {
            if (
              tempVariableReport.finalReport != null &&
              tempVariableReport.finalReport != undefined
            ) {
              let updatedFontSizeReport = convertFontSize(
                tempVariableReport?.finalReport
              );
              tempVariableReport.finalReport = updatedFontSizeReport;
            }
            ele.reportDetails = tempVariableReport;
            ele.reportDetails.reportTemplateId =
              tempVariableReport.reportTemplateId;
            ele.text = tempVariableReport.reportTemplateTitle;
            // Repair a falsy (0/undefined) key carried over from an earlier generate so the
            // captured-images popup and tab switching route to this report correctly.
            if (!ele.key) ele.key = resolvedReportKey;
            regeneratedReport = ele;
          }
          return ele;
        });
      } else {
        if (
          tempVariableReport.finalReport != null &&
          tempVariableReport.finalReport != undefined
        ) {
          let updatedFontSizeReport = convertFontSize(
            tempVariableReport.finalReport
          );
          tempVariableReport.finalReport = updatedFontSizeReport;
        }

        allAddedTabs.push({
          key: resolvedReportKey,
          text: tempVariableReport.reportTemplateTitle,
          isSuperSpecialReport: tempVariableReport.isSuperSpecialReport,
          reportDetails: tempVariableReport,
        });
        if (tempVariableReport.reportTemplateTitle.includes("Auto")) {
          regeneratedReport = {
            key: resolvedReportKey,
            text: tempVariableReport.reportTemplateTitle,
            isSuperSpecialReport: tempVariableReport.isSuperSpecialReport,
            reportDetails: tempVariableReport,
          };
        }
      }
      let autoGeneneratedReport = allAddedTabs.filter((ele, ind) => {
        if (ele.text.includes("Auto Generated Report")) {
          return ele;
        }
      });
      if (regeneratedReport != null) {
        autoGeneneratedReport.push(regeneratedReport);
      }

      let autoGeneratedExist = false;
      let autoChestExist = false;
      allAddedTabs.map((ele, index) => {
        if (ele.text.includes("Auto Generated")) {
          autoGeneratedExist = true;
        }
      });

      allAddedTabs.map((ele, index) => {
        if (ele.text.includes("Auto Chest")) {
          autoChestExist = true;
        }
      });

      let updatedAllAddedTabs = [];
      if (autoChestExist && autoGeneratedExist) {
        updatedAllAddedTabs = allAddedTabs.filter(
          (ele) => !ele.text.includes("Auto Generated")
        );
      } else {
        updatedAllAddedTabs = allAddedTabs;
      }

      setPatientReports(updatedAllAddedTabs);

      if (updatedAllAddedTabs.length > 0) {
        let lastlyAddedReport =
          updatedAllAddedTabs[updatedAllAddedTabs.length - 1];
        handleChangeTemplate(lastlyAddedReport);
      }
    });
  };

  const generateMRISpineReport = async (data, props) => {
    let body = {
      dto: {
        templateName: data[1].value,
        studyId: studyParentId,
        reportOrder: null,
        values: data[0]?.value,
      },
    };
    try {
      // setLoaderMessage("Generating Report...");
      setLoaderRunning(true);
      ref.current.continuousStart();
      let res = await generateMRISpineReportCall(body);
      if (res.data.result == "SUCCESS") {
        setLoaderRunning(false);
        ref.current.complete();
        let result = res.data?.data?.data?.study_report_info;

        if (res.data.data?.data?.study_report_info.length > 0) {
          let allAddedTabs = patientReports;
          let flag = false;
          allAddedTabs.map((ele, index) => {
            if (ele.reportDetails?.reportTemplateId == props.content.key) {
              flag = true;
              return;
            }
          });
          if (flag) {
            allAddedTabs = patientReports.map((ele, ind) => {
              if (ele.reportDetails?.reportTemplateId == props.content.key) {
                ele.reportDetails = result[0];
                ele.reportDetails.reportTemplateId = props.content.key;
              }
              return ele;
            });
          } else {
            let tempReport = result[0];
            tempReport.reportTemplateId = props.content.key;
            allAddedTabs.push({
              key: props.content.key,
              text: result[0].reportTemplateTitle,
              isSuperSpecialReport: result[0].isSuperSpecialReport,
              reportDetails: tempReport,
            });
          }

          setPatientReports(allAddedTabs);
          setHasUnsavedChanges(true);
          let temp = allAddedTabs.filter((ele, ind) => {
            if (ele.text.includes(result[0].reportTemplateTitle)) {
              return ele;
            }
          });

          handleChangeTemplate(temp[0]);
          props.hideModal();
        }
      }
    } catch (e) {
      setLoaderRunning(false);
      ref.current.complete();
      showToastv2(
        TOAST_TYPE.ERROR,
        t("string-literals.error-msg") + " Error Log: " + e.message
      );
    }

    setReportModalState(() => {
      const newVal = { ...reportModalState };
      newVal.mriSpine = false;
      newVal.content = {};
      return newVal;
    });
  };

  const generateCTBrainReport = async (data, props) => {
    let body = {
      dto: {
        templateName: null,
        studyId: studyParentId,
        reportOrder: null,
        values: data[0]?.value,
      },
    };
    let res = await generateCTBrainReportCall(body);
    if (res.data.result == "SUCCESS") {
      let result = res.data?.data?.data?.study_report_info;

      if (res.data.data?.data?.study_report_info.length > 0) {
        let allAddedTabs = patientReports;
        let flag = false;
        allAddedTabs.map((ele, index) => {
          if (ele.reportDetails?.reportTemplateId == props.content.key) {
            flag = true;
            return;
          }
        });
        if (flag) {
          allAddedTabs = patientReports.map((ele, ind) => {
            if (ele.reportDetails?.reportTemplateId == props.content.key) {
              ele.reportDetails = result[0];
              ele.reportDetails.reportTemplateId = props.content.key;
            }
            return ele;
          });
        } else {
          let tempReport = result[0];
          tempReport.reportTemplateId = props.content.key;
          allAddedTabs.push({
            key: props.content.key,
            text: "CT BRAIN SR",
            isSuperSpecialReport: result[0].isSuperSpecialReport,
            reportDetails: tempReport,
          });
        }
        setPatientReports(allAddedTabs);
        let temp = allAddedTabs.filter((ele, ind) => {
          if (ele.reportDetails?.reportTemplateId == props.content.key) {
            return ele;
          }
        });
        setHasUnsavedChanges(true);
        handleChangeTemplate(temp[0]);
        props.hideModal();
      }
    } else {
      //alert("Error while in creating smart report");
    }
  };

  const hideCommnunicationModal = () => {
    setShowCommunicationModal(false);
  };

  const handleMarkAsSuspect = async () => {
    setLoaderRunning(true);
    try {
      // setLoaderMessage("Marking study as suspect...");
      ref.current.continuousStart();
      let response = await markAsSuspect(studyId, firmId);
      if (response.status === 200 && response.data.result == "SUCCESS") {
        setLoaderRunning(false);
        ref.current.complete();
        showToastv2(TOAST_TYPE.SUSPECT, t("mark-as-suspect.success"));
        setShowSuspectIcon(true);
        setTimeout(() => {
          setShowSuspectIcon(false);
          window.close();
        }, 1000);
      } else if (response.data.result == "FAILURE") {
        setLoaderRunning(false);
        ref.current.complete();
        showToastv2(TOAST_TYPE.ERROR, response.data.message);
      } else {
        setLoaderRunning(false);
        ref.current.complete();
        showToastv2(TOAST_TYPE.ERROR, t("mark-as-suspect.error"));
      }
    } catch (e) {
      showToastv2(
        TOAST_TYPE.ERROR,
        t("string-literals.error-msg") + " Error Log: " + e.message + e.message
      );
    }
  };

  const handleDownloadDoc = async (studyId) => {
    try {
      let response = await getWordSession(
        studyId
      );
      if (response.status == 200) {
        if (response.data.result == "SUCCESS") {
          if (isExternal) {
            setIsExternal(false);
            setOpenReportModal(false);
            setIsClientReportExistExternalModal(null);
          }
          var wordDocUrl = DICOM_ACCEPTOR_BASE_URL + APIs.OPENWORD + studyId + ".docx" + '?session_id=' + response.data.data + '&user_id=' + userId + '&study_id=' + studyId;

          var wordInstance = document.createElement("a");
          wordInstance.id = "lnkMsWord";
          var link = document.createTextNode("word link");
          wordInstance.appendChild(link);
          wordInstance.title = "ms-word";
          wordInstance.href = "ms-word:ofe|u|" + wordDocUrl;
          wordInstance.click();
        } else {
          showToastv2(TOAST_TYPE.ERROR, response.data.message);
        }
      } else {
        showToastv2(TOAST_TYPE.ERROR, t("string-literals.word-exception"));
      }
    } catch (e) {
      showToastv2(
        TOAST_TYPE.ERROR,
        t("string-literals.error-msg") + " Error Log: " + e.message + e.message
      );
    }

  }

  const getSafeRedirectUrl = (url) => {
  try {
    const parsed = new URL(url, window.location.origin);

    // allow only same-origin
    if (parsed.origin === window.location.origin) {
      return parsed.pathname + parsed.search + parsed.hash;
    }
  } catch (e) {}

  return "/";
};
  return (
    <StudyReportContext.Provider
      value={{
        model,
        setModel,
        studyId,
        modality,
        patientReports,
        setPatientReports,
        //showToast,
        //setShowToast,
        selectedCategoryTemplate,
        setSelectedCategoryTemplate,
        dropdownSelectedTemplatesStore,
        setDropdownSelectedTemplatesStore,
        allReportTemplates,
        setAllReportTemplates,
        dropdownSelectedTemplates,
        setDropdownSelectedTemplates,
        reset,
        setReset,
        userActionLoading,
        setUserActionLoading,
        hideDialog,
        setToggleHideDialog,
        isDraggable,
        showAlert,
        setShowAlert,

        annotationsJson,
        setAnnotationsJson,
        studyOptionJson,
        setStudyOptionJson,

        disableDownload,
        disablePreview,
        disableSave,
        setDisableSave,
        disableSubmit,
        setDisableSubmit,
        disablePositiveNegative,
        setDisablePositiveNegative,
        disableRaiseAlert,

        suggestedListReport,
        firstReportAdded,
        setFirstReportAdded,
        setSuggestedListReport,
        lockStudy,

        handleDropdown,
        handleModelChange,
        handleRemoveTemplate,
        handleChangeTemplate,
        handleActiveTab,
        refreshReport,
        downloadReport,
        handlePreviewReport,
        handlePreviewReportWithKeyImage,
        handlePreviewReportVersion,
        handleSaveDraft,
        handleSaveReport,
        handleMarkAsPreliminary: handleSaveReport,
        handleReleasePreliminary,
        handleSubmitReport,
        handleRaiseAlertDropdown,
        handleAnnotationJsonData,
        handleDropdownWithContext,
        currentActiveTab,
        setCurrentActiveTab,
        setOpenRSNAModal,
        setRSNAModalContent,
        regenerateClick,
        generateRSNAReportAPICall,
        setEnableReportRegenerate,
        setReportModalState,
        regenerateHRCT,

        generateCTBrainReport,
        generateMRISpineReport,

        showLockButton,
        reportSavedSuccess,

        enableReportRegenerate,
        RSNAModalContent,
        openRSNAModal,
        reportModalState,

        raiseAlertList,
        raiseAlertValue,
        setRaiseAlertValue,
        showLockWarning,
        disablePenEye,
        setDisablePenEye,
        disableQCPass,
        disableQCReturn,
        handleQcPass,
        handleQcReturn,
        setOpenQcModal,
        openQcModal,
        qcProviderList,
        handleQcReturnButtonClick,
        openQcReasonModal,
        setOpenQcReasonModal,
        disableQCReason,
        setDisableQcReason,
        handleQCReasonClick,
        disableSubmitUntilQCReasonClick,
        qcFailReason,
        reportAnnotationState,
        setReportAnnotationState,
        regenerateSmartReport,
        userRole,
        alreadyLocked,
        showReturnedStudyReasonModal,
        setShowReturnedStudyReasonModal,
        checkIfCancelOrNot,
        activeTab,
        setActiveTab,
        disableAddendumTab,
        addendumModel,
        setAddendumModel,
        showReturnStudyModal,
        setShowReturnStudyModal,
        unlockStudy,
        releaseStudy,
        reportDoneStatusState,
        showCommunicationModal,
        setShowCommunicationModal,
        hideCommnunicationModal,

        alertSuccessModal,
        setAlertSuccessModal,
        confirmAlertModal,
        setConfirmAlertModal,
        hideAlertSuccessModal,
        handleUpdateStudyId,
        setStudyParentId,
        openReportModal,
        setOpenReportModal,
        modalityReport,
        setModalityReport,
        isClientReportExist,
        setIsClientReportExist,
        downloadFistolugram,
        openFistolugramUploadModal,
        setFistolugramUploadModal,
        showFistolugram,
        uploadFistolugramFunc,
        deleteFistolugramFunc,
        fistolugramFilePath,
        openFistolugramModal,
        setOpenFistolugramModal,
        openFibroidModal,
        setOpenFibroidModal,
        showFibroid,
        fibroidFilePath,
        uploadFibroidFunc,
        deleteFibroidFunc,
        studyPatientSex,
        showQCReasonBadge,
        setShowQCReasonBadge,
        conflictSave,
        setConflictSave,
        passConflict,
        setPassConflict,
        getData,
        showKeyImagesAndTextAnnotation,
        openQCPassConfirmModal,
        setOpenQCPassConfirmModal,
        isKeyImagesPresent,
        isTextAnnotationPresent,
        setIsKeyImagesPresent,
        setIsTextAnnotationPresent,
        hasUnsavedChanges,
        setHasUnsavedChanges,
        autoSaveReportPreference,
        reportAutosaveStatus,
        reportAutosaveLastSavedAt,
        reportAutosaveDirty,
        reportAutosaveOffReason,
        reportAutosaveBlocked,
        setReportAutosaveDeps,
        markReportAutosaveDirty,
        snapshotRecoveryModalOpen,
        snapshotRecoveryReopenVisible,
        snapshotDraftPatientReports,
        snapshotOfficialPatientReports,
        handleSnapshotRecoveryAccept,
        handleSnapshotRecoveryClose,
        handleSnapshotRecoveryReject,
        handleSnapshotRecoveryReopen,
        firmId,
        setFirmId,
        showAddendumDisclaimerPopup,
        setShowAddendumDisclaimerPopup,
        addendumDisclaimerAddedByRad,
        setAddendumDisclaimerAddedByRad,
        showAddendumDisclaimerModal,
        setShowAddendumDisclaimerModal,
        showConfirmModal,
        setShowConfirmModal,
        isExternal,
        setIsExternal,
        showSubmitTick,
        setShowSubmitTick,
        studyParentId,
        setAllStoreAnnotation,
        addStoreAnnotationState,
        setAddStoreAnnotationState,
        allowDownloadReport,
        studyPatientDetails,
        setStudyPatientDetails,
        externalReportingModalRef,
        externalReportingLoading,
        setExternalReportingLoading,
        handleMarkAsSuspect,
        disableMarkAsSuspect,
        showSuspectIcon,
        setShowSuspectIcon,
        hideLockWarningMessage,
        updateRowSubmitDone,
        setUpdateDoneSubmitDone,
        setIsClientReportExistExternalModal,
        isAdvanceViewer,
        setIsAdvanceViewer,
        getConsistentDateFormat,
        getConsistentDateFormatFromUTC,
        setShowKeyImagesAndTextAnnotation,
        isChildStudyReportState,
        setIsChildStudyReportState,
        handleUpdateReportSection,
        keyImagePresentStudyList,
        setKeyImagePresentStudyList,
        showMsWord,
        setShowMsWord,
        setIsWordFilePath,
        isWordFilePath,
        childModel,
        childPatientReports,
        childCurrentActiveTab,
        handleChildChangeTemplate,
        lockStudySupervisor,
        getConsistentCustomDateFormat,
        downloadAIReport,
        allowCopyPaste,
        lockedByOther,
        allReportTemplatesLoading, setAllReportTemplateLoading,
        setIsRestrictionsEnabled, isRestrictionsEnabled,
        handleDownloadDoc,
        forceReinferenceInProgress, setForReinferenceInProgress,
        showForceReinferenceModal, setShowForceReinferenceModal,
        isDSRExists,
        observationState, setObservationState,
        studyDescription, setStudyDescription,
        findingSentence, setFindingSentence,
        disableObservations,
        showFindingsErrorMessage, setShowFindingsErrorMessage,
        showTemplateList, setShowTemplateList,
        rsnaFlag, setRSNAFlag, handleSwitchCategory,
        fetchS10Report,
        s10User,
        s10Url,
        confirmMultipleTemplateOpen, confirmMultipleTemplateModalContent,
        editorRef,
        activeField,
        setActiveField,
        formatterAgentEnabled, formattedReportUsed,
        showFormatterPopup, setShowFormatterPopup, setPendingSubmission, setFormattedReportAction, setPendingQCPass,
        showPreliminaryActionPopup,
        templateHeight, setTemplateHeight, reportingDoctorName,
        reportTitle, setReportTitle,
        llmReportTitle,
        maskImages, setMaskImages,
        studyClinicalNotesData, setStudyClinicalNotesData,
        setStudyId, setIsWidget, isWidget,
        clientFirmList,
        selectedClient, setSelectedClient,
        defaultAgenticTemplate,
        isNormalStudy, setIsNormalStudy, useOldReportTemplate,
        downloadedStudyIds,
        setDownloadedStudyIds,
        agenticInterfaceRef,
        activeTabKey, setActiveTabKey, reportSavedBy,
        setDisableObservations,
        llmSessionId,
        studyReportPdf, studyReportPdfSelected, setStudyReportPdfSelected, studyReportPdfUrl, handleAttachToggle, disableEditReport, setDisableEditReport,
        hasAgenticReport,
        addImageReferenceToTemplate,
        addAllImagesToTemplate,
        removeCapturedImageFromReport,
        capturedPages,
        capturedPagesMapRef,
        hasNewCapturedImage,
        setHasNewCapturedImage,
        newCapturedImageCount,
        setNewCapturedImageCount,
        showCapturedImagesModal,
        setShowCapturedImagesModal,
        pendingCaptureSops,
        markPendingCapture,
        resolvePendingCapture,
        selectedCapturedPageId, setSelectedCapturedPageId,
        reorderImageInCapturedPage,
        moveImageBetweenPages,
        addCapturedPage,
        removeCapturedPage,
        setCapturedPageColumns,
        addCapturedPageForTemplate,
        removeCapturedPageForTemplate,
        setCapturedPageColumnsForTemplate,
        removeCapturedImageForTemplate,
        bulkLoadCapturedPagesFromLibrary,
        moveCapturedPage,
        scDicomLibrary,
        scDicomLibraryLoading,
        refreshScDicomLibrary,
        refreshCapturedPagesFromServer,
        showKeyImageTitle,
        setShowKeyImageTitle,
        appendCapturedImagesAtEnd,
        setAppendCapturedImagesAtEnd,
        persistCapturedPages,
        setLibraryItemTitle,
        setLibraryItemTitleLocal,
        removeLibraryItem,
        getLibraryItemUsage,
        moveCapturedImageAcrossTemplates,
        autosaveScheduleVersion,
        isexternalStudyReport,
        autoPopulateManualPathology,
        showPathologySentences
      }}
    >
      {props.children}
      
{showUnparsableDialog && (
  <ConfirmModal
    showConfirmModal={showUnparsableDialog}
    title="Unsupported Characters Removed / Replaced"
    handleCloseIcon={() => setShowUnparsableDialog(false)}
    handleConfirm={() => setShowUnparsableDialog(false)}
    confirmButtonText="OK"
    message={unparsableDialogMessage}
  />
)}
    </StudyReportContext.Provider>
  );
};

export default StudyReportState;
